import * as n from "react";
import { Component as rr, useState as M, useRef as j, useEffect as Z, useLayoutEffect as Be, isValidElement as ln, cloneElement as ra, forwardRef as Kr, useContext as Dn, createContext as An, useMemo as we, useCallback as le, Fragment as Ur, Children as Un, createRef as Yr } from "react";
import { createPortal as Gr } from "react-dom";
const Vr = "_page_qrul2_5", Qr = "_inner_qrul2_18", Jr = "_pageScroll_qrul2_31", Zr = "_innerScroll_qrul2_32", fn = {
  page: Vr,
  inner: Qr,
  pageScroll: Jr,
  innerScroll: Zr
};
function Bg({
  gnbHeight: e = 64,
  minWidth: t = 1024,
  scroll: a = "grid",
  className: r = "",
  style: s,
  children: o
}) {
  const l = a === "page";
  return /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [fn.page, l && fn.pageScroll, "axe-page", r].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...s }
    },
    /* @__PURE__ */ n.createElement("div", { className: [fn.inner, l && fn.innerScroll].filter(Boolean).join(" "), style: { minWidth: t } }, o)
  );
}
const es = "_body_1wgsn_4", ts = {
  body: es
};
function Lg({ className: e = "", style: t, children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [ts.body, "axe-page-body", e].filter(Boolean).join(" "), style: t }, a);
}
const ns = "_orbitPortalRoot_177qv_2", as = {
  orbitPortalRoot: ns
};
class Yt extends rr {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || as.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return Gr(this.props.children, this.getPortalRoot());
  }
}
const rs = "_anchor_7h2m7_2", ss = "_tip_7h2m7_5", ya = {
  anchor: rs,
  tip: ss
};
let os = 0;
function Lt({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: s,
  describe: o = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, m] = M(!1), [u, f] = M({ top: 0, left: 0 }), p = j(null), _ = j(null), y = j(null), d = j("");
  d.current || (d.current = `axe-tip-${++os}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, N = (g) => {
    b(), g <= 0 ? m(!0) : y.current = setTimeout(() => m(!0), g);
  }, w = () => {
    b(), m(!1);
  };
  Z(() => b, []), Be(() => {
    if (!i) return;
    const g = () => {
      const h = p.current, E = _.current;
      if (!h || !E) return;
      const $ = h.getBoundingClientRect(), D = E.offsetHeight, S = E.offsetWidth;
      let T = a === "top" ? $.top - D - 6 : $.bottom + 6;
      a === "bottom" && T + D > window.innerHeight - 4 && $.top - D - 6 > 4 && (T = $.top - D - 6), a === "top" && T < 4 && $.bottom + 6 + D < window.innerHeight - 4 && (T = $.bottom + 6);
      const I = Math.max(4, Math.min($.left + $.width / 2 - S / 2, window.innerWidth - S - 4));
      f((q) => q.top === T && q.left === I ? q : { top: T, left: I });
    };
    return g(), window.addEventListener("resize", g), window.addEventListener("scroll", g, !0), () => {
      window.removeEventListener("resize", g), window.removeEventListener("scroll", g, !0);
    };
  }, [i, a, e]), Z(() => {
    if (!i) return;
    const g = (h) => {
      h.key !== "Escape" || h.isComposing || (h.preventDefault(), h.stopPropagation(), w());
    };
    return document.addEventListener("keydown", g, !0), () => document.removeEventListener("keydown", g, !0);
  }, [i]);
  const k = e != null && e !== !1 && e !== "";
  if (!k && !c) return t;
  const x = k && ln(t) ? ra(t, i && o ? { "aria-describedby": d.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: p,
      className: [ya.anchor, l].filter(Boolean).join(" "),
      tabIndex: s ? 0 : void 0,
      onMouseEnter: () => {
        k && N(r);
      },
      onMouseLeave: w,
      onFocus: () => {
        k && N(0);
      },
      onBlur: w
    },
    x,
    k && i && /* @__PURE__ */ n.createElement(Yt, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: _,
        id: d.current,
        role: "tooltip",
        className: ya.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: b,
        onMouseLeave: w
      },
      e
    ))
  );
}
const ls = "_bar_gkpv7_1", cs = "_menu_gkpv7_17", is = "_title_gkpv7_27", us = "_info_gkpv7_29", ms = "_badge_gkpv7_37", ds = "_badge_muted_gkpv7_38", fs = "_badge_ok_gkpv7_39", _s = "_badge_warn_gkpv7_40", ps = "_meta_gkpv7_42", ys = "_actions_gkpv7_26", bs = "_notice_gkpv7_59", hs = "_notice_info_gkpv7_65", Es = "_notice_ok_gkpv7_66", gs = "_notice_err_gkpv7_67", Ye = {
  bar: ls,
  menu: cs,
  title: is,
  info: us,
  badge: ms,
  badge_muted: ds,
  badge_ok: fs,
  badge_warn: _s,
  meta: ps,
  actions: ys,
  notice: bs,
  notice_info: hs,
  notice_ok: Es,
  notice_err: gs
};
function jg({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: s,
  notice: o,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ye.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ye.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ye.title }, e), a && /* @__PURE__ */ n.createElement(Lt, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ye.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("span", { key: m, className: [Ye.badge, Ye[`badge_${(u = i.tone) != null ? u : "muted"}`]].join(" ") }, i.label);
  }), s && /* @__PURE__ */ n.createElement("span", { className: Ye.meta }, s), /* @__PURE__ */ n.createElement("span", { className: Ye.actions }, o && o.text && /* @__PURE__ */ n.createElement("span", { className: [Ye.notice, Ye[`notice_${(c = o.tone) != null ? c : "info"}`]].join(" "), role: o.tone === "err" ? "alert" : "status" }, o.text), l));
}
const vs = "_btn_a0orf_1", ks = "_sm_a0orf_18", ws = "_primary_a0orf_21", Ns = "_dark_a0orf_23", $s = "_danger_a0orf_25", xs = "_soon_a0orf_29", Ds = "_soonTag_a0orf_30", As = "_blocked_a0orf_39", Cs = "_kbd_a0orf_51", Ss = "_iconBtn_a0orf_54", Ms = "_link_a0orf_70", it = {
  btn: vs,
  sm: ks,
  primary: ws,
  dark: Ns,
  danger: $s,
  soon: xs,
  soonTag: Ds,
  blocked: As,
  kbd: Cs,
  iconBtn: Ss,
  link: Ms
}, Wt = Kr(function(t, a) {
  const {
    variant: r = "default",
    size: s = "md",
    kbd: o,
    soon: l,
    blockedReason: c,
    children: i,
    className: m = "",
    type: u = "button",
    onClick: f,
    title: p,
    disabled: _,
    ...y
  } = t, d = l || c || "", b = d !== "", N = "blockedReason" in t, w = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: u,
      className: [it.btn, it[r], s === "sm" ? it.sm : "", l ? it.soon : b ? it.blocked : "", m].filter(Boolean).join(" "),
      "aria-disabled": b ? !0 : void 0,
      disabled: b ? void 0 : _,
      title: b ? void 0 : p,
      onClick: b ? (k) => k.preventDefault() : f,
      ...y
    },
    i,
    o && /* @__PURE__ */ n.createElement("kbd", { className: it.kbd }, o),
    l && /* @__PURE__ */ n.createElement("em", { className: it.soonTag }, "준비 중")
  );
  return b || N ? /* @__PURE__ */ n.createElement(Lt, { content: d, keepWrapper: N }, w) : w;
});
function Yn({ label: e, children: t, className: a = "", type: r = "button", ...s }) {
  return /* @__PURE__ */ n.createElement(Lt, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [it.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...s
    },
    t
  ));
}
function sa({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [it.link, t].filter(Boolean).join(" "), ...r }, e);
}
const Ts = "_wrap_10shm_1", qs = "_btn_10shm_2", Bs = "_on_10shm_6", Ls = "_caret_10shm_8", js = "_pop_10shm_9", Rs = "_sec_10shm_14", Is = "_item_10shm_17", Os = "_danger_10shm_24", ft = {
  wrap: Ts,
  btn: qs,
  on: Bs,
  caret: Ls,
  pop: js,
  sec: Rs,
  item: Is,
  danger: Os
}, Ps = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), Rg = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function Xs({ label: e, entries: t, disabled: a, title: r }) {
  const [s, o] = M(!1), l = j(null), c = j(null), i = j(null), m = () => {
    var f, p;
    return Array.from((p = (f = i.current) == null ? void 0 : f.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? p : []);
  };
  Z(() => {
    var f;
    s && ((f = m()[0]) == null || f.focus());
  }, [s]), Z(() => {
    if (!s) return;
    const f = (_) => {
      l.current && !l.current.contains(_.target) && o(!1);
    }, p = (_) => {
      var y;
      _.key !== "Escape" || _.isComposing || (_.preventDefault(), _.stopPropagation(), o(!1), (y = c.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", p, !0), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", p, !0);
    };
  }, [s]);
  const u = (f) => {
    const p = m();
    if (p.length === 0) return;
    const _ = p.indexOf(document.activeElement);
    let y = -1;
    if (f.key === "ArrowDown") y = (_ + 1) % p.length;
    else if (f.key === "ArrowUp") y = (_ <= 0 ? p.length : _) - 1;
    else if (f.key === "Home") y = 0;
    else if (f.key === "End") y = p.length - 1;
    else if (f.key === "Tab") {
      o(!1);
      return;
    } else return;
    f.preventDefault(), p[y].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: ft.wrap, ref: l }, /* @__PURE__ */ n.createElement(Lt, { content: s ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [ft.btn, s ? ft.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": s,
      onClick: () => o((f) => !f),
      onKeyDown: (f) => {
        f.key === "ArrowDown" && !s && (f.preventDefault(), o(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: ft.caret, "aria-hidden": "true" }, "▾")
  )), s && /* @__PURE__ */ n.createElement("div", { ref: i, className: ft.pop, role: "menu", onKeyDown: u }, t.map((f) => f.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: f.key, className: ft.sec }, f.label, f.note && /* @__PURE__ */ n.createElement("small", null, f.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: f.key,
      type: "button",
      role: "menuitem",
      disabled: f.disabled,
      className: [ft.item, f.danger ? ft.danger : ""].join(" "),
      onClick: () => {
        var p;
        o(!1), (p = c.current) == null || p.focus(), f.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, f.label),
    f.disabled && f.reason && /* @__PURE__ */ n.createElement("small", null, f.reason)
  ))));
}
function Ig(e, t, a = !0) {
  const r = j(t);
  r.current = t, Z(() => {
    if (!a) return;
    const s = (o) => {
      if (o.key !== "Enter" || !(o.ctrlKey || o.metaKey) || o.isComposing || o.repeat || o.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (o.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [e, a]);
}
function zs() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Fs = "_bar_1g564_2", Ws = "_sticky_1g564_12", Hs = "_start_1g564_19", Ks = "_end_1g564_20", Us = "_status_1g564_22", Ys = "_dirty_1g564_23", Gs = "_kbd_1g564_25", wt = {
  bar: Fs,
  sticky: Ws,
  start: Hs,
  end: Ks,
  status: Us,
  dirty: Ys,
  kbd: Gs
};
function Og({ start: e, children: t, status: a, dirty: r, inline: s, shortcutHint: o, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", wt.bar, s ? "" : wt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: wt.start }, e), /* @__PURE__ */ n.createElement("span", { className: wt.end }, a && /* @__PURE__ */ n.createElement("span", { className: [wt.status, r ? wt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, o && /* @__PURE__ */ n.createElement("kbd", { className: wt.kbd }, zs())));
}
const Vs = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Qs = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Js({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Qs[e]);
}
function gn({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Vs[e]
  );
}
const Zs = "_root_j67qt_2", eo = "_closed_j67qt_3", to = "_tab_j67qt_6", no = "_collapse_j67qt_7", ao = "_body_j67qt_16", ro = "_card_j67qt_32", so = "_head_j67qt_37", oo = "_cardOpen_j67qt_44", lo = "_headBtn_j67qt_47", co = "_icon_j67qt_56", io = "_badge_j67qt_57", uo = "_trailing_j67qt_58", mo = "_chev_j67qt_59", fo = "_panelWrap_j67qt_63", _o = "_panelOpen_j67qt_67", po = "_panelBody_j67qt_68", yo = "_panelInner_j67qt_69", bo = "_panelSettled_j67qt_70", ve = {
  root: Zs,
  closed: eo,
  tab: to,
  collapse: no,
  body: ao,
  card: ro,
  head: so,
  cardOpen: oo,
  headBtn: lo,
  icon: co,
  badge: io,
  trailing: uo,
  chev: mo,
  panelWrap: fo,
  panelOpen: _o,
  panelBody: po,
  panelInner: yo,
  panelSettled: bo
}, ho = 1280, Eo = 8, sr = "axe-side-bar:";
function go(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(sr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function vo(e, t) {
  if (e)
    try {
      window.localStorage.setItem(sr + e, t ? "1" : "0");
    } catch {
    }
}
function Pg({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = ho,
  storageKey: s,
  className: o = "",
  children: l
}) {
  var p;
  const c = j(go(s)), [i, m] = M((p = c.current) != null ? p : t), u = j(c.current !== null);
  if (Z(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const _ = window.matchMedia(`(max-width: ${r - 1}px)`), y = () => {
      u.current || m(!_.matches && t);
    };
    return y(), _.addEventListener ? _.addEventListener("change", y) : _.addListener(y), () => {
      _.removeEventListener ? _.removeEventListener("change", y) : _.removeListener(y);
    };
  }, [e, r, t]), !e) return null;
  const f = () => {
    u.current = !0, vo(s, !i), m(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ve.root, i ? "" : ve.closed, o].filter(Boolean).join(" "),
      style: { width: i ? a : Eo }
    },
    /* @__PURE__ */ n.createElement("div", { className: ve.tab }, /* @__PURE__ */ n.createElement(Lt, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ve.collapse,
        onClick: f,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Js, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ve.body }, l)
  );
}
const or = An(null);
function Xg({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, s] = M(t);
  return a ? /* @__PURE__ */ n.createElement(or.Provider, { value: { openId: r, setOpenId: s } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const lr = "axe-side-panel:";
function ko(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(lr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function wo(e, t) {
  if (e)
    try {
      window.localStorage.setItem(lr + e, t ? "1" : "0");
    } catch {
    }
}
function zg({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: s,
  trailing: o,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: m
}) {
  var g;
  const u = Dn(or), f = !!u && c != null, p = j(ko(l)), [_, y] = M((g = p.current) != null ? g : a), d = f ? u.openId === c : _, [b, N] = M(d), [w, k] = M(d);
  if (!t) return null;
  d && !b && N(!0);
  const x = () => {
    const h = !d;
    wo(l, h), N(!0), k(!1), f ? u.setOpenId(h ? c : null) : y(h);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ve.card, d ? ve.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ve.head, onClick: x }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ve.headBtn, "aria-expanded": d }, r && /* @__PURE__ */ n.createElement("span", { className: ve.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), s && /* @__PURE__ */ n.createElement("span", { className: ve.badge }, s), o && /* @__PURE__ */ n.createElement("span", { className: ve.trailing, onClick: (h) => h.stopPropagation() }, o), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ve.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ve.panelWrap, d ? ve.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (h) => {
        h.target === h.currentTarget && h.propertyName === "grid-template-rows" && k(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ve.panelBody, d && w ? ve.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ve.panelInner }, m))
  ));
}
const No = "_guide_qnh7l_1", $o = "_title_qnh7l_5", xo = "_desc_qnh7l_6", Do = "_act_qnh7l_7", Ao = "_why_qnh7l_13", Co = "_steps_qnh7l_14", So = "_no_qnh7l_20", Mo = "_cur_qnh7l_24", To = "_link_qnh7l_26", at = {
  guide: No,
  title: $o,
  desc: xo,
  act: Do,
  why: Ao,
  steps: Co,
  no: So,
  cur: Mo,
  link: To
};
function Fg({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: at.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: at.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: at.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: at.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: at.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: at.steps }, r.map((s, o) => /* @__PURE__ */ n.createElement("li", { key: s.label, className: s.current ? at.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: at.no }, o + 1), s.onClick && !s.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: at.link, onClick: s.onClick }, s.label) : /* @__PURE__ */ n.createElement("span", null, s.label), s.hint && /* @__PURE__ */ n.createElement("small", null, s.hint)))));
}
const qo = "_list_1w2rs_1", Bo = "_row_1w2rs_2", Lo = "_label_1w2rs_6", jo = "_value_1w2rs_7", Ro = "_emphasis_1w2rs_8", Io = "_changed_1w2rs_10", Rt = {
  list: qo,
  row: Bo,
  label: Lo,
  value: jo,
  emphasis: Ro,
  changed: Io
};
function Wg({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [Rt.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [Rt.row, a.emphasis ? Rt.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: Rt.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [Rt.value, a.changed ? Rt.changed : ""].join(" ") }, a.value))));
}
const Oo = "_underline_xl221_2", Po = "_active_xl221_24", Xo = "_segmented_xl221_33", jn = {
  underline: Oo,
  active: Po,
  segmented: Xo
};
function cr({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: s = "",
  "aria-label": o
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? jn.segmented : jn.underline, s].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": o
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? jn.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const zo = "_bar_1e999_1", Fo = "_actions_1e999_17", Wo = "_field_1e999_24", Ho = "_fieldLabel_1e999_25", Ko = "_readout_1e999_33", Uo = "_search_1e999_44", Yo = "_detail_1e999_58", Go = "_pill_1e999_70", Vo = "_hint_1e999_81", ut = {
  bar: zo,
  actions: Fo,
  field: Wo,
  fieldLabel: Ho,
  readout: Ko,
  search: Uo,
  detail: Yo,
  pill: Go,
  hint: Vo
}, Qo = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function Jo(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !Qo.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function Hg({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: s,
  detailSearch: o = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  trailing: i,
  enterSearch: m = !0
}) {
  const u = (f) => {
    !m || !t || r || !Jo(f) || (f.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: ut.bar, onKeyDown: u }, e, /* @__PURE__ */ n.createElement("span", { className: ut.actions }, i, o && /* @__PURE__ */ n.createElement("button", { type: "button", className: ut.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(Lt, { content: s, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ut.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function Zo({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: ut.field }, /* @__PURE__ */ n.createElement("span", { className: ut.fieldLabel }, e), t);
}
function Kg({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: ut.readout }, e);
}
function Ug({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: ut.pill, role: "status" }, e);
}
function Yg({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: ut.hint }, e);
}
function el(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function Gg({ rows: e, value: t, onChange: a, disabled: r, label: s = "기수" }) {
  return /* @__PURE__ */ n.createElement(Zo, { label: s }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": s,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (o) => a(Number(o.target.value))
    },
    e.map((o) => /* @__PURE__ */ n.createElement("option", { key: o.gisu, value: o.gisu }, el(o)))
  ));
}
class ir {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const s of r) {
            const o = s.borderBoxSize[0];
            this._callback({ width: o.inlineSize, height: o.blockSize }, s);
          }
        } catch (s) {
          console.error(s);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function ur(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function mr(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function dr(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function tl(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function fr(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function nl(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => fr(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let s = [], o = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(s), s = [], o = [], a.push(c);
      return;
    }
    for (; o.length && o[o.length - 1].level >= l.level; ) o.pop();
    const i = { i: c, kids: [] };
    (o.length ? o[o.length - 1].node.kids : s).push(i), o.push({ level: l.level, node: i });
  }), r(s), a;
}
function al(e, t) {
  const a = new Set(t), r = e.filter((o) => a.has(o)), s = new Set(r);
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    if (s.has(l)) continue;
    const c = o + 1 < t.length ? r.indexOf(t[o + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), s.add(l);
  }
  return r;
}
function rl(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), s = [], o = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let m = 0, u = s.length;
    for (; m < u; ) {
      const f = m + u >> 1;
      r[s[f]] < c ? m = f + 1 : u = f;
    }
    m > 0 && (o[i] = s[m - 1]), s[m] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = s.length ? s[s.length - 1] : -1; c >= 0; c = o[c]) l.add(e[c]);
  return l;
}
const sl = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', ol = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function ll(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((o, l) => {
      o <= 1 ? a.delete(l) : a.set(l, o - 1);
    });
    let s = 0;
    for (const o of Array.from(r.cells)) {
      for (; a.has(s); ) s += 1;
      const l = o.colSpan || 1;
      if (t.set(o, s), o.rowSpan > 1) for (let c = s; c < s + l; c += 1) a.set(c, o.rowSpan);
      s += l;
    }
  }
  return t;
}
function cl(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = ll(Array.from(t.rows)), r = [];
  return a.forEach((s, o) => {
    var c, i;
    if (o.tagName !== "TH" || (o.colSpan || 1) !== 1 || o.dataset.sortable === "false" || o.hasAttribute("aria-sort") && o.dataset.axeSort === void 0 || o.querySelector(sl)) return;
    const l = ((c = o.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: o, col: s, key: (i = o.dataset.sortKey) != null ? i : String(s), label: l });
  }), r;
}
function ba(e, t) {
  var r;
  let a = 0;
  for (const s of Array.from(e.cells)) {
    const o = s.colSpan || 1;
    if (t < a + o) {
      const l = s.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = s.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return tl(c ? c.value : (r = s.textContent) != null ? r : "");
    }
    a += o;
  }
  return null;
}
function il(e) {
  if (e.matches(ol) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function ul() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function ml(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((s) => Array.from(s.cells).some((o) => o.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const _r = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function dl(e, t, a) {
  if (_r(t, a)) return;
  const r = rl(t, a);
  let s = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let o = t.length - 1; o >= 0; o -= 1) {
    const l = t[o];
    r.has(l) || e.insertBefore(l, s), s = l;
  }
}
function fl(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? ba(c.rows[0], a) : null }));
    return l.sort((c, i) => fr(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const s = e, o = s.map((l) => {
    const c = il(l);
    return { level: c, value: c === null ? null : ba(l, a) };
  });
  return nl(o, r).map((l) => s[l]);
}
function _l(e, t, a) {
  const r = ml(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const s = r.items, o = t ? `${t.col}:${t.dir}` : "";
  if (o === a.sig && _r(s, a.shown)) return;
  a.base = a.sig ? al(a.base, s) : s;
  let l = t ? fl(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && o === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((u) => u.parentElement === r.parent);
    let m = 0;
    l = l.map((u) => c.has(u) ? i[m++] : u);
  }
  dl(r.parent, l, s), a.shown = l, a.sig = o;
}
const pl = "input, select, textarea, button";
function yl(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const s = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), o = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    s !== "" && !r.querySelector(pl) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: s, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || o) && (r.getAttribute("title") !== s && r.setAttribute("title", s), r.dataset.axeTitle !== s && (r.dataset.axeTitle = s))) : o && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const pr = An(null), bl = "_card_1j6er_2", hl = "_grow_1j6er_24", El = "_head_1j6er_26", gl = "_title_1j6er_35", vl = "_trailing_1j6er_36", kl = "_scroll_1j6er_6", wl = "_foot_1j6er_54", Nl = "_strip_1j6er_56", $l = "_pager_1j6er_58", xl = "_spacer_1j6er_60", Dl = "_table_1j6er_62", Al = "_fixed_1j6er_63", Cl = "_fz_1j6er_81", Sl = "_fzEdge_1j6er_93", Ml = "_frozen_1j6er_100", Tl = "_sr_1j6er_162", ql = "_statusCell_1j6er_43", Bl = "_status_1j6er_43", Ll = "_st_error_1j6er_244", jl = "_stIcon_1j6er_245", Rl = "_spin_1j6er_251", Il = "_axeSpin_1j6er_1", Ol = "_busy_1j6er_261", Pl = "_statusRow_1j6er_263", Xl = "_busyBar_1j6er_264", zl = "_axeBusy_1j6er_1", ue = {
  card: bl,
  grow: hl,
  head: El,
  title: gl,
  trailing: vl,
  scroll: kl,
  foot: wl,
  strip: Nl,
  pager: $l,
  spacer: xl,
  table: Dl,
  fixed: Al,
  fz: Cl,
  fzEdge: Sl,
  frozen: Ml,
  sr: Tl,
  statusCell: ql,
  status: Bl,
  st_error: Ll,
  stIcon: jl,
  spin: Rl,
  axeSpin: Il,
  busy: Ol,
  statusRow: Pl,
  busyBar: Xl,
  axeBusy: zl
}, Fl = 120;
function Wl(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * Fl : void 0;
}
function ha({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const Ht = /* @__PURE__ */ new Set();
function oa() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function Hl(e) {
  if (!oa() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var s;
    return (s = r.textContent) == null ? void 0 : s.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  Ht.has(a) || (Ht.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function Kl(e) {
  if (!oa()) return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var s, o;
    r.scrollWidth > r.clientWidth + 1 && t.push((o = (s = r.textContent) == null ? void 0 : s.trim()) != null ? o : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  Ht.has(a) || (Ht.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function Ul(e) {
  if (!oa() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (Ht.has(t)) return;
  Ht.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function Ea(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const s of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let o = 0;
    for (const l of Array.from(s.cells)) {
      for (; r.has(o); ) o += 1;
      const c = l.colSpan || 1, i = t > 0 && o + c <= t;
      if (l.classList.toggle(ue.fz, i), l.classList.toggle(ue.fzEdge, i && o + c === t), l.style.left = i ? `${a[o]}px` : "", l.rowSpan > 1) for (let m = o; m < o + c; m += 1) r.set(m, l.rowSpan);
      o += c;
    }
  }
}
function Vg({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: s,
  grow: o,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: m,
  "aria-label": u,
  sortable: f = !0,
  sort: p,
  onSort: _,
  manualSort: y,
  className: d = "",
  children: b
}) {
  const N = l || e !== void 0 && e.length > 0, w = N ? Wl(e) : void 0, { stick: k, offsets: x } = we(() => {
    const R = Math.max(Math.trunc(c), 0), z = [];
    if (R === 0 || !e) return { stick: 0, offsets: z };
    let G = 0, X = 0;
    for (let H = 0; H < R; H += 1) {
      const ce = e[H];
      if (typeof ce != "number") break;
      z.push(G), G += ce, X += 1;
    }
    return { stick: X, offsets: z };
  }, [e, c]), g = [ue.table, N ? ue.fixed : "", k > 0 ? ue.frozen : ""].filter(Boolean).join(" "), h = j(null), E = j(null), $ = j(null), D = j(null), S = j(0), T = j(0), I = we(() => ({
    scrollRef: h,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (T.current += 1, () => {
      T.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [q, P] = M(null), Y = p !== void 0 ? p : q, [K, L] = M(""), te = j(ul()), ne = () => {
    const R = h.current, z = $.current, G = D.current;
    if (!R || !z || !G) return;
    const X = R.scrollWidth;
    G.style.width = X + "px", z.style.display = X > R.clientWidth + 1 ? "" : "none";
    const H = R.offsetWidth - R.clientWidth;
    z.style.paddingRight = H + "px", E.current && (E.current.style.paddingRight = H + "px"), Kl(R), Ul(yl(R.querySelector("table")));
  };
  Z(() => {
    const R = h.current;
    if (!R) return;
    const z = new ir(R, ne);
    return Hl(R.querySelector("table")), () => z.detach();
  }, []), Be(() => {
    var R, z, G, X, H;
    (k > 0 || S.current > 0) && (Ea((z = (R = h.current) == null ? void 0 : R.querySelector("table")) != null ? z : null, k, x), Ea((X = (G = E.current) == null ? void 0 : G.querySelector("table")) != null ? X : null, k, x)), S.current = k, (H = h.current) == null || H.querySelectorAll("thead th:not([scope])").forEach((ce) => ce.setAttribute("scope", "col")), v(), ne();
  });
  function v() {
    var X;
    const R = (X = h.current) == null ? void 0 : X.querySelector("table");
    if (!R) return;
    const z = f ? cl(R) : [];
    R.querySelectorAll("thead th[data-axe-sort]").forEach((H) => {
      z.some((ce) => ce.th === H) || (H.removeAttribute("data-axe-sort"), H.removeAttribute("aria-sort"), H.removeAttribute("tabindex"));
    }), z.forEach(({ th: H, key: ce }) => {
      H.dataset.axeSort !== ce && (H.dataset.axeSort = ce);
      const Ue = mr(Y, ce);
      H.getAttribute("aria-sort") !== Ue && H.setAttribute("aria-sort", Ue), H.hasAttribute("tabindex") || H.setAttribute("tabindex", "0");
    });
    const G = Y && z.find((H) => H.key === Y.key);
    _l(R, Y && G && !y && T.current === 0 ? { col: G.col, dir: Y.dir } : null, te.current);
  }
  const O = (R) => {
    var H;
    const z = R.dataset.axeSort;
    if (z === void 0) return;
    const G = ur(Y, z), X = ((H = R.textContent) != null ? H : "").replace(/\s+/g, " ").trim();
    L(dr(G, () => X)), p === void 0 && P(G), _ == null || _(G);
  }, V = (R) => {
    var X, H;
    const z = R, G = (X = z.closest) == null ? void 0 : X.call(z, "thead th[data-axe-sort]");
    return !G || !((H = h.current) != null && H.contains(G)) || z !== G && z.closest('input, select, textarea, button, a[href], [role="button"]') ? null : G;
  }, Q = (R) => {
    const z = V(R.target);
    z && O(z);
  }, se = (R) => {
    if (R.key !== "Enter" && R.key !== " ") return;
    const z = V(R.target);
    !z || R.target !== z || (R.preventDefault(), O(z));
  }, B = (R) => {
    const z = R.target.scrollLeft;
    h.current && (h.current.scrollLeft = z), E.current && (E.current.scrollLeft = z);
  }, J = (R) => {
    const z = R.target.scrollLeft;
    E.current && (E.current.scrollLeft = z), $.current && ($.current.scrollLeft = z);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ue.card, o ? ue.grow : "", i ? ue.busy : "", d].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ue.busyBar, "aria-hidden": "true" }), (r !== void 0 || s !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ue.head }, /* @__PURE__ */ n.createElement("span", { className: ue.title }, r), s && /* @__PURE__ */ n.createElement("span", { className: ue.trailing }, s)), /* @__PURE__ */ n.createElement("div", { className: ue.scroll, ref: h, onScroll: J }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: g,
      role: m && m !== "table" ? m : void 0,
      "aria-busy": i || void 0,
      "aria-label": u != null ? u : typeof r == "string" && r ? r : void 0,
      style: w ? { minWidth: w } : void 0,
      onClick: f ? Q : void 0,
      onKeyDown: f ? se : void 0
    },
    /* @__PURE__ */ n.createElement(ha, { cols: e }),
    /* @__PURE__ */ n.createElement(pr.Provider, { value: I }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ue.foot, ref: E }, /* @__PURE__ */ n.createElement("table", { className: g, style: w ? { minWidth: w } : void 0 }, /* @__PURE__ */ n.createElement(ha, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ue.strip, ref: $, onScroll: B }, /* @__PURE__ */ n.createElement("div", { ref: D, className: ue.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ue.pager }, a), f && /* @__PURE__ */ n.createElement("span", { className: ue.sr, role: "status", "aria-live": "polite" }, K));
}
const Yl = 600;
function ga(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: s } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const o = e.viewport > 0 ? e.viewport : Yl, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - s) / a))), i = Math.ceil(o / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function Gl(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function Vl(e, t) {
  return e.start === t.start && e.end === t.end;
}
const va = /* @__PURE__ */ new Set();
function ka({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function Qg({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: s = 6,
  colSpan: o,
  headerRows: l = 1,
  className: c
}) {
  var g;
  const i = Dn(pr), m = j(null), [u, f] = M(() => ga({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: s
  })), p = e.length, [_, y] = M(null), d = _ && _.of === t ? _.px : t;
  Be(() => i ? i.registerVirtual() : void 0, [i]), Be(() => {
    var E;
    const h = (E = m.current) == null ? void 0 : E.closest("table");
    if (h)
      return h.setAttribute("aria-rowcount", String(p + l)), () => h.removeAttribute("aria-rowcount");
  }, [p, l]), Z(() => {
    const h = i == null ? void 0 : i.scrollRef.current, E = m.current;
    if (!h || !E) return;
    const $ = () => {
      const S = E.getBoundingClientRect().top - h.getBoundingClientRect().top + h.scrollTop, T = ga({ count: p, rowHeight: d, scrollTop: h.scrollTop, viewport: h.clientHeight, bodyTop: S, overscan: s });
      f((I) => Vl(I, T) ? I : T);
    };
    $(), h.addEventListener("scroll", $, { passive: !0 });
    const D = typeof ResizeObserver == "function" ? new ResizeObserver($) : null;
    return D ? D.observe(h) : window.addEventListener("resize", $), () => {
      h.removeEventListener("scroll", $), D ? D.disconnect() : window.removeEventListener("resize", $);
    };
  }, [i, p, d, s]), Be(() => {
    var $, D, S;
    const h = ($ = m.current) == null ? void 0 : $.querySelector("tr:not([data-virtual-spacer])"), E = (D = h == null ? void 0 : h.getBoundingClientRect().height) != null ? D : 0;
    !(E > 0) || Math.abs(E - d) <= 0.25 || (y({ of: t, px: E }), typeof process != "undefined" && ((S = process.env) == null ? void 0 : S.NODE_ENV) !== "production" && Math.abs(E - t) > 2 && !va.has(t) && (va.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(E)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [d, t, p]);
  const b = Math.min(u.end, p), N = Math.min(u.start, b), w = Gl(p, d, { start: N, end: b }), k = (g = o != null ? o : i == null ? void 0 : i.colCount) != null ? g : 1, x = [];
  for (let h = N; h < b; h += 1) {
    const E = a(e[h], h), $ = r ? r(e[h], h) : h;
    x.push(ln(E) ? ra(E, { key: $, "aria-rowindex": h + 1 + l }) : E);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: m, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(ka, { height: w.top, colSpan: k }), x, /* @__PURE__ */ n.createElement(ka, { height: w.bottom, colSpan: k }));
}
const Ql = 7.09, Jl = 3.88, Zl = 4.46, ec = 16, tc = 2;
function nc(e, t = {}) {
  var o;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), s = a * Ql + r * Jl + (t.negative ? Zl : 0) + ec + tc;
  return Math.max(Math.ceil(s), (o = t.min) != null ? o : 0);
}
function Jg(e, t = {}) {
  var s, o;
  let a = 0, r = (s = t.negative) != null ? s : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((o = t.min) != null ? o : 96, 96) : nc(a, { ...t, negative: r });
}
function Zg(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), s = a("000,000,000,000"), o = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (s - r) / 3, minus: o - s };
}
const Nt = 12, ac = 1.06, rc = 16, sc = 4;
function oc(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? Nt : e === " " ? Nt * 0.3 : /[0-9]/.test(e) ? Nt * 0.56 : /[A-Z]/.test(e) ? Nt * 0.68 : /[a-z]/.test(e) ? Nt * 0.56 : /[.,:;'|!]/.test(e) ? Nt * 0.3 : Nt * 0.6;
}
function lc(e, t = !1) {
  let a = 0;
  for (const r of e) a += oc(r);
  return t ? a * ac : a;
}
function ev(e, t = {}) {
  var o, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const m = lc(i, t.bold);
    m > a && (a = m);
  }
  const r = (o = t.min) != null ? o : 64;
  if (a === 0) return r;
  const s = Math.ceil(a + rc + ((l = t.extra) != null ? l : 0) + sc);
  return Math.min(Math.max(s, r), (c = t.max) != null ? c : 1 / 0);
}
function tv({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: s = "조회 결과가 없습니다",
  idle: o = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", m = r == null || r === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let f;
  if (i) f = "error";
  else if (t && m) f = "loading";
  else if (r == null) {
    if (o === null) return null;
    f = "idle";
  } else if (r === 0) f = "empty";
  else return null;
  const p = /* @__PURE__ */ n.createElement(n.Fragment, null, f === "loading" && /* @__PURE__ */ n.createElement("span", { className: ue.spin, "aria-hidden": "true" }), f === "error" && /* @__PURE__ */ n.createElement("span", { className: ue.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, f === "error" ? u : f === "loading" ? l : f === "idle" ? o : s)), _ = /* @__PURE__ */ n.createElement("div", { className: [ue.status, ue[`st_${f}`]].join(" "), role: "status" }, p);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": f }, _) : /* @__PURE__ */ n.createElement("tr", { className: [ue.statusRow, c].filter(Boolean).join(" "), "data-state": f }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ue.statusCell }, _));
}
function nv(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const cc = "_cell_n9rrj_1", ic = "_toggle_n9rrj_2", uc = "_spacer_n9rrj_8", mc = "_label_n9rrj_9", dc = "_dim_n9rrj_10", Qt = {
  cell: cc,
  toggle: ic,
  spacer: uc,
  label: mc,
  dim: dc
};
function av(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [s, o] = M(() => /* @__PURE__ */ new Set()), [l, c] = M(() => /* @__PURE__ */ new Set()), { parents: i, kids: m } = we(() => {
    const _ = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), d = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const N = a(b), w = N == null || !d.has(String(N)) ? null : String(N);
      _.set(String(t(b)), w), w && y.add(w);
    }
    return { parents: _, kids: y };
  }, [e, t, a]), u = le((_) => r ? !s.has(_) : l.has(_), [r, s, l]), f = we(() => e.filter((_) => {
    var b, N;
    let y = (b = i.get(String(t(_)))) != null ? b : null;
    const d = /* @__PURE__ */ new Set();
    for (; y && !d.has(y); ) {
      if (!u(y)) return !1;
      d.add(y), y = (N = i.get(y)) != null ? N : null;
    }
    return !0;
  }), [e, i, t, u]), p = le((_, y) => {
    const d = (b, N) => {
      const w = new Set(b);
      return N ? w.add(_) : w.delete(_), w;
    };
    r ? o((b) => d(b, !y)) : c((b) => d(b, y));
  }, [r]);
  return {
    visible: f,
    hasChildren: (_) => m.has(String(t(_))),
    isOpen: (_) => u(String(t(_))),
    toggle: (_) => {
      const y = String(t(_));
      p(y, !u(y));
    },
    expandAll: () => {
      o(/* @__PURE__ */ new Set()), c(new Set(m));
    },
    collapseAll: () => {
      o(new Set(m)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const _ = s, y = l;
      return o(/* @__PURE__ */ new Set()), c(new Set(m)), () => {
        o(_), c(y);
      };
    },
    reveal: (_) => {
      var b, N;
      let y = (b = i.get(String(_))) != null ? b : null;
      const d = /* @__PURE__ */ new Set();
      for (; y && !d.has(y); )
        p(y, !0), d.add(y), y = (N = i.get(y)) != null ? N : null;
    }
  };
}
function rv({ depth: e, hasChildren: t, open: a, onToggle: r, dim: s, toggleOutOfTabOrder: o, title: l, csvPath: c, children: i }) {
  const m = (f) => {
    f.stopPropagation(), r();
  }, u = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Qt.cell, s ? Qt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Qt.toggle,
        "aria-expanded": a,
        "aria-label": `${u ? `${u} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: m,
        tabIndex: o ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Qt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Qt.label, title: u }, i)
  );
}
function fc(e, t, a, r = !1) {
  const s = e[t.r];
  if (!s || t.i < 0 || t.i >= s.length) return null;
  const o = s[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < s.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: s.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let m = t.r + i; m >= 0 && m < e.length; m += i)
        if (e[m].length > 0) return { r: m, i: _c(e[m], o) };
      return null;
    }
    default:
      return null;
  }
}
function _c(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function sv(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, s = j(null), [o, l] = M(null);
  Z(() => {
    e.current !== o && l(e.current);
  }), Z(() => {
    if (!o) return;
    const i = () => Array.from(o.querySelectorAll(a)), m = () => {
      const y = i();
      if (!y.length) {
        s.current = null;
        return;
      }
      (!s.current || !y.includes(s.current)) && (s.current = r && y.find((d) => d.matches(r)) || y[0]), y.forEach((d) => {
        const b = d === s.current ? "0" : "-1";
        d.getAttribute("tabindex") !== b && d.setAttribute("tabindex", b);
      });
    }, u = () => {
      const y = i(), d = [], b = [], N = /* @__PURE__ */ new Map(), w = [];
      return y.forEach((k) => {
        var S;
        const x = k.tagName === "TR", g = x ? null : k.closest("td, th"), h = g && o.contains(g) ? g.parentElement : null, E = x ? k : (S = h != null ? h : k.parentElement) != null ? S : o;
        let $ = d.indexOf(E);
        $ < 0 && ($ = d.length, d.push(E), b.push([]), w.push([]));
        let D;
        if (x)
          D = 0;
        else if (g && h) {
          D = 0;
          for (const T of Array.from(h.cells)) {
            if (T === g) break;
            D += Math.max(1, T.colSpan || 1);
          }
        } else
          D = b[$].length;
        N.set(k, { r: $, i: b[$].length }), b[$].push(D), w[$].push(k);
      }), { rows: b, where: N, byPos: w };
    }, f = (y) => {
      var h;
      const d = y.target;
      if (!d || !d.matches(a) || !o.contains(d) || y.altKey || y.metaKey || d.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: N, byPos: w } = u(), k = N.get(d);
      if (!k) return;
      const x = fc(b, k, y.key, y.ctrlKey);
      if (x === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const g = (h = w[x.r]) == null ? void 0 : h[x.i];
      g && (s.current = g, m(), g.focus());
    }, p = (y) => {
      const d = y.target;
      !d || !d.matches(a) || d === s.current || (s.current = d, m());
    };
    m(), o.addEventListener("keydown", f), o.addEventListener("focusin", p);
    const _ = typeof MutationObserver != "undefined" ? new MutationObserver(m) : null;
    return _ == null || _.observe(o, { childList: !0, subtree: !0 }), () => {
      o.removeEventListener("keydown", f), o.removeEventListener("focusin", p), _ == null || _.disconnect();
    };
  }, [o, a, r]);
}
const pc = "_btn_r1trx_1", yc = "_mark_r1trx_7", bc = "_sr_r1trx_9", Gn = {
  btn: pc,
  mark: yc,
  sr: bc
};
function ov({ sortKey: e, sort: t, onSort: a, children: r, className: s = "", colSpan: o, style: l, title: c }) {
  const i = mr(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: o, style: l, title: c, className: s }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Gn.btn, onClick: () => a(ur(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: Gn.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function lv({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: Gn.sr, role: "status", "aria-live": "polite" }, dr(e, t));
}
const hc = "_card_14vt3_1", Ec = "_accent_14vt3_8", gc = "_grow_14vt3_9", vc = "_head_14vt3_11", kc = "_body_14vt3_20", wc = "_title_14vt3_28", Nc = "_trailing_14vt3_29", $c = "_summary_14vt3_32", xc = "_sumHead_14vt3_33", Dc = "_sumTotal_14vt3_42", Ac = "_tone_warn_14vt3_43", Cc = "_tone_ok_14vt3_44", Sc = "_sumList_14vt3_46", Mc = "_sumEm_14vt3_55", Tc = "_sumFoot_14vt3_57", qc = "_sumNote_14vt3_66", $e = {
  card: hc,
  accent: Ec,
  grow: gc,
  head: vc,
  body: kc,
  title: wc,
  trailing: Nc,
  summary: $c,
  sumHead: xc,
  sumTotal: Dc,
  tone_warn: Ac,
  tone_ok: Cc,
  sumList: Sc,
  sumEm: Mc,
  sumFoot: Tc,
  sumNote: qc
};
function yr({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: s,
  className: o = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [$e.card, a ? $e.accent : "", r ? $e.grow : "", o].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: $e.head }, /* @__PURE__ */ n.createElement("span", { className: $e.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: $e.trailing }, t)),
    s ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", $e.body].join(" ") }, l)
  );
}
function cv({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: s,
  note: o,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [$e.card, $e.accent, $e.summary, $e[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: $e.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: $e.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: $e.sumList }, a.map((i, m) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: (u = i.key) != null ? u : m, className: i.em ? $e.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: $e.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, s)), o && /* @__PURE__ */ n.createElement("div", { className: $e.sumNote }, o));
}
let Bc = 0;
function Gt(e = "axe") {
  const t = j(null);
  return t.current || (t.current = `${e}-${++Bc}`), t.current;
}
const Lc = "_sr_1y2mv_2", jc = "_skip_1y2mv_8", Rc = "_crit_1y2mv_16", Ic = "_c_danger_1y2mv_21", Oc = "_c_warn_1y2mv_22", Pc = "_critI_1y2mv_23", Xc = "_critBody_1y2mv_24", zc = "_critX_1y2mv_25", Fc = "_ch_1y2mv_32", Wc = "_chBtn_1y2mv_33", Hc = "_chBox_1y2mv_43", Je = {
  sr: Lc,
  skip: jc,
  crit: Rc,
  c_danger: Ic,
  c_warn: Oc,
  critI: Pc,
  critBody: Xc,
  critX: zc,
  ch: Fc,
  chBtn: Wc,
  chBox: Hc
};
function br({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: Je.sr, id: a }, t);
}
function iv({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, s) => {
    const o = document.getElementById(s);
    o && (r.preventDefault(), o.hasAttribute("tabindex") || o.setAttribute("tabindex", "-1"), o.focus(), o.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Je.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (s) => a(s, r.targetId) }, r.label)));
}
function uv({ title: e, children: t, tone: a = "danger", onClose: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Je.crit, Je[`c_${a}`], s].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: Je.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: Je.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Je.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function mv({ label: e, children: t, className: a = "" }) {
  const [r, s] = M(!1), o = Gt("axe-ch"), l = j(null), c = j(null);
  return Z(() => {
    if (!r) return;
    const i = (u) => {
      l.current && !l.current.contains(u.target) && s(!1);
    }, m = (u) => {
      var f;
      u.key !== "Escape" || u.isComposing || (u.preventDefault(), u.stopPropagation(), s(!1), (f = c.current) == null || f.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", m, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", m, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [Je.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: Je.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": o,
      onClick: () => s((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: o, role: "region", "aria-label": e, className: Je.chBox }, t));
}
function Vn(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const s = (t != null ? t : "").trim();
  return !s || a === "code" ? r : a === "name" ? s : `${r}. ${s}`;
}
function Kc(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = Vn(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function Uc(e, t, a, r) {
  const s = (e != null ? e : "").trim();
  if (!s) return null;
  if (t && t.name && t.code === s) return t.name;
  if (a && a.code === s && a.name) return a.name;
  const o = r == null ? void 0 : r.find((l) => l.code === s);
  return o && o.name ? o.name : null;
}
const Yc = "_root_umk7w_1", Gc = "_rootNone_umk7w_5", Vc = "_field_umk7w_12", Qc = "_codeInput_umk7w_13", Jc = "_pickBtn_umk7w_17", Zc = "_suggest_umk7w_34", ei = "_suggestList_umk7w_40", ti = "_suggestRow_umk7w_41", ni = "_suggestOn_umk7w_42", ai = "_suggestEmpty_umk7w_47", ri = "_suggestMore_umk7w_47", si = "_popup_umk7w_51", oi = "_popupHead_umk7w_65", li = "_searchRow_umk7w_75", ci = "_list_umk7w_79", ii = "_current_umk7w_88", ui = "_empty_umk7w_92", mi = "_summaryBtn_umk7w_100", di = "_ov_umk7w_121", fi = "_modal_umk7w_132", _i = "_modalWide_umk7w_132", pi = "_head_umk7w_144", yi = "_sub_umk7w_152", bi = "_x_umk7w_154", hi = "_body_umk7w_171", Ei = "_chips_umk7w_179", gi = "_chip_umk7w_179", vi = "_chipOn_umk7w_193", ki = "_search_umk7w_75", wi = "_tbl_umk7w_212", Ni = "_row_umk7w_242", $i = "_rowCursor_umk7w_244", xi = "_rowPicked_umk7w_245", Di = "_rowCurrent_umk7w_246", Ai = "_curTag_umk7w_247", Ci = "_busy_umk7w_248", Si = "_count_umk7w_249", Mi = "_chk_umk7w_251", Ti = "_tdLeft_umk7w_252", qi = "_tdCenter_umk7w_253", Bi = "_emptyCell_umk7w_255", Li = "_stop_umk7w_257", ji = "_more_umk7w_268", Ri = "_pager_umk7w_280", Ii = "_note_umk7w_293", Oi = "_foot_umk7w_296", Pi = "_ghost_umk7w_305", Xi = "_primary_umk7w_317", U = {
  root: Yc,
  rootNone: Gc,
  field: Vc,
  codeInput: Qc,
  pickBtn: Jc,
  suggest: Zc,
  suggestList: ei,
  suggestRow: ti,
  suggestOn: ni,
  suggestEmpty: ai,
  suggestMore: ri,
  popup: si,
  popupHead: oi,
  searchRow: li,
  list: ci,
  current: ii,
  empty: ui,
  summaryBtn: mi,
  ov: di,
  modal: fi,
  modalWide: _i,
  head: pi,
  sub: yi,
  x: bi,
  body: hi,
  chips: Ei,
  chip: gi,
  chipOn: vi,
  search: ki,
  tbl: wi,
  row: Ni,
  rowCursor: $i,
  rowPicked: xi,
  rowCurrent: Di,
  curTag: Ai,
  busy: Ci,
  count: Si,
  chk: Mi,
  tdLeft: Ti,
  tdCenter: qi,
  emptyCell: Bi,
  stop: Li,
  more: ji,
  pager: Ri,
  note: Ii,
  foot: Oi,
  ghost: Pi,
  primary: Xi
};
function zi({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: s,
  pos: o,
  onPick: l,
  onClose: c
}) {
  const [i, m] = M(""), u = we(() => {
    const f = i.trim().toLowerCase();
    return f ? e.filter(
      (p) => {
        var _;
        return p.code.toLowerCase().includes(f) || p.name.toLowerCase().includes(f) || ((_ = p.sub) != null ? _ : "").toLowerCase().includes(f);
      }
    ) : e;
  }, [e, i]);
  return Z(() => {
    const f = (_) => {
      const y = _.target;
      r.current && !r.current.contains(y) && s.current && !s.current.contains(y) && c();
    }, p = (_) => {
      _.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", f), document.addEventListener("keydown", p), () => {
      document.removeEventListener("mousedown", f), document.removeEventListener("keydown", p);
    };
  }, [r, s, c]), /* @__PURE__ */ n.createElement(Yt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: U.popup,
      style: { left: o.left, top: o.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: U.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: U.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (f) => m(f.target.value),
        onKeyDown: (f) => {
          f.key === "Enter" && u.length && l(u[0]), f.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: U.list }, u.map((f) => /* @__PURE__ */ n.createElement("li", { key: f.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(f), className: f.code === t ? U.current : "" }, /* @__PURE__ */ n.createElement("code", null, f.code), /* @__PURE__ */ n.createElement("span", null, f.name), f.sub && /* @__PURE__ */ n.createElement("small", null, f.sub)))), u.length === 0 && /* @__PURE__ */ n.createElement("li", { className: U.empty }, "검색 결과가 없습니다"))
  ));
}
const hr = 250, _n = 7;
function wa(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function Fi(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const s = r.trim().toLowerCase();
      return s ? Promise.resolve({
        rows: a.filter(
          (o) => {
            var l;
            return o.cd.toLowerCase().includes(s) || o.nm.toLowerCase().includes(s) || String((l = o.sub) != null ? l : "").toLowerCase().includes(s);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Wi({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: s,
  current: o,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  var se;
  const m = we(() => Fi(t != null ? t : [], a), [t, a]), u = e != null ? e : m, [f, p] = M(""), [_, y] = M((se = e == null ? void 0 : e.defaultFilter) != null ? se : null), [d, b] = M(0), [N, w] = M([]), [k, x] = M(!1), [g, h] = M(!1), [E, $] = M(null), [D, S] = M(0), [T, I] = M(/* @__PURE__ */ new Map()), q = j(u);
  q.current = u, Z(() => {
    var J;
    p(""), y((J = q.current.defaultFilter) != null ? J : null), b(0), S(0), $(null), I(new Map((s != null ? s : []).map((R) => [R.cd, R])));
    const B = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(B);
  }, [u.key]), Z(() => {
    let B = !0;
    h(!0);
    const J = () => {
      q.current.fetch({ q: f.trim(), ty: _, page: d }).then((z) => {
        var X, H;
        if (!B) return;
        w((X = z.rows) != null ? X : []), x(!!z.hasMore), $(null);
        const G = o ? ((H = z.rows) != null ? H : []).findIndex((ce) => ce.cd === o) : -1;
        S(G > 0 ? G : 0);
      }).catch((z) => {
        B && (w([]), x(!1), $("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        B && h(!1);
      });
    }, R = window.setTimeout(J, f.trim() ? hr : 0);
    return () => {
      B = !1, window.clearTimeout(R);
    };
  }, [u.key, f, _, d]);
  const P = j(null);
  Z(() => {
    const B = P.current && P.current.children[D];
    B && "scrollIntoView" in B && B.scrollIntoView({ block: "nearest" });
  }, [D, N]);
  const Y = we(() => {
    var J, R;
    const B = [
      { key: "cd", label: "코드", width: (J = u.codeWidth) != null ? J : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (z) => /* @__PURE__ */ n.createElement(n.Fragment, null, z.nm, z.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: U.stop }, "사용중단"))
      }
    ];
    return u.typeLabel && B.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (z) => u.typeLabel ? u.typeLabel(z) : ""
    }), B.concat((R = u.extraColumns) != null ? R : []);
  }, [u]), K = le((B) => {
    I((J) => {
      const R = new Map(J);
      return R.has(B.cd) ? R.delete(B.cd) : R.set(B.cd, B), R;
    });
  }, []), L = le((B) => c([B]), [c]), te = le(() => c(Array.from(T.values())), [T, c]), ne = N.length > 0 && N.every((B) => T.has(B.cd)), v = () => {
    I((B) => {
      const J = new Map(B);
      return ne ? N.forEach((R) => J.delete(R.cd)) : N.forEach((R) => J.set(R.cd, R)), J;
    });
  }, O = j(null);
  Z(() => {
    const B = document.activeElement;
    return () => {
      window.setTimeout(() => {
        B && B.isConnected && typeof B.focus == "function" && (!document.activeElement || document.activeElement === document.body) && B.focus();
      }, 0);
    };
  }, []);
  const V = j(i);
  V.current = i, Z(() => {
    const B = (J) => {
      J.key !== "Escape" || J.isComposing || (J.stopPropagation(), J.preventDefault(), V.current());
    };
    return document.addEventListener("keydown", B, !0), () => document.removeEventListener("keydown", B, !0);
  }, []);
  const Q = (B) => {
    var z;
    if (B.nativeEvent.isComposing || B.keyCode === 229) return;
    if (B.key === "Tab" && O.current) {
      const G = Array.from(O.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (G.length) {
        const X = G[0], H = G[G.length - 1], ce = document.activeElement;
        B.shiftKey && ce === X ? (B.preventDefault(), H.focus()) : !B.shiftKey && ce === H && (B.preventDefault(), X.focus());
      }
      return;
    }
    if (B.key === "Escape") {
      B.stopPropagation(), i();
      return;
    }
    const J = B.target, R = J === l.current;
    if (!(!R && J !== O.current)) {
      if (B.key === "ArrowDown" || B.key === "ArrowUp") {
        B.preventDefault(), S((G) => Math.max(0, Math.min(N.length - 1, G + (B.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (B.key === " " && r && N[D] && !(R && ((z = l.current) != null && z.value))) {
        B.preventDefault(), K(N[D]);
        return;
      }
      if (B.key === "Enter") {
        if (B.preventDefault(), g) return;
        r ? te() : N[D] && L(N[D]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Yt, null, /* @__PURE__ */ n.createElement("div", { className: U.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: u.wide ? `${U.modal} ${U.modalWide}` : U.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: O,
      onClick: (B) => B.stopPropagation(),
      onKeyDown: Q
    },
    /* @__PURE__ */ n.createElement("div", { className: U.head }, /* @__PURE__ */ n.createElement("h2", null, u.title), r && /* @__PURE__ */ n.createElement("span", { className: U.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: U.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: U.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: _ === null ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), u.filters.map((B) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: B.value,
        type: "button",
        className: _ === B.value ? `${U.chip} ${U.chipOn}` : U.chip,
        onClick: () => {
          y(B.value), b(0);
        }
      },
      B.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: U.search,
        value: f,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (B) => {
          p(B.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: U.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: U.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: ne,
        onChange: v,
        "aria-label": "표시된 행 전체 선택"
      }
    )), Y.map((B) => /* @__PURE__ */ n.createElement("th", { key: B.key, style: B.width ? { width: B.width } : void 0 }, B.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: P, className: g && N.length > 0 ? U.busy : void 0, "aria-busy": g }, N.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: U.emptyCell, colSpan: Y.length + (r ? 1 : 0) }, g ? "검색 중…" : E || u.emptyText || "검색 결과가 없습니다")) : N.map((B, J) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: B.cd,
        className: [
          U.row,
          J === D ? U.rowCursor : "",
          T.has(B.cd) ? U.rowPicked : "",
          !r && o && B.cd === o ? U.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": J === D,
        onClick: () => {
          S(J), r ? K(B) : L(B);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: U.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: T.has(B.cd),
          onChange: () => K(B),
          onClick: (R) => R.stopPropagation(),
          "aria-label": `${B.cd} 선택`
        }
      )),
      Y.map((R) => {
        var z, G;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: R.key,
            className: R.align === "left" ? U.tdLeft : U.tdCenter,
            title: R.render ? void 0 : String((z = B[R.key]) != null ? z : "")
          },
          R.render ? R.render(B) : String((G = B[R.key]) != null ? G : ""),
          R.key === "cd" && !r && o && B.cd === o && /* @__PURE__ */ n.createElement("em", { className: U.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: U.count, role: "status", "aria-live": "polite" }, g ? "검색 중…" : E ? "" : `${N.length}건`, !r && !g && !E && N.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 줄을 누르세요"), (k || d > 0) && /* @__PURE__ */ n.createElement("div", { className: U.more }, /* @__PURE__ */ n.createElement("span", null, k ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: U.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: d === 0, onClick: () => b((B) => Math.max(0, B - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, d + 1), k && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((B) => B + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: U.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, T.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: U.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: () => I(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: U.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.primary, onClick: te }, "확인"))
  )));
}
let Hi = 0;
function Ki({ source: e, items: t, anchorRef: a }) {
  const [r, s] = M(null), [o, l] = M(-1), [c, i] = M(null), m = j(null), u = j(0), f = j(`axe-cp-${++Hi}`), p = j(e);
  p.current = e;
  const _ = j(t);
  _.current = t;
  const y = le(() => {
    m.current != null && (window.clearTimeout(m.current), m.current = null), u.current += 1, s(null), l(-1);
  }, []);
  Z(() => y, [y]);
  const d = (b) => {
    m.current != null && window.clearTimeout(m.current), u.current += 1;
    const N = u.current;
    if (!b.trim()) {
      s(null), l(-1);
      return;
    }
    m.current = window.setTimeout(async () => {
      var x;
      let w = [], k = !1;
      try {
        const g = p.current;
        if (g) {
          const h = await g.fetch({ q: b, ty: null, page: 0 });
          w = h.rows, k = !!h.hasMore || w.length > _n;
        } else {
          const h = b.trim().toLowerCase();
          w = ((x = _.current) != null ? x : []).filter((E) => {
            var $;
            return E.code.toLowerCase().includes(h) || E.name.toLowerCase().includes(h) || (($ = E.sub) != null ? $ : "").toLowerCase().includes(h);
          }).map((E) => ({ cd: E.code, nm: E.name, sub: E.sub })), k = w.length > _n;
        }
      } catch {
        return;
      }
      N === u.current && (s({ rows: w.slice(0, _n), more: k, q: b }), l(-1));
    }, hr);
  };
  return Z(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const N = a.current;
      if (!N) return;
      const w = N.getBoundingClientRect(), k = Math.min(r.rows.length, _n) * 28 + 34, x = w.bottom + k > window.innerHeight - 8 && w.top - k - 2 > 8 ? w.top - k - 2 : w.bottom + 2, g = Math.max(w.width, 260);
      i({ left: Math.max(8, Math.min(w.left, window.innerWidth - g - 8)), top: x, width: g });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: o, setActive: l, suggPos: c, suggId: f, runSuggest: d, cancelSuggest: y };
}
function dv({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: s,
  source: o,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: m,
  trigger: u,
  emptyLabel: f = "전체",
  open: p,
  onOpenChange: _,
  placeholder: y,
  title: d = "코드 선택",
  variant: b,
  disabled: N,
  className: w = "",
  maxLength: k,
  numeric: x = !1,
  ariaLabel: g,
  autoFocus: h,
  onEnter: E,
  onEscape: $,
  onBlur: D,
  invalid: S,
  selectOnFocus: T = !1
}) {
  const I = o ? "source" : "static", q = g != null ? g : (o == null ? void 0 : o.title) || (typeof d == "string" && d !== "코드 선택" ? d : "") || "코드", P = b != null ? b : I === "source" ? "modal" : "anchor", Y = u != null ? u : l ? "summary" : "input", [K, L] = M(!1), te = p != null ? p : K, ne = le(
    (W) => {
      p === void 0 && L(W), _ && _(W);
    },
    [p, _]
  ), v = j(null), O = j(!1), V = j(null), Q = j(null), [se, B] = M(null), J = () => {
    if (!N) {
      if (P === "anchor") {
        const W = v.current;
        if (!W) return;
        const fe = W.getBoundingClientRect(), A = 320, F = fe.bottom + A > window.innerHeight ? Math.max(8, fe.top - A - 4) : fe.bottom + 4;
        B({ left: Math.min(fe.left, window.innerWidth - 320), top: F });
      }
      ne(!0);
    }
  }, R = le(() => ne(!1), [ne]), [z, G] = M(!1), [X, H] = M(null), ce = j(null);
  (!ce.current || ce.current.name !== t) && (ce.current = { name: t, code: e });
  const Ue = Uc(e, ce.current, X, s), Re = Vn(e, Ue, a), Ie = Vn(e, Ue), gt = (W) => {
    !l && W[0] && H({ code: W[0].cd, name: W[0].nm }), i ? i(W) : W[0] && r && r(W[0].cd, { code: W[0].cd, name: W[0].nm });
  }, { sugg: xe, active: Xe, setActive: nt, suggPos: jt, suggId: Oe, runSuggest: Bn, cancelSuggest: vt } = Ki({ source: o, items: s, anchorRef: v }), kt = (W) => {
    vt(), gt([W]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: v, className: [Y === "none" ? U.rootNone : U.root, w].filter(Boolean).join(" ") }, Y === "input" && /* @__PURE__ */ n.createElement("span", { className: U.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: U.codeInput,
      style: { paddingRight: 24 },
      value: z ? e : Re,
      placeholder: y,
      disabled: N,
      maxLength: k,
      inputMode: x ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: h,
      "aria-label": q,
      "aria-invalid": S ? !0 : void 0,
      onChange: (W) => {
        const fe = W.target.value.trim(), A = x ? fe.replace(/[^0-9]/g, "") : fe, F = k ? A.slice(0, k) : A;
        r && r(F), !N && (o || s) && Bn(F);
      },
      onKeyDown: (W) => {
        if (W.key === "F2") {
          W.preventDefault(), vt(), J();
          return;
        }
        if (!xe) {
          W.key === "Enter" && E && !W.nativeEvent.isComposing ? (W.preventDefault(), E()) : W.key === "Escape" && $ && (W.preventDefault(), $());
          return;
        }
        const fe = xe.rows.length;
        W.key === "ArrowDown" && fe ? (W.preventDefault(), nt((A) => (A + 1) % fe)) : W.key === "ArrowUp" && fe ? (W.preventDefault(), nt((A) => (A <= 0 ? fe : A) - 1)) : W.key === "Enter" && Xe >= 0 && xe.rows[Xe] ? (W.preventDefault(), kt(xe.rows[Xe])) : W.key === "Enter" && E && !W.nativeEvent.isComposing ? (W.preventDefault(), vt(), E()) : W.key === "Escape" && (W.preventDefault(), W.stopPropagation(), W.nativeEvent.stopImmediatePropagation(), vt());
      },
      onFocus: (W) => {
        if (G(!0), !T) return;
        const fe = W.currentTarget;
        window.requestAnimationFrame(() => fe.select());
      },
      onMouseDown: (W) => {
        T && document.activeElement !== W.currentTarget && (O.current = !0);
      },
      onMouseUp: (W) => {
        O.current && (W.preventDefault(), O.current = !1);
      },
      onBlur: () => {
        G(!1), vt(), D && D();
      },
      title: typeof S == "string" && S ? S : Ie && Ie !== e ? `${Ie} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!xe,
      "aria-controls": xe ? Oe.current : void 0,
      "aria-activedescendant": xe && Xe >= 0 ? `${Oe.current}-${Xe}` : void 0,
      "aria-describedby": typeof S == "string" && S ? `${Oe.current}-inv` : void 0
    }
  ), typeof S == "string" && S && /* @__PURE__ */ n.createElement(br, { id: `${Oe.current}-inv` }, S), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: U.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: N,
      onClick: J,
      onMouseDown: (W) => W.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(gn, { name: "search", size: 13 })
  )), Y === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: U.summaryBtn, disabled: N, onClick: J }, /* @__PURE__ */ n.createElement("span", null, Kc(c != null ? c : [], f, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(gn, { name: "search", size: 13 }))), xe && jt && Y === "input" && !te && /* @__PURE__ */ n.createElement(Yt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: U.suggest,
      style: { left: jt.left, top: jt.top, width: jt.width },
      onMouseDown: (W) => W.preventDefault()
    },
    xe.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: U.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: Oe.current, role: "listbox", className: U.suggestList }, xe.rows.map((W, fe) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: W.cd,
        id: `${Oe.current}-${fe}`,
        role: "option",
        "aria-selected": fe === Xe,
        className: [U.suggestRow, fe === Xe ? U.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => nt(fe),
        onClick: () => kt(W)
      },
      /* @__PURE__ */ n.createElement("code", null, wa(W.cd, xe.q)),
      /* @__PURE__ */ n.createElement("span", null, wa(W.nm, xe.q)),
      W.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    xe.more && /* @__PURE__ */ n.createElement("div", { className: U.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), te && I === "static" && P === "anchor" && se && /* @__PURE__ */ n.createElement(
    zi,
    {
      items: s != null ? s : [],
      value: e,
      title: d,
      popupRef: V,
      anchorRef: v,
      pos: se,
      onPick: (W) => {
        H({ code: W.code, name: W.name }), r && r(W.code, W), R();
      },
      onClose: R
    }
  ), te && (I === "source" || P === "modal") && /* @__PURE__ */ n.createElement(
    Wi,
    {
      source: o,
      items: s,
      title: d,
      multiple: l,
      selected: c,
      current: m,
      searchRef: Q,
      onConfirm: (W) => {
        gt(W), R();
      },
      onClose: R
    }
  ));
}
const la = 864e5;
function Ui(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? Ui(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function ht(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / la);
}
function Yi(e) {
  const t = new Date(e * la);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function Cn(e, t) {
  return Yi(ht(e) + t);
}
function ca(e) {
  return new Date(ht(e) * la).getUTCDay();
}
const Na = "1900-01-01", $a = "2099-12-31", Rn = ["일", "월", "화", "수", "목", "금", "토"], vn = (e) => String(e).padStart(2, "0");
function tt(e, t, a) {
  return `${String(e).padStart(4, "0")}-${vn(t)}-${vn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], s = +t[3];
  return r < 1 || r > 12 || s < 1 || s > Le(a, r) ? null : { y: a, m: r, d: s };
}
function Gi(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function Jt(e, t) {
  return t === "month" ? Gi(e) : de(e);
}
function qe(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${vn(e.m)}` : tt(e.y, e.m, e.d);
}
function je(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function cn(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function Et(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = (a % 12 + 12) % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Le(r, s)) };
}
function Vi(e, t, a) {
  return e >= t && e <= a;
}
function It(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function In(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), s = e.slice(6, 8);
  let o = a;
  return e.length > 4 && (o += "-" + r), t === "date" && e.length > 6 && (o += "-" + s), o;
}
function xa(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function hn(e, t, a) {
  let r, s, o = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), s = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), s = +e.slice(4, 6), o = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), s = +e.slice(2, 4), o = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, s = +e.slice(0, 2), o = +e.slice(2, 4);
  else return null;
  return s < 1 || s > 12 || o < 1 || o > Le(r, s) ? null : { y: r, m: s, d: o };
}
function Qi(e, t, a) {
  const r = e.trim(), s = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (s) {
    const o = { y: +s[1], m: +s[2], d: t === "month" ? 1 : +s[3] };
    return o.m >= 1 && o.m <= 12 && o.d >= 1 && o.d <= Le(o.y, o.m) ? o : null;
  }
  return hn(r.replace(/\D/g, ""), t, a);
}
function Ji(e, t) {
  const a = { y: e, m: t, d: 1 }, r = cn(a, -je(a));
  return Array.from({ length: 42 }, (s, o) => cn(r, o));
}
function Zi(e, t) {
  const a = e.y, r = [], s = (m, u) => `${String(m).padStart(4, "0")}-${vn(u)}`, o = (m, u, f) => tt(m, u, f);
  if (t === "month") {
    r.push({ label: "이번 달", from: s(a, e.m), to: s(a, e.m) });
    const m = Et(e, -1);
    r.push({ label: "지난달", from: s(m.y, m.m), to: s(m.y, m.m) }), r.push({ label: "올해", from: s(a, 1), to: s(a, 12) }), r.push({ label: "올해 누계", from: s(a, 1), to: s(a, e.m) }), r.push({ label: "전년도", from: s(a - 1, 1), to: s(a - 1, 12) });
    for (let u = 1; u <= 4; u++) r.push({ label: `${u}분기`, from: s(a, u * 3 - 2), to: s(a, u * 3) });
    return r.push({ label: "상반기", from: s(a, 1), to: s(a, 6) }), r.push({ label: "하반기", from: s(a, 7), to: s(a, 12) }), r;
  }
  const l = tt(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = cn(e, -je(e));
  r.push({ label: "이번 주", from: qe(c, "date"), to: qe(cn(c, 6), "date") }), r.push({ label: "이번 달", from: o(a, e.m, 1), to: o(a, e.m, Le(a, e.m)) });
  const i = Et({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: o(i.y, i.m, 1), to: o(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: o(a, 1, 1), to: o(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: o(a, 1, 1), to: l }), r.push({ label: "전년도", from: o(a - 1, 1, 1), to: o(a - 1, 12, 31) });
  for (let m = 1; m <= 4; m++)
    r.push({ label: `${m}분기`, from: o(a, m * 3 - 2, 1), to: o(a, m * 3, Le(a, m * 3)) });
  return r;
}
const eu = "_wrap_uxy72_1", tu = "_disabled_uxy72_18", nu = "_input_uxy72_22", au = "_month_uxy72_36", ru = "_weekday_uxy72_39", su = "_sun_uxy72_40", ou = "_sat_uxy72_41", lu = "_icon_uxy72_43", cu = "_readOnly_uxy72_57", iu = "_required_uxy72_62", uu = "_invalid_uxy72_63", mu = "_pop_uxy72_66", du = "_calHead_uxy72_79", fu = "_calTitleStatic_uxy72_80", _u = "_calTitle_uxy72_80", pu = "_grid_uxy72_90", yu = "_wd_uxy72_91", bu = "_day_uxy72_95", hu = "_mon_uxy72_36", Eu = "_out_uxy72_104", gu = "_sel_uxy72_105", vu = "_today_uxy72_108", ku = "_months_uxy72_111", wu = "_foot_uxy72_114", Nu = "_clear_uxy72_127", $u = "_range_uxy72_130", xu = "_tilde_uxy72_131", Du = "_rangeErr_uxy72_132", ae = {
  wrap: eu,
  disabled: tu,
  input: nu,
  month: au,
  weekday: ru,
  sun: su,
  sat: ou,
  icon: lu,
  readOnly: cu,
  required: iu,
  invalid: uu,
  pop: mu,
  calHead: du,
  calTitleStatic: fu,
  calTitle: _u,
  grid: pu,
  wd: yu,
  day: bu,
  mon: hu,
  out: Eu,
  sel: gu,
  today: vu,
  months: ku,
  foot: wu,
  clear: Nu,
  range: $u,
  tilde: xu,
  rangeErr: Du
}, _t = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function Da({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: s,
  disabled: o,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: m,
  onReject: u,
  placeholder: f,
  id: p,
  name: _,
  onBlur: y,
  "aria-label": d,
  "aria-describedby": b,
  className: N = "",
  style: w
}) {
  const k = a === "month", x = Gt("axe-dp"), g = r || (k ? Na.slice(0, 7) : Na), h = s || (k ? $a.slice(0, 7) : $a), E = (A) => Vi(A, g, h), $ = !!o || !!l, [D, S] = M(e || ""), [T, I] = M(!1), [q, P] = M(!1), [Y, K] = M(k ? "month" : "day"), [L, te] = M(() => {
    var F;
    const A = (F = Jt(e, a)) != null ? F : _t();
    return { y: A.y, m: A.m };
  }), [ne, v] = M({ top: 0, left: 0 }), O = j(null), V = j(null), Q = j(null), se = j(null);
  Z(() => {
    S(e || ""), I(!1);
  }, [e]), Z(() => {
    const A = Jt(e, a);
    A && te({ y: A.y, m: A.m });
  }, [e, a]), Be(() => {
    const A = V.current;
    se.current != null && A && document.activeElement === A && A.setSelectionRange(se.current, se.current), se.current = null;
  }, [D]), Be(() => {
    if (!q) return;
    const A = () => {
      const F = O.current, re = Q.current;
      if (!F || !re) return;
      const ie = F.getBoundingClientRect(), me = re.offsetHeight, Ee = re.offsetWidth;
      let De = ie.bottom + 4;
      De + me > window.innerHeight - 8 && ie.top - me - 4 > 8 && (De = ie.top - me - 4);
      const Vt = Math.max(8, Math.min(ie.left, window.innerWidth - Ee - 8));
      v((Ln) => Ln.top === De && Ln.left === Vt ? Ln : { top: De, left: Vt });
    };
    return A(), window.addEventListener("resize", A), window.addEventListener("scroll", A, !0), () => {
      window.removeEventListener("resize", A), window.removeEventListener("scroll", A, !0);
    };
  }, [q, Y, L.y, L.m]), Z(() => {
    if (!q) return;
    const A = (F) => {
      var ie, me;
      const re = F.target;
      (ie = O.current) != null && ie.contains(re) || (me = Q.current) != null && me.contains(re) || P(!1);
    };
    return document.addEventListener("mousedown", A), () => document.removeEventListener("mousedown", A);
  }, [q]);
  const B = (A) => {
    A !== (e || "") && t(A);
  }, J = (A) => {
    S(A), I(!1), B(A);
  }, R = () => {
    const A = It(D, a);
    if (!A) return;
    const F = hn(A, a, _t()), re = F ? qe(F, a) : null;
    if (re && E(re)) {
      J(re);
      return;
    }
    u == null || u(D, re ? "range" : "format"), S(e || ""), I(!1);
  }, z = (A, F) => {
    const re = It(A.slice(0, F), a).length, ie = It(A, a), me = In(ie, a);
    if (se.current = xa(me, Math.min(re, ie.length)), S(me), !ie) {
      I(!1), B("");
      return;
    }
    if (ie.length === (k ? 6 : 8)) {
      const Ee = hn(ie, a, _t()), De = Ee ? qe(Ee, a) : null;
      De && E(De) ? (I(!1), B(De)) : I(!0);
    } else I(!1);
  }, G = (A, F) => {
    var Vt;
    const re = _t(), ie = It(D, a), me = (Vt = hn(ie, a, re)) != null ? Vt : Jt(e, a);
    let Ee;
    me ? k ? Ee = Et(me, A === "year" ? 12 * F : F) : A === "day" ? Ee = cn(me, F) : Ee = Et(me, A === "month" ? F : 12 * F) : Ee = re;
    const De = qe(Ee, a);
    E(De) && J(De);
  }, X = (A) => {
    var F;
    J(A), P(!1), (F = V.current) == null || F.focus();
  }, H = () => {
    var F;
    if ($) return;
    const A = (F = Jt(e, a)) != null ? F : _t();
    te({ y: A.y, m: A.m }), K(k ? "month" : "day"), P(!0);
  }, ce = (A) => {
    var re, ie;
    if ($) return;
    const F = A.currentTarget;
    switch (A.key) {
      case "Escape":
        q ? (P(!1), A.preventDefault(), A.stopPropagation(), A.nativeEvent.stopImmediatePropagation()) : D !== (e || "") && (S(e || ""), I(!1), A.preventDefault(), A.stopPropagation(), A.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => F.select()));
        break;
      case "ArrowDown":
        A.preventDefault(), A.altKey ? q ? P(!1) : H() : G("day", 1);
        break;
      case "ArrowUp":
        A.preventDefault(), G("day", -1);
        break;
      case "PageDown":
        A.preventDefault(), G("month", 1);
        break;
      case "PageUp":
        A.preventDefault(), G("month", -1);
        break;
      case "F2":
      case "F4":
        A.preventDefault(), q ? P(!1) : H();
        break;
      case "Enter":
        R(), q && P(!1);
        break;
      case "t":
      case "T":
        if (A.ctrlKey || A.metaKey || A.altKey) break;
        A.preventDefault(), J(qe(_t(), a));
        break;
      case "Backspace": {
        const me = (re = F.selectionStart) != null ? re : 0;
        if (me === ((ie = F.selectionEnd) != null ? ie : 0) && me > 0 && D[me - 1] === "-") {
          A.preventDefault();
          const Ee = It(D.slice(0, me), a).length, De = It(D, a);
          z(In(De.slice(0, Ee - 1) + De.slice(Ee), a), 0), se.current = xa(In(De.slice(0, Ee - 1) + De.slice(Ee), a), Ee - 1);
        }
        break;
      }
    }
  }, Ue = (A) => {
    if ($) return;
    A.preventDefault();
    const F = Qi(A.clipboardData.getData("text"), a, _t()), re = F ? qe(F, a) : null;
    re && E(re) ? J(re) : I(!0);
  }, Re = (A) => {
    var re, ie;
    const F = A.relatedTarget;
    F && ((re = O.current) != null && re.contains(F) || (ie = Q.current) != null && ie.contains(F)) || (R(), P(!1), y && y());
  }, Ie = Jt(e, a), gt = _t(), xe = T || !!i, Xe = m && !k && Ie ? je(Ie) : null, nt = (A) => qe(A, a), jt = (A, F) => {
    const re = qe({ y: A, m: F, d: 1 }, "date"), ie = qe({ y: A, m: F, d: Le(A, F) }, "date"), me = k ? g + "-01" : g, Ee = k ? h + "-31" : h;
    return ie >= me && re <= Ee;
  }, Oe = (A) => {
    const F = Et({ y: L.y, m: L.m, d: 1 }, A);
    te({ y: F.y, m: F.m });
  }, Bn = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Oe(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Oe(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.calTitle, "aria-label": "연·월 선택", onClick: () => K("month") }, L.y, "년 ", L.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Oe(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Oe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.grid }, Rn.map((A, F) => /* @__PURE__ */ n.createElement("span", { key: A, className: [ae.wd, F === 0 ? ae.sun : "", F === 6 ? ae.sat : ""].join(" ") }, A)), Ji(L.y, L.m).map((A) => {
    const F = qe(A, "date"), re = je(A), ie = [
      ae.day,
      A.m !== L.m ? ae.out : "",
      re === 0 ? ae.sun : "",
      re === 6 ? ae.sat : "",
      F === qe(gt, "date") ? ae.today : "",
      Ie && F === qe(Ie, "date") ? ae.sel : ""
    ].join(" "), me = !E(F);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: F,
        type: "button",
        tabIndex: -1,
        className: ie,
        disabled: me,
        "aria-label": `${A.y}년 ${A.m}월 ${A.d}일 ${Rn[re]}요일`,
        "aria-pressed": !!Ie && F === qe(Ie, "date"),
        onClick: () => X(F)
      },
      A.d
    );
  }))), vt = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Oe(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: ae.calTitleStatic }, L.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Oe(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.months }, Array.from({ length: 12 }, (A, F) => F + 1).map((A) => {
    const F = !!Ie && Ie.y === L.y && Ie.m === A, re = [ae.mon, F ? ae.sel : "", gt.y === L.y && gt.m === A ? ae.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: A,
        type: "button",
        tabIndex: -1,
        className: re,
        disabled: !jt(L.y, A),
        "aria-pressed": F,
        onClick: () => {
          k ? X(nt({ y: L.y, m: A, d: 1 })) : (te({ y: L.y, m: A }), K("day"));
        }
      },
      A,
      "월"
    );
  }))), kt = qe(gt, a), W = k ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(kt), onClick: () => X(kt) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(kt), onClick: () => X(kt) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(nt({ y: L.y, m: L.m, d: 1 })),
      onClick: () => X(nt({ y: L.y, m: L.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(nt({ y: L.y, m: L.m, d: Le(L.y, L.m) })),
      onClick: () => X(nt({ y: L.y, m: L.m, d: Le(L.y, L.m) }))
    },
    "월말"
  )), fe = [
    ae.wrap,
    o ? ae.disabled : "",
    l ? ae.readOnly : "",
    c && !e && !D ? ae.required : "",
    xe ? ae.invalid : "",
    k ? ae.month : "",
    N
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: O, className: fe, style: w, onBlur: Re }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: V,
      id: p,
      name: _,
      className: ae.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: D,
      placeholder: f != null ? f : k ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: o,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": q,
      "aria-controls": x,
      "aria-label": d,
      "aria-describedby": b,
      "aria-invalid": xe || void 0,
      "aria-required": c || void 0,
      onChange: (A) => {
        var F;
        return z(A.target.value, (F = A.target.selectionStart) != null ? F : A.target.value.length);
      },
      onKeyDown: ce,
      onPaste: Ue
    }
  ), Xe != null && /* @__PURE__ */ n.createElement("span", { className: [ae.weekday, Xe === 0 ? ae.sun : "", Xe === 6 ? ae.sat : ""].join(" "), "aria-hidden": "true" }, "(", Rn[Xe], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: ae.icon,
      disabled: $,
      "aria-label": k ? "월 선택 열기" : "달력 열기",
      onMouseDown: (A) => A.preventDefault(),
      onClick: () => {
        var A;
        (A = V.current) == null || A.focus(), q ? P(!1) : H();
      }
    },
    /* @__PURE__ */ n.createElement(gn, { name: "calendar", size: 15 })
  ), q && /* @__PURE__ */ n.createElement(Yt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: Q,
      id: x,
      className: ae.pop,
      style: { top: ne.top, left: ne.left },
      role: "dialog",
      "aria-label": k ? "월 선택" : "날짜 선택",
      onMouseDown: (A) => A.preventDefault()
    },
    Y === "day" && !k ? Bn() : vt(),
    /* @__PURE__ */ n.createElement("div", { className: ae.foot }, W, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.clear, onClick: () => X("") }, "비우기"))
  )));
}
const St = (e) => String(e).padStart(2, "0");
function Er() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${St(e.getMonth() + 1)}-${St(e.getDate())}`;
}
function fv(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${St(t.getMonth() + 1)}-${St(t.getDate())} ${St(t.getHours())}:${St(t.getMinutes())}:${St(t.getSeconds())}`;
}
function _v(e, t) {
  return !!e && !!t && e <= t;
}
function pv({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: s,
  max: o,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: m,
  onReject: u
}) {
  const f = !!e && !!t && e > t, p = /* @__PURE__ */ new Date(), _ = i === !1 ? [] : Array.isArray(i) ? i : Zi({ y: p.getFullYear(), m: p.getMonth() + 1, d: p.getDate() }, r), y = (d) => (!s || d.from >= s) && (!o || d.to <= o);
  return /* @__PURE__ */ n.createElement("span", { className: ae.range }, /* @__PURE__ */ n.createElement(
    Da,
    {
      value: e,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 시작일`,
      onChange: (d) => a(d, t),
      onReject: u && ((d, b) => u(d, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: ae.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    Da,
    {
      value: t,
      mode: r,
      min: s,
      max: o,
      disabled: l,
      showWeekday: m,
      "aria-label": `${c} 종료일`,
      onChange: (d) => a(e, d),
      onReject: u && ((d, b) => u(d, b, "to"))
    }
  ), _.length > 0 && /* @__PURE__ */ n.createElement(
    Xs,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: _.map((d) => Ps(
        d.label,
        d.label,
        () => a(d.from, d.to),
        y(d) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), f && /* @__PURE__ */ n.createElement("span", { className: ae.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const gr = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function vr(e, t = gr) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const s of t) s.start <= e.slice(0, 10) && (!r || s.start > r.start) && (r = s);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function Au(e, t = {}) {
  const a = vr(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function yv(e, t) {
  const a = vr(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Se = 1440, kn = (e) => String(e).padStart(2, "0");
function ye(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function Tt(e) {
  const t = new Date(e * 6e4);
  return tt(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function an(e) {
  const t = new Date(e * 6e4);
  return `${Tt(e)}T${kn(t.getUTCHours())}:${kn(t.getUTCMinutes())}`;
}
function Ze(e) {
  const t = (e % Se + Se) % Se;
  return `${kn(Math.floor(t / 60))}:${kn(t % 60)}`;
}
function ke(e, t) {
  return de(e) ? Cn(e, t) : e;
}
function Kt(e, t) {
  return Math.round((ye(t) - ye(e)) / Se);
}
function un(e) {
  if (!de(e)) return !1;
  const t = ca(e);
  return t === 0 || t === 6;
}
function Cu(e) {
  var s;
  const t = ye(e.start);
  if (Number.isNaN(t)) return null;
  const a = (s = e.allDay) != null ? s : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const o = Tt(t), l = e.end ? Tt(ye(e.end)) : o, c = l < o ? o : l;
    return { ev: e, s: ye(o), e: ye(c) + Se, allDay: a, sDay: o, eDay: c };
  }
  let r = e.end ? ye(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: Tt(t), eDay: Tt(r - 1) };
}
function Sn(e, t, a, r) {
  const s = [];
  for (const o of e) {
    const l = r && o.id === r.id ? { ...o, start: r.start, end: r.end } : o, c = Cu(l);
    c && c.eDay >= t && c.sDay <= a && s.push(c);
  }
  return s.sort(Su);
}
function Su(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Kt(t.sDay, t.eDay) - Kt(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function Mu(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function kr(e) {
  return e.allDay || e.e - e.s >= Se;
}
function wn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (je(a) - t + 7) % 7;
  return ke(e, -r);
}
function Mn(e, t) {
  const a = Kt(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, s) => ke(e, s));
}
function wr(e, t) {
  const a = de(e), r = tt(a.y, a.m, 1), s = tt(a.y, a.m, Le(a.y, a.m)), o = wn(r, t), l = ke(wn(s, t), 6), c = Mn(o, l), i = [];
  for (let m = 0; m < c.length; m += 7) i.push(c.slice(m, m + 7));
  return i;
}
function ia(e, t, a) {
  if (e === "month") {
    const r = wr(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: tt(r.y, r.m, 1), to: tt(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = wn(t, a);
    return { from: r, to: ke(r, 6) };
  }
  return { from: t, to: t };
}
function Tu(e, t, a, r = !1) {
  const s = de(t);
  if (!s) return t;
  if (e === "month" || e === "agenda") {
    const l = Et(s, a);
    return tt(l.y, l.m, l.d);
  }
  if (e === "week") return ke(t, 7 * a);
  let o = ke(t, a);
  for (; r && un(o); ) o = ke(o, a);
  return o;
}
function qu(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: s, to: o } = ia("week", t, a);
  return r.year(s) !== r.year(o) ? `${r.ymd(s)} – ${r.ymd(o)}` : s.slice(5, 7) !== o.slice(5, 7) ? `${r.ymd(s)} – ${r.md(o)}` : `${r.ymd(s)} – ${r.d(o)}`;
}
function Nr(e, t) {
  const a = [], r = [];
  for (const s of e) {
    let o = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= s.sDay && t[i] <= s.eDay && (o < 0 && (o = i), l = i);
    if (o < 0) continue;
    let c = r.findIndex((i) => i < o);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: s, col: o, span: l - o + 1, lane: c, contL: s.sDay < t[o], contR: s.eDay > t[l] });
  }
  return a;
}
function Bu(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const s = Math.max(1, a), o = e.filter((c) => {
    if (c.lane < s - 1) return !0;
    if (c.lane > s - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > s) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of o) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: o, more: r.map((c, i) => c - l[i]) };
}
const Lu = 20;
function ju(e, t) {
  const a = ye(t), r = a + Se, s = e.filter((m) => !kr(m) && m.s < r && m.e > a).map((m) => ({
    item: m,
    top: Math.max(m.s, a) - a,
    bottom: Math.min(m.e, r) - a,
    col: 0,
    cols: 1,
    contTop: m.s < a,
    contBottom: m.e > r
  })).sort((m, u) => m.top - u.top || u.bottom - m.bottom);
  let o = [], l = [], c = -1;
  const i = () => {
    for (const m of o) m.cols = l.length;
    o = [], l = [];
  };
  for (const m of s) {
    m.top >= c && i();
    const u = Math.max(m.bottom, m.top + Lu);
    let f = l.findIndex((p) => p <= m.top);
    f < 0 ? (f = l.length, l.push(u)) : l[f] = u, m.col = f, o.push(m), c = Math.max(c, u);
  }
  return i(), s;
}
function Aa(e, t) {
  return Math.round(e / t) * t;
}
function Qn(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Se);
    return { start: ke(e.sDay, a), end: ke(e.eDay, a) };
  }
  return { start: an(e.s + t), end: an(e.e + t) };
}
function ua(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = ye(e.sDay), r = Ze(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Se ? "24:00" : Ze(e.e - a)}`;
  const s = de(e.sDay), o = de(Tt(e.e));
  return `${s.m}/${s.d} ${r} – ${o.m}/${o.d} ${Ze(e.e - ye(Tt(e.e)))}`;
}
const Ae = (e) => {
  const t = de(e);
  return { ...t, w: je(t) };
};
function Ca(e, t, a, r, s) {
  const o = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return o;
  const l = Au(e, { eras: r, gannen: s });
  return l ? t === "era" ? l : `${o}(${l})` : o;
}
function Ru(e = "ko", t = {}) {
  var i, m;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (m = t.eras) != null ? m : gr, s = t.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], f = (_) => Ca(_, a, "年", r, s), p = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (_) => `前の${p[_]} (P)`,
      next: (_) => `次の${p[_]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (_) => `他${_}件`,
      eventCount: (_) => `予定${_}件`,
      dayOfSpan: (_, y) => `${_}/${y}日目`,
      openDay: (_) => {
        const y = Ae(_);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: f,
      ym: (_) => `${f(_)}${Ae(_).m}月`,
      ymd: (_) => {
        const y = Ae(_);
        return `${f(_)}${y.m}月${y.d}日`;
      },
      md: (_) => {
        const y = Ae(_);
        return `${y.m}月${y.d}日`;
      },
      d: (_) => `${Ae(_).d}日`,
      m: (_) => `${Ae(_).m}月`,
      dayTitle: (_) => {
        const y = Ae(_);
        return `${f(_)}${y.m}月${y.d}日(${u[y.w]})`;
      },
      dayAria: (_) => {
        const y = Ae(_);
        return `${y.m}月${y.d}日 ${u[y.w]}曜日`;
      }
    };
  }
  const o = ["일", "월", "화", "수", "목", "금", "토"], l = (u) => Ca(u, a, "년", r, s), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: o,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${c[u]} (P)`,
    next: (u) => `다음 ${c[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, f) => `${u}/${f}일째`,
    openDay: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일 일 보기`;
    },
    year: l,
    ym: (u) => `${l(u)} ${Ae(u).m}월`,
    ymd: (u) => {
      const f = Ae(u);
      return `${l(u)} ${f.m}월 ${f.d}일`;
    },
    md: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일`;
    },
    d: (u) => `${Ae(u).d}일`,
    m: (u) => `${Ae(u).m}월`,
    dayTitle: (u) => {
      const f = Ae(u);
      return `${l(u)} ${f.m}월 ${f.d}일 (${o[f.w]})`;
    },
    dayAria: (u) => {
      const f = Ae(u);
      return `${f.m}월 ${f.d}일 ${o[f.w]}요일`;
    }
  };
}
const $r = Ru("ko"), Iu = "_cal_38qtm_2", Ou = "_toolbar_38qtm_20", Pu = "_navBtns_38qtm_28", Xu = "_title_38qtm_29", zu = "_toolRight_38qtm_36", Fu = "_toggle_38qtm_37", Wu = "_body_38qtm_58", Hu = "_busy_38qtm_59", Ku = "_sun_38qtm_71", Uu = "_sat_38qtm_72", Yu = "_tAccent_38qtm_75", Gu = "_tOk_38qtm_76", Vu = "_tWarn_38qtm_77", Qu = "_tDanger_38qtm_78", Ju = "_tViolet_38qtm_79", Zu = "_tGray_38qtm_80", em = "_month_38qtm_83", tm = "_mHead_38qtm_84", nm = "_wdName_38qtm_85", am = "_mBody_38qtm_91", rm = "_mWeek_38qtm_92", sm = "_mCells_38qtm_94", om = "_cell_38qtm_96", lm = "_out_38qtm_104", cm = "_dayNum_38qtm_105", im = "_creatable_38qtm_106", um = "_selDay_38qtm_109", mm = "_cellHead_38qtm_111", dm = "_isToday_38qtm_124", fm = "_holiday_38qtm_125", _m = "_addHint_38qtm_130", pm = "_barLayer_38qtm_138", ym = "_chip_38qtm_139", bm = "_more_38qtm_139", hm = "_tEv_38qtm_155", Em = "_aRow_38qtm_155", gm = "_popItem_38qtm_155", vm = "_bar_38qtm_138", km = "_contL_38qtm_165", wm = "_contR_38qtm_166", Nm = "_dotChip_38qtm_167", $m = "_dot_38qtm_167", xm = "_chipTime_38qtm_170", Dm = "_chipTitle_38qtm_171", Am = "_movable_38qtm_173", Cm = "_ghost_38qtm_176", Sm = "_time_38qtm_189", Mm = "_tHead_38qtm_190", Tm = "_tAllDay_38qtm_190", qm = "_gutter_38qtm_193", Bm = "_tHeadDays_38qtm_197", Lm = "_tAllDayCells_38qtm_197", jm = "_tDay_38qtm_198", Rm = "_tDayBtn_38qtm_202", Im = "_tWd_38qtm_206", Om = "_tDayNum_38qtm_208", Pm = "_tAllDayRow_38qtm_216", Xm = "_allDayCell_38qtm_218", zm = "_tBody_38qtm_222", Fm = "_tGrid_38qtm_223", Wm = "_tGutter_38qtm_224", Hm = "_tCols_38qtm_230", Km = "_tCol_38qtm_230", Um = "_tSel_38qtm_238", Ym = "_tEvTitle_38qtm_258", Gm = "_tEvTime_38qtm_259", Vm = "_tEvShort_38qtm_261", Qm = "_contTop_38qtm_263", Jm = "_contBottom_38qtm_264", Zm = "_resize_38qtm_265", ed = "_now_38qtm_268", td = "_agenda_38qtm_272", nd = "_aDay_38qtm_273", ad = "_aDate_38qtm_275", rd = "_aDateBtn_38qtm_276", sd = "_aDayNum_38qtm_280", od = "_aDayWd_38qtm_286", ld = "_aList_38qtm_288", cd = "_aTime_38qtm_295", id = "_aTitle_38qtm_296", ud = "_aSpan_38qtm_297", md = "_aLoc_38qtm_298", dd = "_empty_38qtm_303", fd = "_pop_38qtm_155", _d = "_popHead_38qtm_321", pd = "_popDay_38qtm_322", yd = "_popClose_38qtm_329", bd = "_popList_38qtm_334", hd = "_tAllDayOnly_38qtm_348", C = {
  cal: Iu,
  toolbar: Ou,
  navBtns: Pu,
  title: Xu,
  toolRight: zu,
  toggle: Fu,
  body: Wu,
  busy: Hu,
  sun: Ku,
  sat: Uu,
  tAccent: Yu,
  tOk: Gu,
  tWarn: Vu,
  tDanger: Qu,
  tViolet: Ju,
  tGray: Zu,
  month: em,
  mHead: tm,
  wdName: nm,
  mBody: am,
  mWeek: rm,
  mCells: sm,
  cell: om,
  out: lm,
  dayNum: cm,
  creatable: im,
  selDay: um,
  cellHead: mm,
  isToday: dm,
  holiday: fm,
  addHint: _m,
  barLayer: pm,
  chip: ym,
  more: bm,
  tEv: hm,
  aRow: Em,
  popItem: gm,
  bar: vm,
  contL: km,
  contR: wm,
  dotChip: Nm,
  dot: $m,
  chipTime: xm,
  chipTitle: Dm,
  movable: Am,
  ghost: Cm,
  time: Sm,
  tHead: Mm,
  tAllDay: Tm,
  gutter: qm,
  tHeadDays: Bm,
  tAllDayCells: Lm,
  tDay: jm,
  tDayBtn: Rm,
  tWd: Im,
  tDayNum: Om,
  tAllDayRow: Pm,
  allDayCell: Xm,
  tBody: zm,
  tGrid: Fm,
  tGutter: Wm,
  tCols: Hm,
  tCol: Km,
  tSel: Um,
  tEvTitle: Ym,
  tEvTime: Gm,
  tEvShort: Vm,
  contTop: Qm,
  contBottom: Jm,
  resize: Zm,
  now: ed,
  agenda: td,
  aDay: nd,
  aDate: ad,
  aDateBtn: rd,
  aDayNum: sd,
  aDayWd: od,
  aList: ld,
  aTime: cd,
  aTitle: id,
  aSpan: ud,
  aLoc: md,
  empty: dd,
  pop: fd,
  popHead: _d,
  popDay: pd,
  popClose: yd,
  popList: bd,
  tAllDayOnly: hd
}, mn = 22, Ed = {
  accent: C.tAccent,
  ok: C.tOk,
  warn: C.tWarn,
  danger: C.tDanger,
  violet: C.tViolet,
  gray: C.tGray
};
function Tn(e) {
  var t;
  return e.color ? "" : Ed[(t = e.tone) != null ? t : "accent"];
}
function qn(e) {
  if (e.color)
    return { "--ev": e.color };
}
function xr(e, t) {
  return [e.ev.title, ua(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const rn = (e, t) => !!e.onEventChange && !t.locked;
function En(e, t, a) {
  var r;
  for (const s of document.elementsFromPoint(e, t)) {
    const o = (r = s.closest) == null ? void 0 : r.call(s, `[${a}]`);
    if (o) return o;
  }
  return null;
}
function Nn(e, t) {
  const a = e.clientX, r = e.clientY;
  let s = !1;
  const o = (u) => {
    !s && Math.hypot(u.clientX - a, u.clientY - r) < 4 || (s = !0, t.move(u));
  }, l = () => {
    window.removeEventListener("pointermove", o), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", m, !0);
  }, c = (u) => {
    l(), t.end(u, s);
  }, i = () => {
    l(), t.cancel();
  }, m = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), i());
  };
  window.addEventListener("pointermove", o), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", m, !0);
}
function Dr(e) {
  const [t, a] = M(null), [r, s] = M(null), o = j(!1);
  return { preview: t, items: (f, p) => Sn(e.events, f, p, t), onItemDown: (f, p) => {
    var d;
    if (f.button !== 0 || !rn(e, p.ev)) return;
    const _ = (d = En(f.clientX, f.clientY, "data-cal-day")) == null ? void 0 : d.dataset.calDay;
    if (!_) return;
    o.current = !1;
    let y = 0;
    Nn(f, {
      move: (b) => {
        var w;
        o.current = !0;
        const N = (w = En(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : w.dataset.calDay;
        N && (y = Kt(_, N), a({ id: p.ev.id, ...Qn(p, y * Se) }));
      },
      end: (b, N) => {
        var w;
        a(null), N && y && ((w = e.onEventChange) == null || w.call(e, p.ev, Qn(p, y * Se)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (f, p) => {
    if (f.button !== 0 || !e.onCreate) return;
    f.preventDefault();
    let _ = p;
    s({ a: p, b: p }), Nn(f, {
      move: (y) => {
        var b;
        const d = (b = En(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        d && (_ = d, s({ a: p, b: d }));
      },
      end: () => {
        var b;
        s(null);
        const [y, d] = p <= _ ? [p, _] : [_, p];
        (b = e.onCreate) == null || b.call(e, { start: y, end: d, allDay: !0 });
      },
      cancel: () => s(null)
    });
  }, clickItem: (f, p) => {
    var _;
    if (o.current) {
      o.current = !1;
      return;
    }
    (_ = e.onEventClick) == null || _.call(e, p, f);
  }, inSel: (f) => !!r && f >= (r.a < r.b ? r.a : r.b) && f <= (r.a < r.b ? r.b : r.a) };
}
function Ar({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: s
}) {
  return /* @__PURE__ */ n.createElement("div", { className: C.barLayer }, e.map((o) => {
    var f;
    const l = o.item, c = l.ev, i = Mu(l), m = Ze(l.s - ye(l.sDay)), u = [
      C.chip,
      i ? C.bar : C.dotChip,
      Tn(c),
      o.contL ? C.contL : "",
      o.contR ? C.contR : "",
      ((f = s.preview) == null ? void 0 : f.id) === c.id ? C.ghost : "",
      rn(r, c) ? C.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${o.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${o.col / t * 100}% + 2px)`,
          width: `calc(${o.span / t * 100}% - 4px)`,
          top: a + o.lane * mn,
          ...qn(c)
        },
        "aria-label": xr(l, r.L),
        onPointerDown: (p) => s.onItemDown(p, l),
        onClick: (p) => s.clickItem(p.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: C.chipTitle }, !l.allDay && !o.contL && /* @__PURE__ */ n.createElement("span", { className: C.chipTime }, m), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: C.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: C.chipTime }, m), /* @__PURE__ */ n.createElement("span", { className: C.chipTitle }, c.title))
    );
  }));
}
const On = 26;
function gd({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: s, showWeekends: o, holidays: l } = e, c = a.slice(0, 7), i = we(
    () => wr(a, s).map((x) => o ? x : x.filter((g) => !un(g))),
    [a, s, o]
  ), m = i[0].length, u = Dr(e), f = u.items(i[0][0], i[i.length - 1][m - 1]), p = j(null), [_, y] = M(0);
  Be(() => {
    const x = p.current;
    if (!x) return;
    const g = () => y(x.clientHeight / i.length);
    if (g(), typeof ResizeObserver == "undefined") return;
    const h = new ResizeObserver(g);
    return h.observe(x), () => h.disconnect();
  }, [i.length]);
  const d = _ ? Math.max(1, Math.floor((_ - On - 4) / mn)) : 3, b = j(!1), N = j(null);
  Z(() => {
    var x, g;
    b.current && (b.current = !1, (g = (x = N.current) == null ? void 0 : x.querySelector(`[data-cal-day="${a}"]`)) == null || g.focus());
  }, [a, c]);
  const w = (x, g) => {
    let h = ke(x, g);
    for (; !o && un(h); ) h = ke(h, g > 0 ? 1 : -1);
    return h;
  }, k = (x, g, h) => {
    let E = null;
    if (x.key === "ArrowLeft") E = w(g, -1);
    else if (x.key === "ArrowRight") E = w(g, 1);
    else if (x.key === "ArrowUp") E = w(g, -7);
    else if (x.key === "ArrowDown") E = w(g, 7);
    else if (x.key === "Home") E = h[0];
    else if (x.key === "End") E = h[h.length - 1];
    else if (x.key === "Enter" || x.key === " ") {
      x.preventDefault(), e.goto("day", g);
      return;
    }
    E && (x.preventDefault(), b.current = !0, e.setCursor(E));
  };
  return /* @__PURE__ */ n.createElement("div", { className: C.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: N }, /* @__PURE__ */ n.createElement("div", { className: C.mHead, role: "row" }, i[0].map((x) => {
    const g = je(de(x));
    return /* @__PURE__ */ n.createElement("div", { key: x, role: "columnheader", className: [C.wdName, g === 0 ? C.sun : "", g === 6 ? C.sat : ""].join(" ") }, t.weekdays[g]);
  })), /* @__PURE__ */ n.createElement("div", { className: C.mBody, ref: p }, i.map((x) => {
    const { shown: g, more: h } = Bu(Nr(f, x), m, d);
    return /* @__PURE__ */ n.createElement("div", { key: x[0], className: C.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: C.mCells, style: { gridTemplateColumns: `repeat(${m}, minmax(0, 1fr))` } }, x.map((E) => {
      const $ = de(E), D = je($), S = l[E], T = f.filter((q) => q.sDay <= E && q.eDay >= E).length, I = [
        C.cell,
        E.slice(0, 7) !== c ? C.out : "",
        D === 0 || S ? C.sun : D === 6 ? C.sat : "",
        E === r ? C.isToday : "",
        u.inSel(E) ? C.selDay : "",
        e.onCreate ? C.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: E,
          role: "gridcell",
          "data-cal-day": E,
          tabIndex: E === a ? 0 : -1,
          "aria-selected": E === a,
          "aria-current": E === r ? "date" : void 0,
          "aria-label": `${t.dayAria(E)}${S ? ` ${S}` : ""}, ${t.eventCount(T)}`,
          className: I,
          onPointerDown: (q) => u.onCellDown(q, E),
          onKeyDown: (q) => k(q, E, x)
        },
        /* @__PURE__ */ n.createElement("div", { className: C.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: C.dayNum,
            "aria-label": t.openDay(E),
            onPointerDown: (q) => q.stopPropagation(),
            onClick: () => e.goto("day", E)
          },
          $.d === 1 ? t.md(E) : $.d
        ), S && /* @__PURE__ */ n.createElement("span", { className: C.holiday, title: S }, S), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: C.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(Ar, { segs: g, cols: m, top: On, ctx: e, drag: u }), h.map((E, $) => E > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: x[$],
        type: "button",
        className: C.more,
        style: {
          left: `calc(${$ / m * 100}% + 2px)`,
          width: `calc(${100 / m}% - 4px)`,
          top: On + (d - 1) * mn
        },
        onClick: (D) => e.openMore(x[$], D.currentTarget)
      },
      t.more(E)
    ) : null));
  })));
}
const Qe = 44, vd = Array.from({ length: 23 }, (e, t) => t + 1);
function Sa() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function Pn(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Se, (e - a.top) / Qe * 60));
}
function Ma({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, s = Dr(e), [o, l] = M(null), [c, i] = M(null), m = j(!1), u = Sn(e.events, t[0], t[a - 1], o != null ? o : s.preview), f = Nr(e.timeGrid ? u.filter(kr) : u, t), p = f.reduce((g, h) => Math.max(g, h.lane + 1), 0), _ = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, d] = M(Sa);
  Z(() => {
    const g = window.setInterval(() => d(Sa()), 6e4);
    return () => window.clearInterval(g);
  }, []);
  const b = j(null), N = t.includes(e.today);
  Be(() => {
    const g = b.current;
    if (!g) return;
    const h = N ? Math.max(0, Math.floor((y - ye(e.today)) / 60) - 1) : e.scrollToHour;
    g.scrollTop = h * Qe;
  }, [t[0], a]);
  const w = (g, h) => {
    if (g.button !== 0 || !e.onCreate) return;
    g.preventDefault();
    const E = g.currentTarget, $ = Math.min(Se - r, Math.floor(Pn(g.clientY, E) / r) * r);
    let D = $;
    i({ day: h, a: $, b: $ + r }), Nn(g, {
      move: (S) => {
        D = Math.min(Se - r, Math.floor(Pn(S.clientY, E) / r) * r), i({ day: h, a: Math.min($, D), b: Math.max($, D) + r });
      },
      end: (S, T) => {
        var Y;
        i(null);
        const I = ye(h), q = T ? Math.min($, D) : $, P = T ? Math.max($, D) + r : Math.min($ + 60, Se);
        (Y = e.onCreate) == null || Y.call(e, { start: an(I + q), end: an(I + P), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, k = (g, h, E) => {
    if (g.stopPropagation(), g.button !== 0 || !rn(e, h.ev)) return;
    const $ = (T, I) => {
      const q = En(T, I, "data-cal-col");
      return q ? ye(q.dataset.calCol) + Pn(I, q) : null;
    }, D = $(g.clientX, g.clientY);
    if (D == null) return;
    m.current = !1;
    let S = null;
    Nn(g, {
      move: (T) => {
        m.current = !0;
        const I = $(T.clientX, T.clientY);
        if (I != null) {
          if (E === "move") {
            const q = Aa(I - D, r);
            S = q ? Qn(h, q) : null;
          } else {
            const q = Math.max(h.s + r, Aa(I, r));
            S = q !== h.e ? { start: h.ev.start, end: an(q) } : null;
          }
          l(S ? { id: h.ev.id, ...S } : null);
        }
      },
      end: (T, I) => {
        var q;
        l(null), I && S && ((q = e.onEventChange) == null || q.call(e, h.ev, S));
      },
      cancel: () => l(null)
    });
  }, x = (g, h) => {
    var E;
    if (m.current) {
      m.current = !1;
      return;
    }
    (E = e.onEventClick) == null || E.call(e, h, g);
  };
  return /* @__PURE__ */ n.createElement("div", { className: C.time }, /* @__PURE__ */ n.createElement("div", { className: C.tHead }, /* @__PURE__ */ n.createElement("div", { className: C.gutter }), /* @__PURE__ */ n.createElement("div", { className: C.tHeadDays, style: _ }, t.map((g) => {
    const h = de(g), E = je(h), $ = e.holidays[g];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: g,
        className: [C.tDay, g === e.today ? C.isToday : "", E === 0 || $ ? C.sun : E === 6 ? C.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: C.tDayBtn, onClick: () => e.goto("day", g), "aria-label": e.L.openDay(g) }, /* @__PURE__ */ n.createElement("span", { className: C.tWd }, e.L.weekdays[E]), /* @__PURE__ */ n.createElement("span", { className: C.tDayNum }, h.d)),
      $ && /* @__PURE__ */ n.createElement("span", { className: C.holiday, title: $ }, $)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: [C.tAllDay, e.timeGrid ? "" : C.tAllDayOnly].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: C.gutter }, e.timeGrid ? e.L.allDay : ""), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: C.tAllDayRow,
      style: e.timeGrid ? { height: Math.max(1, p) * mn + 6 } : { minHeight: Math.max(1, p) * mn + 6 }
    },
    /* @__PURE__ */ n.createElement("div", { className: C.tAllDayCells, style: _ }, t.map((g) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: g,
        "data-cal-day": g,
        className: [C.allDayCell, s.inSel(g) ? C.selDay : "", e.onCreate ? C.creatable : ""].join(" "),
        onPointerDown: (h) => s.onCellDown(h, g)
      }
    ))),
    /* @__PURE__ */ n.createElement(Ar, { segs: f, cols: a, top: 3, ctx: e, drag: s })
  )), e.timeGrid && /* @__PURE__ */ n.createElement("div", { className: C.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: C.tGrid, style: { height: 24 * Qe } }, /* @__PURE__ */ n.createElement("div", { className: C.tGutter, "aria-hidden": !0 }, vd.map((g) => /* @__PURE__ */ n.createElement("span", { key: g, style: { top: g * Qe } }, Ze(g * 60)))), /* @__PURE__ */ n.createElement("div", { className: C.tCols, style: { ..._, backgroundSize: `100% ${Qe}px` } }, t.map((g) => {
    const h = ju(u, g);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: g,
        "data-cal-col": g,
        className: [C.tCol, g === e.today ? C.isToday : "", e.onCreate ? C.creatable : ""].join(" "),
        onPointerDown: (E) => w(E, g)
      },
      (c == null ? void 0 : c.day) === g && /* @__PURE__ */ n.createElement("div", { className: C.tSel, style: { top: c.a / 60 * Qe, height: (c.b - c.a) / 60 * Qe } }, Ze(c.a), " – ", c.b === Se ? "24:00" : Ze(c.b)),
      h.map((E) => {
        const $ = E.item.ev, D = (E.bottom - E.top) / 60 * Qe, S = [
          C.tEv,
          Tn($),
          D < 34 ? C.tEvShort : "",
          E.contTop ? C.contTop : "",
          E.contBottom ? C.contBottom : "",
          (o == null ? void 0 : o.id) === $.id ? C.ghost : "",
          rn(e, $) ? C.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: $.id,
            type: "button",
            className: S,
            style: {
              top: E.top / 60 * Qe,
              height: Math.max(18, D - 1),
              left: `calc(${E.col / E.cols * 100}% + 1px)`,
              width: `calc(${100 / E.cols}% - 4px)`,
              ...qn($)
            },
            "aria-label": xr(E.item, e.L),
            onPointerDown: (T) => k(T, E.item, "move"),
            onClick: (T) => x(T.currentTarget, $)
          },
          /* @__PURE__ */ n.createElement("span", { className: C.tEvTitle }, $.title),
          /* @__PURE__ */ n.createElement("span", { className: C.tEvTime }, ua(E.item, e.L.allDay)),
          rn(e, $) && !E.contBottom && /* @__PURE__ */ n.createElement("span", { className: C.resize, "aria-hidden": !0, onPointerDown: (T) => k(T, E.item, "resize") })
        );
      }),
      g === e.today && /* @__PURE__ */ n.createElement("div", { className: C.now, style: { top: (y - ye(g)) / 60 * Qe }, "aria-hidden": !0 })
    );
  })))));
}
function Ta(e, t, a) {
  return e.sDay === e.eDay ? ua(e, a) : e.allDay ? a : t === e.sDay ? `${Ze(e.s - ye(t))} ~` : t === e.eDay ? `~ ${Ze(e.e - ye(t))}` : a;
}
function kd({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = ia("agenda", e.cursor, e.weekStartsOn), s = Sn(e.events, a, r), o = Mn(a, r).filter((l) => e.showWeekends || !un(l)).map((l) => {
    const c = ye(l), i = (u) => Ta(u, l, "") === "" ? -1 : Math.max(u.s, c), m = s.filter((u) => u.sDay <= l && u.eDay >= l);
    return { day: l, list: m.sort((u, f) => i(u) - i(f)) };
  }).filter((l) => l.list.length > 0);
  return o.length ? /* @__PURE__ */ n.createElement("div", { className: C.agenda }, o.map(({ day: l, list: c }) => {
    const i = de(l), m = e.holidays[l], u = je(i), f = t.weekdays[u];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [C.aDay, l === e.today ? C.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [C.aDate, u === 0 || m ? C.sun : u === 6 ? C.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: C.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: C.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: C.aDayWd }, t.m(l), " · ", f)), m && /* @__PURE__ */ n.createElement("span", { className: C.holiday }, m)), /* @__PURE__ */ n.createElement("ul", { className: C.aList }, c.map((p) => {
      const _ = p.ev, y = Kt(p.sDay, p.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: _.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [C.aRow, Tn(_)].join(" "),
          style: qn(_),
          onClick: (d) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, _, d.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: C.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: C.aTime }, Ta(p, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: C.aTitle }, _.title, y > 1 && /* @__PURE__ */ n.createElement("em", { className: C.aSpan }, t.dayOfSpan(Kt(p.sDay, l) + 1, y))),
        _.location && /* @__PURE__ */ n.createElement("span", { className: C.aLoc }, _.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: C.empty }, t.empty);
}
const Xn = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function qa(e, t, a) {
  const [r, s] = M(t), o = e !== void 0 ? e : r;
  return [o, (c) => {
    e === void 0 && s(c), c !== o && (a == null || a(c));
  }];
}
const Ba = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function bv({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: s,
  defaultDate: o,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: m = !0,
  weekendToggle: u = !0,
  holidays: f,
  slotMinutes: p = 30,
  scrollToHour: _ = 8,
  timeGrid: y = !0,
  onRangeChange: d,
  onEventClick: b,
  onCreate: N,
  onEventChange: w,
  locale: k = $r,
  loading: x,
  headerExtra: g,
  className: h = "",
  style: E,
  "aria-label": $
}) {
  var G;
  const D = Er(), [S, T] = qa(t, (G = a != null ? a : c[0]) != null ? G : "month", r), [I, q] = qa(s, o != null ? o : D, l), P = de(I) ? I : D, [Y, K] = M(m), [L, te] = M(null), ne = j(null), v = j(!1);
  Z(() => {
    var H;
    if (!v.current) return;
    v.current = !1;
    const X = ne.current;
    !X || X.contains(document.activeElement) || ((H = X.querySelector('[data-cal-day][tabindex="0"]')) != null ? H : X).focus();
  });
  const { from: O, to: V } = ia(S, P, i), Q = j(d);
  Q.current = d, Z(() => {
    var X;
    (X = Q.current) == null || X.call(Q, { from: O, to: V, view: S });
  }, [O, V, S]);
  const se = (X, H) => {
    q(H), c.includes(X) && T(X);
  }, B = {
    events: e,
    L: k,
    cursor: P,
    today: D,
    weekStartsOn: i,
    showWeekends: Y,
    holidays: f != null ? f : {},
    slotMinutes: p,
    scrollToHour: _,
    timeGrid: y,
    setCursor: q,
    goto: se,
    openMore: (X, H) => te({ day: X, anchor: H }),
    onEventClick: b,
    onCreate: N,
    onEventChange: w
  }, J = (X) => q(Tu(S, P, X, S === "day" && !Y)), R = (X) => {
    if (X.defaultPrevented || X.ctrlKey || X.metaKey || X.altKey || X.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const H = X.nativeEvent.code;
    if (H === "KeyT") q(D);
    else if (H === "KeyN" || H === "KeyJ" || X.key === "PageDown") J(1);
    else if (H === "KeyP" || H === "KeyK" || X.key === "PageUp") J(-1);
    else if (Xn[H] && c.includes(Xn[H])) T(Xn[H]);
    else if (H === "KeyC" && N)
      N(S === "month" || S === "agenda" ? { start: P, end: P, allDay: !0 } : { start: `${P}T09:00`, end: `${P}T10:00`, allDay: !1 });
    else return;
    X.preventDefault(), v.current = !0;
  }, z = we(
    () => Mn(O, V).filter((X) => Y || !un(X)),
    [O, V, Y]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [C.cal, h].filter(Boolean).join(" "),
      style: E,
      role: "region",
      "aria-label": $ != null ? $ : k.region,
      "aria-busy": x || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: R,
      ref: ne,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: C.toolbar }, /* @__PURE__ */ n.createElement(Wt, { onClick: () => q(D), title: `${k.today} (T)` }, k.today), /* @__PURE__ */ n.createElement("span", { className: C.navBtns }, /* @__PURE__ */ n.createElement(Yn, { label: k.prev(S), onClick: () => J(-1) }, /* @__PURE__ */ n.createElement(Ba, { dir: "l" })), /* @__PURE__ */ n.createElement(Yn, { label: k.next(S), onClick: () => J(1) }, /* @__PURE__ */ n.createElement(Ba, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: C.title, "aria-live": "polite" }, qu(S, P, i, k)), /* @__PURE__ */ n.createElement("span", { className: C.toolRight }, g, u && S !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: C.toggle,
        "aria-pressed": !Y,
        onClick: () => K((X) => !X)
      },
      k.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      cr,
      {
        variant: "segmented",
        "aria-label": k.viewTabs,
        items: c.map((X) => ({ key: X, label: k.views[X] })),
        value: S,
        onChange: (X) => T(X)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: C.body }, x && /* @__PURE__ */ n.createElement("div", { className: C.busy, role: "progressbar", "aria-label": k.loading }), S === "month" && /* @__PURE__ */ n.createElement(gd, { ctx: B }), S === "week" && /* @__PURE__ */ n.createElement(Ma, { ctx: B, days: z }), S === "day" && /* @__PURE__ */ n.createElement(Ma, { ctx: B, days: [P] }), S === "agenda" && /* @__PURE__ */ n.createElement(kd, { ctx: B })),
    L && /* @__PURE__ */ n.createElement(wd, { ctx: B, day: L.day, anchor: L.anchor, onClose: () => te(null) })
  );
}
function wd({ ctx: e, day: t, anchor: a, onClose: r }) {
  const s = j(null), [o, l] = M({ top: -9999, left: -9999 }), c = de(t), i = Sn(e.events, t, t);
  return Be(() => {
    var _;
    const m = s.current;
    if (!m) return;
    const u = a.getBoundingClientRect(), f = m.offsetWidth, p = m.offsetHeight;
    l({
      left: Math.max(8, Math.min(u.left + u.width / 2 - f / 2, window.innerWidth - f - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - p - 8))
    }), (_ = m.querySelector("[data-cal-pop-item]")) == null || _.focus();
  }, [a]), Z(() => {
    const m = () => {
      r(), a.isConnected && a.focus();
    }, u = (p) => {
      var _;
      (_ = s.current) != null && _.contains(p.target) || r();
    }, f = (p) => {
      p.key !== "Escape" || p.isComposing || (p.preventDefault(), p.stopPropagation(), m());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", f, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Yt, null, /* @__PURE__ */ n.createElement("div", { ref: s, className: C.pop, style: o, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: C.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: C.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[je(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: C.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: C.popList }, i.map((m) => {
    const u = m.ev, f = m.allDay || m.sDay !== m.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: u.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [C.popItem, f ? C.bar : C.dotChip, Tn(u)].join(" "),
        style: qn(u),
        onClick: () => {
          var p;
          r(), (p = e.onEventClick) == null || p.call(e, u, a);
        }
      },
      !f && /* @__PURE__ */ n.createElement("i", { className: C.dot, "aria-hidden": !0 }),
      !m.allDay && /* @__PURE__ */ n.createElement("span", { className: C.chipTime }, Ze(Math.max(m.s, ye(t)) - ye(t))),
      /* @__PURE__ */ n.createElement("span", { className: C.chipTitle }, u.title)
    ));
  }))));
}
const Nd = "_mini_q7p5n_3", $d = "_nav_q7p5n_5", xd = "_navBtn_q7p5n_6", Dd = "_todayBtn_q7p5n_6", Ad = "_title_q7p5n_6", Cd = "_day_q7p5n_25", Sd = "_mon_q7p5n_25", Md = "_grid_q7p5n_29", Td = "_wdRow_q7p5n_30", qd = "_row_q7p5n_30", Bd = "_sun_q7p5n_35", Ld = "_sat_q7p5n_36", jd = "_num_q7p5n_45", Rd = "_sel_q7p5n_46", Id = "_out_q7p5n_50", Od = "_isToday_q7p5n_52", Pd = "_dots_q7p5n_55", Xd = "_months_q7p5n_59", oe = {
  mini: Nd,
  nav: $d,
  navBtn: xd,
  todayBtn: Dd,
  title: Ad,
  day: Cd,
  mon: Sd,
  grid: Md,
  wdRow: Td,
  row: qd,
  sun: Bd,
  sat: Ld,
  num: jd,
  sel: Rd,
  out: Id,
  isToday: Od,
  dots: Pd,
  months: Xd
}, La = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function hv({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: s = {},
  markLabel: o,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = $r,
  today: m,
  children: u,
  className: f = "",
  "aria-label": p
}) {
  const _ = m != null ? m : Er(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${_.slice(0, 7)}-01`, d = de(y), b = wn(y, c), N = Mn(b, ke(b, 41)), w = o != null ? o : i.eventCount, [k, x] = M("day"), [g, h] = M(d.y), E = (K) => !!K && K.slice(0, 7) === y.slice(0, 7), [$, D] = M(() => E(a) ? a : E(_) ? _ : y);
  Z(() => {
    E($) || D(E(a) ? a : E(_) ? _ : y);
  }, [y]);
  const S = j(!1), T = j(null);
  Z(() => {
    var K, L;
    S.current && (S.current = !1, (L = (K = T.current) == null ? void 0 : K.querySelector(`[data-day="${$}"]`)) == null || L.focus());
  }, [$, y]);
  const I = (K) => {
    S.current = !0, D(K), E(K) || t(K.slice(0, 7));
  }, q = (K) => {
    const L = Et(d, K);
    t(La(L.y, L.m));
  }, P = (K, L) => {
    const te = de(L), ne = (je(te) - c + 7) % 7;
    let v = null;
    if (K.key === "ArrowLeft") v = ke(L, -1);
    else if (K.key === "ArrowRight") v = ke(L, 1);
    else if (K.key === "ArrowUp") v = ke(L, -7);
    else if (K.key === "ArrowDown") v = ke(L, 7);
    else if (K.key === "Home") v = ke(L, -ne);
    else if (K.key === "End") v = ke(L, 6 - ne);
    else if (K.key === "PageUp" || K.key === "PageDown") {
      const O = Et(te, K.key === "PageUp" ? -1 : 1);
      v = tt(O.y, O.m, O.d);
    }
    v && (K.preventDefault(), I(v));
  }, Y = () => {
    h(d.y), x("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [oe.mini, f].filter(Boolean).join(" "), role: p ? "group" : void 0, "aria-label": p }, k === "day" ? /* @__PURE__ */ n.createElement("div", { className: oe.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: oe.navBtn, "aria-label": i.prevMonth, onClick: () => q(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: oe.title, "aria-label": `${i.ym(y)}, ${i.pickMonth}`, "aria-live": "polite", onClick: Y }, i.ym(y)), /* @__PURE__ */ n.createElement("button", { type: "button", className: oe.navBtn, "aria-label": i.nextMonth, onClick: () => q(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: oe.todayBtn,
      disabled: E(_),
      onClick: () => {
        t(_.slice(0, 7)), I(_);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: oe.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: oe.navBtn, "aria-label": i.prevYear, onClick: () => h((K) => K - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: oe.title, "aria-live": "polite" }, i.year(`${g}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: oe.navBtn, "aria-label": i.nextYear, onClick: () => h((K) => K + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: oe.todayBtn, onClick: () => x("day"), "aria-label": i.close }, "✕")), k === "month" ? /* @__PURE__ */ n.createElement("div", { className: oe.months, onKeyDown: (K) => {
    K.key === "Escape" && (K.preventDefault(), x("day"));
  } }, Array.from({ length: 12 }, (K, L) => {
    const te = La(g, L + 1), ne = te === y.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: te,
        type: "button",
        className: [oe.mon, ne ? oe.sel : "", te === _.slice(0, 7) ? oe.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": ne,
        autoFocus: ne,
        onClick: () => {
          t(te), x("day");
        }
      },
      i.m(`${te}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: oe.grid, role: "grid", "aria-label": i.ym(y), ref: T }, /* @__PURE__ */ n.createElement("div", { className: oe.wdRow, role: "row" }, N.slice(0, 7).map((K) => {
    const L = je(de(K));
    return /* @__PURE__ */ n.createElement("span", { key: K, role: "columnheader", className: L === 0 ? oe.sun : L === 6 ? oe.sat : "" }, i.weekdays[L]);
  })), [0, 1, 2, 3, 4, 5].map((K) => /* @__PURE__ */ n.createElement("div", { key: K, className: oe.row, role: "row" }, N.slice(K * 7, K * 7 + 7).map((L) => {
    var V;
    const te = je(de(L)), ne = l[L], v = (V = s[L]) != null ? V : 0, O = [
      oe.day,
      E(L) ? "" : oe.out,
      te === 0 || ne ? oe.sun : te === 6 ? oe.sat : "",
      L === _ ? oe.isToday : "",
      L === a ? oe.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: L,
        type: "button",
        role: "gridcell",
        "data-day": L,
        className: O,
        tabIndex: L === $ ? 0 : -1,
        "aria-selected": L === a,
        "aria-current": L === _ ? "date" : void 0,
        "aria-label": [i.dayAria(L), ne, v ? w(v) : ""].filter(Boolean).join(", "),
        onKeyDown: (Q) => P(Q, L),
        onFocus: () => D(L),
        onClick: () => r(L)
      },
      /* @__PURE__ */ n.createElement("span", { className: oe.num }, +L.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: oe.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(v, 3) }, (Q, se) => /* @__PURE__ */ n.createElement("i", { key: se })))
    );
  })))), u);
}
function zd(e) {
  return e.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function ma(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function Cr(e, t = !0) {
  e = ma(e);
  const a = t && /^\s*-/.test(e), r = e.split(".", 1)[0].replace(/[^\d]/g, "");
  return r ? (a ? "-" : "") + r.replace(/^0+(?=\d)/, "") : a ? "-" : "";
}
function Fd(e) {
  var r;
  if (e == null || e === "") return "";
  const t = typeof e == "number" ? String(e) : e.trim(), a = /^(-?)(\d+)(\.\d+)?$/.exec(t);
  return a ? a[1] + zd(a[2]) + ((r = a[3]) != null ? r : "") : t;
}
function Wd(e) {
  const t = Cr(e);
  if (t === "" || t === "-") return;
  const a = Number(t);
  return Number.isFinite(a) ? a : void 0;
}
function Hd(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
function Ev({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: s,
  className: o,
  ...l
}) {
  const c = j(null), i = j(null), [m, u] = M(!1), f = e == null || e === "";
  Be(() => {
    const _ = c.current, y = i.current;
    if (i.current = null, !_ || y === null) return;
    let d = 0, b = 0;
    for (; d < _.value.length && b < y; )
      /\d/.test(_.value[d]) && (b += 1), d += 1;
    d === 0 && _.value[0] === "-" && (d = 1), _.setSelectionRange(d, d);
  });
  const p = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: o,
      value: m && f ? "-" : Fd(e),
      onChange: (_) => {
        var b;
        const y = _.target;
        i.current = Hd(y.value.slice(0, (b = y.selectionStart) != null ? b : y.value.length));
        const d = Cr(y.value, a);
        if (r) {
          const N = ma(y.value);
          !a && /^\s*-/.test(N) ? r("sign") : (/\.\d/.test(N.replace(/^\s*-/, "")) || /\.$/.test(N)) && r("decimal");
        }
        u(d === "-"), t({ text: d, num: Wd(d) });
      }
    }
  );
  return s ? /* @__PURE__ */ n.createElement(n.Fragment, null, p, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, s)) : p;
}
function Jn(e) {
  const t = ma(e).replace(/,/g, "").trim();
  if (t === "") return null;
  const a = Number(t);
  return Number.isFinite(a) ? a : null;
}
function ja(e, t) {
  const a = Jn(e), r = Jn(t);
  return a == null || r == null ? null : Math.round(a * r);
}
function gv(e, t) {
  var o, l;
  const a = ja(e.qty, e.unitAm), r = ja((o = t.qty) != null ? o : e.qty, (l = t.unitAm) != null ? l : e.unitAm);
  if (r == null) return t;
  const s = Jn(e.lineAm);
  return s == null || s === a ? { ...t, lineAm: String(r) } : t;
}
const Kd = "_box_qzg36_3", Ud = "_banner_qzg36_9", Yd = "_verify_qzg36_10", Gd = "_t_info_qzg36_15", Vd = "_t_warn_qzg36_16", Qd = "_t_danger_qzg36_17", Jd = "_error_qzg36_22", Zd = "_note_qzg36_30", ef = "_noteI_qzg36_42", tf = "_noteBody_qzg36_43", nf = "_badge_qzg36_49", af = "_b_muted_qzg36_53", rf = "_b_ok_qzg36_54", sf = "_b_warn_qzg36_55", of = "_b_info_qzg36_56", lf = "_b_off_qzg36_57", Fe = {
  box: Kd,
  banner: Ud,
  verify: Yd,
  t_info: Gd,
  t_warn: Vd,
  t_danger: Qd,
  error: Jd,
  note: Zd,
  noteI: ef,
  noteBody: tf,
  badge: nf,
  b_muted: af,
  b_ok: rf,
  b_warn: sf,
  b_info: of,
  b_off: lf
};
function vv({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Fe.box, Fe.banner, Fe[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function kv({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [Fe.box, Fe.verify, Fe[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Sr({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [Fe.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(cf, { text: t }) : t);
}
function wv({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [Fe.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: Fe.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: Fe.noteBody }, a));
}
function Nv({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", Fe.badge, Fe[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function cf({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(Ur, { key: a }, t))) : null;
}
const uf = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function mf(e, t = uf) {
  const a = j(e);
  return a.current = e, Z(() => {
    if (!e) return;
    const r = (s) => {
      s.preventDefault(), s.returnValue = "";
    };
    return window.addEventListener("beforeunload", r), () => window.removeEventListener("beforeunload", r);
  }, [e]), le(() => !a.current || window.confirm(t), [t]);
}
const df = "_overlay_1qt6w_2", ff = "_modal_1qt6w_8", _f = "_wide_1qt6w_15", pf = "_head_1qt6w_16", yf = "_title_1qt6w_20", bf = "_close_1qt6w_21", hf = "_body_1qt6w_25", Ef = "_flush_1qt6w_26", gf = "_error_1qt6w_27", vf = "_foot_1qt6w_29", Ge = {
  overlay: df,
  modal: ff,
  wide: _f,
  head: pf,
  title: yf,
  close: bf,
  body: hf,
  flush: Ef,
  error: gf,
  foot: vf
}, Mt = [];
function Ra(e) {
  const t = Mt[Mt.length - 1];
  e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc || (e.preventDefault(), t.close());
}
const kf = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Ia(e) {
  return Array.from(e.querySelectorAll(kf)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let Oa = 0, Pa = "";
function da({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: s,
  headerExtra: o,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !1,
  error: m,
  confirmDiscard: u = !0
}) {
  const [f, p] = M(!1), _ = u ? () => {
    f || p(!0);
  } : void 0, y = mf(u && f, "입력한 내용을 저장하지 않고 닫을까요?"), d = () => {
    y() && t();
  }, b = j(d);
  b.current = d;
  const N = j({ close: () => b.current(), esc: i });
  N.current.esc = i, Z(() => {
    const h = N.current;
    return Mt.push(h), Mt.length === 1 && window.addEventListener("keydown", Ra), () => {
      const E = Mt.lastIndexOf(h);
      E >= 0 && Mt.splice(E, 1), Mt.length === 0 && window.removeEventListener("keydown", Ra);
    };
  }, []);
  const w = j(null), k = j(null), x = j(void 0);
  x.current === void 0 && (x.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var $;
    const h = w.current, E = ($ = x.current) != null ? $ : null;
    return h && !h.contains(document.activeElement) && (k.current && Ia(k.current)[0] || null || h).focus(), Oa++ === 0 && (Pa = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Oa === 0 && (document.body.style.overflow = Pa), E && E.isConnected && typeof E.focus == "function" && E.focus();
    };
  }, []);
  const g = (h) => {
    const E = w.current;
    if (h.key !== "Tab" || !E || !E.contains(h.target)) return;
    const $ = Ia(E);
    if ($.length === 0) {
      h.preventDefault(), E.focus();
      return;
    }
    const D = $[0], S = $[$.length - 1], T = document.activeElement;
    h.shiftKey && (T === D || T === E) ? (h.preventDefault(), S.focus()) : !h.shiftKey && T === S && (h.preventDefault(), D.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: Ge.overlay, onClick: c ? d : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: w,
      tabIndex: -1,
      className: [Ge.modal, r ? Ge.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (h) => h.stopPropagation(),
      onKeyDown: g
    },
    /* @__PURE__ */ n.createElement("header", { className: Ge.head }, /* @__PURE__ */ n.createElement("strong", { className: Ge.title }, e), o, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.close, onClick: d, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: k,
        className: [Ge.body, l ? Ge.flush : ""].filter(Boolean).join(" "),
        onInputCapture: _,
        onChangeCapture: _
      },
      a
    ),
    m != null && m !== !1 && m !== "" && /* @__PURE__ */ n.createElement("div", { className: Ge.error }, /* @__PURE__ */ n.createElement(Sr, null, m)),
    s && /* @__PURE__ */ n.createElement("footer", { className: Ge.foot }, s)
  ));
}
function $v(e = 4e3) {
  const [t, a] = M(""), [r, s] = M(!1), o = j(void 0), l = le((m) => {
    window.clearTimeout(o.current), s(!1), a(m), o.current = window.setTimeout(() => a(""), e);
  }, [e]), c = le((m) => {
    window.clearTimeout(o.current), s(!0), a(m);
  }, []), i = le(() => {
    window.clearTimeout(o.current), s(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const wf = "_message_psco6_1", Nf = "_details_psco6_2", $f = "_warn_psco6_7", xf = "_field_psco6_8", pn = {
  message: wf,
  details: Nf,
  warn: $f,
  field: xf
};
function xv() {
  var _, y;
  const [e, t] = M(null), [a, r] = M(""), s = j(null), o = j(null), l = j(null), c = le((d) => new Promise((b) => {
    t({ kind: "confirm", opts: d, resolve: b });
  }), []), i = le((d) => new Promise((b) => {
    var N, w, k, x;
    r((x = (k = d.defaultValue) != null ? k : (w = (N = d.choices) == null ? void 0 : N[0]) == null ? void 0 : w.value) != null ? x : ""), t({ kind: "prompt", opts: d, resolve: b });
  }), []);
  Z(() => {
    var d, b, N;
    e && (e.kind === "prompt" ? (d = l.current) == null || d.focus() : e.opts.danger || e.opts.focusCancel ? (b = o.current) == null || b.focus() : (N = s.current) == null || N.focus());
  }, [e]);
  const m = (d) => {
    e && (e.kind === "confirm" ? e.resolve(d) : e.resolve(d ? a : null), t(null));
  }, u = e == null ? void 0 : e.opts, f = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), p = e && u ? /* @__PURE__ */ n.createElement(
    da,
    {
      title: u.title,
      onClose: () => m(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(Wt, { ref: o, onClick: () => m(!1) }, (_ = u.cancelLabel) != null ? _ : "취소"), /* @__PURE__ */ n.createElement(
        Wt,
        {
          ref: s,
          variant: u.danger ? "danger" : "primary",
          disabled: f,
          onClick: () => m(!0)
        },
        (y = u.confirmLabel) != null ? y : "확인"
      ))
    },
    u.message && /* @__PURE__ */ n.createElement("div", { className: pn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: pn.details }, u.details.map((d, b) => /* @__PURE__ */ n.createElement("li", { key: b }, d))),
    u.irreversible && /* @__PURE__ */ n.createElement("p", { className: pn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: pn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (d) => r(d.target.value) }, e.opts.choices.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.value, value: d.value }, d.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (d) => r(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && !f && (d.preventDefault(), m(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: p };
}
function Dv(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + Df(e);
}
function Df(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
const Af = "_section_dyrr7_3", Cf = "_row_dyrr7_10", Sf = "_label_dyrr7_15", Mf = "_value_dyrr7_21", Tf = "_invalid_dyrr7_43", qf = "_help_dyrr7_45", Bf = "_err_dyrr7_45", Lf = "_req_dyrr7_49", jf = "_opt_dyrr7_50", Rf = "_sr_dyrr7_51", If = "_ro_dyrr7_10", Of = "_readonly_dyrr7_58", Pf = "_hint_dyrr7_65", Xf = "_toggle_dyrr7_73", zf = "_table_dyrr7_80", Ff = "_isReq_dyrr7_95", Ce = {
  section: Af,
  row: Cf,
  label: Sf,
  value: Mf,
  invalid: Tf,
  help: qf,
  err: Bf,
  req: Lf,
  opt: jf,
  sr: Rf,
  ro: If,
  readonly: Of,
  hint: Pf,
  toggle: Xf,
  table: zf,
  isReq: Ff
};
let Wf = 0;
const Hf = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function Av({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: s,
  required: o,
  optional: l,
  help: c,
  error: i,
  className: m = ""
}) {
  var g, h, E, $;
  const u = j(`axe-fr${++Wf}`).current, f = `${u}-lbl`, p = j(null), _ = c ? `${u}-help` : void 0, y = i ? `${u}-err` : void 0, d = [_, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let N = t;
  const w = Un.count(t) === 1 ? Un.toArray(t)[0] : null, k = ln(w) && typeof w.type != "string" && !!w.type.axeFormControl;
  if (ln(w) && (typeof w.type == "string" && Hf.has(w.type) || k)) {
    const D = w, S = D.props;
    N = ra(D, {
      id: (g = S.id) != null ? g : s,
      "aria-describedby": (h = S["aria-describedby"]) != null ? h : d,
      "aria-invalid": (E = S["aria-invalid"]) != null ? E : i ? !0 : void 0,
      "aria-required": ($ = S["aria-required"]) != null ? $ : o ? !0 : void 0
    });
  }
  Be(() => {
    var I;
    const D = (I = p.current) == null ? void 0 : I.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!D) return;
    const S = (q, P) => {
      const Y = `data-fr-${q}`;
      if (P == null) {
        D.hasAttribute(Y) && (D.removeAttribute(q), D.removeAttribute(Y));
        return;
      }
      D.hasAttribute(q) && !D.hasAttribute(Y) || (D.getAttribute(q) !== P && D.setAttribute(q, P), D.setAttribute(Y, ""));
    }, T = !!(D.id && document.querySelector(`label[for="${CSS.escape(D.id)}"]`));
    S("aria-labelledby", T ? null : f), S("aria-invalid", i ? "true" : null), S("aria-required", o ? "true" : null), S("aria-describedby", d != null ? d : null);
  });
  const x = /* @__PURE__ */ n.createElement(n.Fragment, null, e, o && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ce.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ce.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ce.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ce.row, r ? Ce.ro : "", i ? Ce.invalid : "", o ? Ce.isReq : "", m].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ce.label}` }, s ? /* @__PURE__ */ n.createElement("label", { htmlFor: s, id: f }, x) : /* @__PURE__ */ n.createElement("span", { id: f }, x), a && /* @__PURE__ */ n.createElement(Lt, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ce.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: p, className: `axe-form-value ${Ce.value}` }, N, c && /* @__PURE__ */ n.createElement("span", { id: _, className: Ce.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: y, className: Ce.err }, i)));
}
function Cv({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ce.table}` : "", Ce.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function Sv({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ce.readonly }, e);
}
function Mv({ checked: e, onChange: t, disabled: a, label: r, className: s = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ce.toggle, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (o) => t(o.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
const Kf = "_mono_6omzf_2", Uf = "_invalid_6omzf_3", Yf = "_qty_6omzf_6", Gf = "_qtyInput_6omzf_7", Vf = "_unit_6omzf_8", Qf = "_note_6omzf_9", Jf = "_qtyErr_6omzf_10", bt = {
  mono: Kf,
  invalid: Uf,
  qty: Yf,
  qtyInput: Gf,
  unit: Vf,
  note: Qf,
  qtyErr: Jf
};
function Zf({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: s,
  mono: o,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: m,
  id: u,
  "aria-describedby": f,
  "aria-invalid": p,
  "aria-required": _,
  className: y = ""
}) {
  const d = [o ? bt.mono : "", l ? bt.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: u,
    className: d,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: s,
    disabled: a,
    "aria-label": m,
    "aria-describedby": f,
    "aria-invalid": p != null ? p : l || void 0,
    "aria-required": _,
    onChange: (N) => t(N.target.value === "" ? null : N.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
Zf.axeFormControl = !0;
function e_(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: s,
    label: o,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": m,
    className: u
  } = e, f = (_) => {
    e.codeType === "string" ? e.onChange(_ === "" ? null : _) : e.onChange(_ === "" ? null : Number(_));
  }, p = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: u,
      value: t == null ? "" : String(t),
      disabled: s,
      "aria-label": o,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": m,
      onChange: (_) => f(_.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    p.map(([_, y]) => /* @__PURE__ */ n.createElement("option", { key: _, value: String(_) }, y))
  );
}
e_.axeFormControl = !0;
function t_(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const n_ = /^-?(\d+\.?\d*|\.\d+)$/;
function Zt(e) {
  const t = t_(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!n_.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function $n(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const s = t.slice(0, a), o = s.indexOf(".");
    return (o >= 0 ? s.length - o - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Mr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if ($n(e) <= a) return e;
  const r = e < 0 ? -1 : 1, s = Math.abs(e).toFixed(Math.min(20, $n(e))), o = Math.round(+`${s}e${a}`), l = r * +`${o}e-${a}`;
  return l === 0 ? 0 : l;
}
function Ot(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function a_(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function r_(e, t, a, r, s, o) {
  let l = e == null ? s != null ? s : 0 : Mr(e + a * t, Math.max(r, $n(t)));
  return s != null && l < s && (l = s), o != null && l > o && (l = o), l;
}
const s_ = 2500;
function o_({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: s,
  step: o,
  unit: l,
  disabled: c,
  label: i,
  id: m,
  "aria-describedby": u,
  "aria-invalid": f,
  "aria-required": p,
  width: _,
  onEnter: y,
  onInvalidChange: d,
  placeholder: b,
  className: N = ""
}) {
  const [w, k] = M(() => Ot(e)), [x, g] = M(!1), [h, E] = M(null), [$, D] = M(!1), S = j(null), T = j(w);
  T.current = w, Z(() => {
    const v = Zt(T.current), O = v.kind === "num" ? v.value : v.kind === "empty" ? null : void 0;
    O !== void 0 && O === (e != null ? e : null) || k(Ot(e));
  }, [e]), Z(() => () => {
    S.current && clearTimeout(S.current);
  }, []);
  const I = Zt(w), q = I.kind === "bad" || I.kind === "partial";
  Z(() => {
    q || D(!1);
  }, [q]);
  const P = j(d);
  P.current = d, Z(() => {
    var v;
    (v = P.current) == null || v.call(P, q);
  }, [q]), Z(() => () => {
    var v;
    (v = P.current) == null || v.call(P, !1);
  }, []);
  const Y = (v) => {
    S.current && clearTimeout(S.current), E(v), S.current = setTimeout(() => E(null), s_);
  }, K = (v) => {
    k(v);
    const O = Zt(v);
    O.kind === "empty" ? t(null) : O.kind === "num" && t(O.value);
  }, L = () => {
    const v = Zt(w);
    if (v.kind !== "num") return;
    if ($n(v.value) > a) {
      const V = Mr(v.value, a);
      k(Ot(V)), t(V), Y(`반올림했습니다 → ${Ot(V)}`);
      return;
    }
    const O = Ot(v.value);
    O !== w && k(O);
  }, te = (v) => {
    if (!v.nativeEvent.isComposing) {
      if (v.key === "Enter") {
        if (q) {
          D(!0);
          return;
        }
        L(), y == null || y();
        return;
      }
      if (o && (v.key === "ArrowUp" || v.key === "ArrowDown")) {
        v.preventDefault();
        const O = Zt(w), V = O.kind === "num" ? O.value : O.kind === "empty" ? null : e, Q = r_(V, o, v.key === "ArrowUp" ? 1 : -1, a, r, s);
        k(Ot(Q)), t(Q);
      }
    }
  }, ne = I.kind === "bad" || I.kind === "partial" && (!x || $) || I.kind === "num" && a_(I.value, r, s);
  return /* @__PURE__ */ n.createElement("span", { className: [bt.qty, N].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: m,
      className: [bt.qtyInput, ne ? bt.invalid : ""].filter(Boolean).join(" "),
      style: _ != null ? { width: _, maxWidth: "none" } : void 0,
      value: w,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": u,
      "aria-invalid": f != null ? f : ne || void 0,
      "aria-required": p,
      onChange: (v) => K(v.target.value),
      onFocus: () => g(!0),
      onBlur: () => {
        g(!1), L();
      },
      onKeyDown: te
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: bt.unit }, l), (I.kind === "bad" || I.kind === "partial" && (!x || $)) && /* @__PURE__ */ n.createElement("span", { className: bt.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: bt.note, role: "status", "aria-live": "polite" }, h));
}
o_.axeFormControl = !0;
function l_(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function c_(e, t) {
  var s;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((s = e != null ? e : t) != null ? s : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((o) => {
    l_(e[o], t[o]) || r.push(o);
  }), r;
}
function i_(e, t) {
  return e === null || t === null ? e === t : c_(e, t).length === 0;
}
function Tv() {
  const [e, t] = M(null), [a, r] = M(!1), [s, o] = M(null), l = we(() => a || !i_(s, e), [a, s, e]), c = le((_) => {
    t((y) => y === null ? y : { ...y, ..._ });
  }, []), i = le((_, y) => {
    t((d) => d === null ? d : { ...d, [_]: y });
  }, []), m = j(null), u = le((_) => {
    m.current = _, t(_), o(_), r(!1);
  }, []), f = le((_) => {
    m.current = _, t(_), o(_), r(!0);
  }, []), p = le(() => t(m.current), []);
  return we(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: u, start: f, reset: p, snapshot: s }),
    [e, a, l, i, c, u, f, p, s]
  );
}
function qv() {
  const e = j(!1), [t, a] = M(!1), r = le(async (s) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await s();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const u_ = "_panel_1w7xx_2", m_ = "_band_1w7xx_7", d_ = "_chev_1w7xx_11", f_ = "_title_1w7xx_17", __ = "_note_1w7xx_19", p_ = "_chip_1w7xx_21", y_ = "_other_1w7xx_32", b_ = "_reset_1w7xx_33", h_ = "_form_1w7xx_42", rt = {
  panel: u_,
  band: m_,
  chev: d_,
  title: f_,
  note: __,
  chip: p_,
  other: y_,
  reset: b_,
  form: h_
};
function Bv({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: s = "상세검색",
  title: o = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: m = "상세검색",
  className: u = ""
}) {
  const f = j(null);
  if (i && !a && e.length === 0) return null;
  const p = (y, d = 0) => {
    var x, g, h;
    const b = (x = document.querySelector(`section[aria-label="${CSS.escape(m)}"]`)) != null ? x : f.current, N = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), w = (h = N && ((g = N[y]) != null ? g : N[y - 1])) != null ? h : b == null ? void 0 : b.querySelector("button[aria-expanded]"), k = !document.activeElement || document.activeElement === document.body;
    w && w !== document.activeElement && (d === 0 || k) && w.focus(), d < 4 && setTimeout(() => p(y, d + 1), 250);
  }, _ = (y) => {
    e[y].onClear(), requestAnimationFrame(() => p(y));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [rt.panel, u].filter(Boolean).join(" "), "aria-label": m }, /* @__PURE__ */ n.createElement("div", { className: rt.band, ref: f }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", s), o !== null && /* @__PURE__ */ n.createElement("span", { className: rt.title, "aria-live": "polite" }, o, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((y, d) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: y.key, className: [rt.chip, y.tone === "other" ? rt.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => _(d)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.reset, onClick: () => {
    t(), requestAnimationFrame(() => p(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: rt.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: rt.form }, c));
}
const E_ = "_zone_1y6sp_2", g_ = "_drag_1y6sp_8", v_ = "_busy_1y6sp_9", k_ = "_attached_1y6sp_10", w_ = "_left_1y6sp_12", N_ = "_icon_1y6sp_13", $_ = "_title_1y6sp_18", x_ = "_desc_1y6sp_19", D_ = "_right_1y6sp_20", A_ = "_count_1y6sp_21", C_ = "_pick_1y6sp_22", We = {
  zone: E_,
  drag: g_,
  busy: v_,
  attached: k_,
  left: w_,
  icon: N_,
  title: $_,
  desc: x_,
  right: D_,
  count: A_,
  pick: C_
};
function Lv({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: s,
  multiple: o = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: m = ""
}) {
  const u = j(null), [f, p] = M(!1), _ = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [We.zone, f ? We.drag : "", l ? We.busy : "", c ? We.attached : "", m].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = u.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || p(!0);
      },
      onDragLeave: () => p(!1),
      onDrop: (y) => {
        y.preventDefault(), p(!1), _(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: We.left }, /* @__PURE__ */ n.createElement("div", { className: We.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: We.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: We.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: We.right }, r && /* @__PURE__ */ n.createElement("span", { className: We.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: We.pick,
        disabled: l,
        onClick: (y) => {
          var d;
          y.stopPropagation(), (d = u.current) == null || d.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: s,
        multiple: o,
        hidden: !0,
        onChange: (y) => {
          _(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function S_(e, t) {
  var o, l;
  const a = (o = e.headers.get("Content-Disposition")) != null ? o : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const s = /filename="?([^";]+)"?/i.exec(a);
  return (l = s == null ? void 0 : s[1]) != null ? l : t;
}
function Tr(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function jv(e, t, a) {
  Tr(await e.blob(), a != null ? a : S_(e, t));
}
const M_ = /^([△▲\-−]?)\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, T_ = /^\(\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function qr(e, t = {}) {
  var s, o;
  const a = e.trim();
  if (t.parenNegative) {
    const l = T_.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(s = l[2]) != null ? s : ""}`;
  }
  const r = M_.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((o = r[3]) != null ? o : "") : null;
}
function Ft(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function q_(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => bn(Ft(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let s = null;
  const o = (l) => {
    var i;
    const c = B_(l, e);
    !c || c === s || (s = c, a.length > r && a.push(""), a.push(bn(Ft((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var _;
    if (l.tagName !== "TABLE") {
      if ((_ = l.parentElement) != null && _.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const y = L_(l, t);
      if (!y) return;
      o(l), a.push(y.map(bn).join(","));
      return;
    }
    const c = l;
    o(c);
    const i = c.querySelector("[data-tree-depth]"), m = i ? i.closest("td, th") : null, u = m ? m.cellIndex : -1, f = u >= 0 && !!c.querySelector("[data-csv-path]"), p = [];
    Array.from(c.rows).forEach((y) => {
      if (y.hasAttribute("data-state") || y.getAttribute("aria-hidden") === "true") return;
      const d = [];
      let b = 0;
      const N = () => {
        for (; p[b] && p[b].n > 0; )
          p[b].n -= 1, p[b].skip || d.push(""), b += 1;
      };
      Array.from(y.cells).forEach((w) => {
        var E, $;
        N();
        const k = R_(w), x = k ? "" : I_(w, t), g = Math.max(1, w.colSpan || 1), h = Math.max(1, w.rowSpan || 1);
        for (let D = 0; D < g; D += 1)
          k || d.push(D === 0 ? x : ""), p[b] = { n: h - 1, skip: k }, b += 1;
        if (u >= 0 && w.cellIndex === u) {
          const D = w.querySelector("[data-tree-depth]");
          D ? (d.push(String(Number(D.getAttribute("data-tree-depth")) + 1)), f && d.push(Ft((E = D.getAttribute("data-csv-path")) != null ? E : ""))) : (($ = y.parentElement) == null ? void 0 : $.tagName) === "THEAD" ? (d.push("단계"), f && d.push("상위 경로")) : (d.push(""), f && d.push(""));
        }
      }), N(), d.some((w) => w !== "") && a.push(d.map(bn).join(","));
    });
  }), a.join(`\r
`);
}
function B_(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function L_(e, t) {
  var m, u;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), s = e.querySelector("[data-csv-unit]"), o = s ? yn(s) : "";
  let c = ((m = e.getAttribute("data-csv-kv")) != null ? m : "") || (a ? yn(a) : "");
  if (!c) return null;
  o && (c = `${c} (${o})`);
  let i;
  if (r) {
    const f = r.cloneNode(!0);
    f.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((p) => p.remove()), i = yn(f);
  } else {
    const f = e.cloneNode(!0);
    f.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((p) => p.remove()), i = yn(f);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [Ft(c), (u = qr(i, t)) != null ? u : Ft(i)];
}
function yn(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function j_(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  Tr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function R_(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function I_(e, t) {
  var s, o, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((o = (s = a.innerText) != null ? s : a.textContent) != null ? o : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = qr(r, t)) != null ? l : Ft(r);
}
function bn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const O_ = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function Rv({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: s, prepare: o, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    Yn,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        o && (c = await o(), await O_());
        try {
          const i = e.current;
          if (!i) return;
          j_(q_(i, { parenNegative: s, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(gn, { name: "download", size: 14 }),
    "CSV"
  );
}
const P_ = "_card_1adld_1", X_ = "_sub_1adld_2", z_ = "_state_1adld_3", F_ = "_list_1adld_7", W_ = "_row_1adld_8", H_ = "_warn_1adld_20", K_ = "_danger_1adld_21", $t = {
  card: P_,
  sub: X_,
  state: z_,
  list: F_,
  row: W_,
  warn: H_,
  danger: K_
};
function Iv({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: s,
  onRetry: o,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    yr,
    {
      flush: !0,
      className: [$t.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: $t.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: $t.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: $t.state }, /* @__PURE__ */ n.createElement(Sr, null, s != null ? s : "불러오지 못했습니다"), o && /* @__PURE__ */ n.createElement(sa, { onClick: o }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: $t.list }, c.map((m, u) => {
      var _, y;
      const f = [$t.row, m.tone ? $t[m.tone] : ""].filter(Boolean).join(" "), p = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, m.label), /* @__PURE__ */ n.createElement("strong", null, m.value, m.unit ? /* @__PURE__ */ n.createElement("small", null, m.unit) : null));
      return m.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (_ = m.key) != null ? _ : u, className: f, onClick: m.onClick }, p) : /* @__PURE__ */ n.createElement("div", { key: (y = m.key) != null ? y : u, className: f }, p);
    }))
  );
}
function U_(e, t, a, r, s) {
  const o = Math.max(0, Math.floor(e));
  if (o === 0) return 1;
  const l = Math.max(1, Math.min(o, s != null && s > 0 ? Math.floor(s) : o)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(o / c);
  return Math.ceil(o / i);
}
const Y_ = "_group_16rha_1", G_ = "_tile_16rha_2", V_ = "_click_16rha_9", Q_ = "_ok_16rha_12", J_ = "_warn_16rha_13", Z_ = "_danger_16rha_14", ep = "_info_16rha_15", tp = "_accent_16rha_16", np = "_muted_16rha_17", ap = "_label_16rha_18", rp = "_value_16rha_20", sp = "_desc_16rha_25", Dt = {
  group: Y_,
  tile: G_,
  click: V_,
  ok: Q_,
  warn: J_,
  danger: Z_,
  info: ep,
  accent: tp,
  muted: np,
  label: ap,
  value: rp,
  desc: sp
};
function Ov({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: s = "info",
  onClick: o,
  className: l = ""
}) {
  const c = [Dt.tile, Dt[s], o ? Dt.click : "", l].filter(Boolean).join(" "), i = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Dt.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: Dt.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: Dt.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return o ? /* @__PURE__ */ n.createElement("button", { type: "button", className: c, onClick: o, "data-csv-kv": "" }, i) : /* @__PURE__ */ n.createElement("div", { className: c, "data-csv-kv": "" }, i);
}
const op = 150, lp = 12, cp = 8;
function Pv({ children: e, columns: t, className: a = "" }) {
  const r = j(null), s = Un.toArray(e).filter(ln).length, o = t != null || s <= cp, [l, c] = M(null);
  Be(() => {
    const u = r.current;
    if (!o || !u || (c(u.clientWidth), typeof ResizeObserver == "undefined")) return;
    const f = new ResizeObserver(() => c(u.clientWidth));
    return f.observe(u), () => f.disconnect();
  }, [o]);
  const i = o ? U_(s, l != null ? l : Number.MAX_SAFE_INTEGER, op, lp, t) : 0, m = o ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [Dt.group, a].filter(Boolean).join(" "), style: m }, e);
}
const ip = "_card_1lav2_1", up = "_n_1lav2_2", mp = "_list_1lav2_7", dp = "_row_1lav2_8", fp = "_go_1lav2_15", _p = "_name_1lav2_16", pp = "_empty_1lav2_17", yp = "_star_1lav2_18", bp = "_clear_1lav2_27", Ve = {
  card: ip,
  n: up,
  list: mp,
  row: dp,
  go: fp,
  name: _p,
  empty: pp,
  star: yp,
  clear: bp
};
function Xv({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  mineHint: s = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: o = ""
}) {
  const [l, c] = M("mine"), i = l === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    yr,
    {
      flush: !0,
      className: [Ve.card, o].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        cr,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: l,
          onChange: (m) => c(m),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Ve.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Ve.n }, t.length)) }
          ]
        }
      ),
      trailing: l === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(sa, { className: Ve.clear, onClick: r }, "목록 비우기") : void 0
    },
    i.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: Ve.list }, i.map((m) => /* @__PURE__ */ n.createElement("li", { key: m.path }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.row, onClick: () => a(m) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Ve.go }, "↗"), /* @__PURE__ */ n.createElement("span", { className: Ve.name }, m.label))))) : /* @__PURE__ */ n.createElement("div", { className: Ve.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Ve.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, l === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, l === "mine" ? s : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function Xa(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function zn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function zv({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, s] = M(() => Xa(e)), [o, l] = M(() => Xa(t)), c = le((f) => r.some((p) => p.path === f), [r]), i = le((f) => s((p) => {
    const _ = p.some((y) => y.path === f.path) ? p.filter((y) => y.path !== f.path) : [...p, f];
    return zn(e, _), _;
  }), [e]), m = le((f) => l((p) => {
    const _ = [f, ...p.filter((y) => y.path !== f.path)].slice(0, a);
    return zn(t, _), _;
  }), [t, a]), u = le(() => {
    l([]), zn(t, []);
  }, [t]);
  return { mine: r, recent: o, isMine: c, toggleMine: i, remember: m, clearRecent: u };
}
const hp = "_banner_7tqhk_2", Ep = "_heading_7tqhk_7", gp = "_sparkleBox_7tqhk_8", vp = "_eyebrow_7tqhk_12", kp = "_headline_7tqhk_13", wp = "_desc_7tqhk_15", Np = "_err_7tqhk_16", $p = "_chips_7tqhk_18", xp = "_footer_7tqhk_28", Dp = "_kicker_7tqhk_35", Ap = "_list_7tqhk_36", Cp = "_row_7tqhk_37", Sp = "_icon_7tqhk_39", Mp = "_text_7tqhk_40", Tp = "_cap_7tqhk_41", qp = "_body_7tqhk_43", Bp = "_reason_7tqhk_44", Lp = "_empty_7tqhk_45", be = {
  banner: hp,
  heading: Ep,
  sparkleBox: gp,
  eyebrow: vp,
  headline: kp,
  desc: wp,
  err: Np,
  chips: $p,
  footer: xp,
  kicker: Dp,
  list: Ap,
  row: Cp,
  icon: Sp,
  text: Mp,
  cap: Tp,
  body: qp,
  reason: Bp,
  empty: Lp
};
function za({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function Fv({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: s,
  maxChips: o = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: m = "전체 업무 제안 보기",
  allDisabled: u,
  className: f = ""
}) {
  const p = s.slice(0, o), _ = s.length - p.length;
  return /* @__PURE__ */ n.createElement("section", { className: [be.banner, f].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: be.heading }, /* @__PURE__ */ n.createElement("span", { className: be.sparkleBox }, /* @__PURE__ */ n.createElement(za, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: be.eyebrow }, /* @__PURE__ */ n.createElement(za, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: be.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [be.desc, r ? be.err : ""].filter(Boolean).join(" ") }, a) : null)), s.length > 0 && /* @__PURE__ */ n.createElement("div", { className: be.chips }, p.map((y) => /* @__PURE__ */ n.createElement("button", { type: "button", key: y.key, title: y.label, onClick: () => l(y.key) }, /* @__PURE__ */ n.createElement("i", { style: y.color ? { background: y.color } : void 0, "aria-hidden": "true" }), y.label, " ", /* @__PURE__ */ n.createElement("strong", { style: y.color ? { color: y.color } : void 0 }, y.count, "건"))), _ > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", _, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: be.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? be.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(sa, { onClick: () => l(null), disabled: u }, m, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function jp({ items: e, onRun: t, onSkip: a, busy: r, emptyText: s = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: be.empty }, s) : /* @__PURE__ */ n.createElement("ul", { className: be.list }, e.map((o) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: o.id, className: be.row }, /* @__PURE__ */ n.createElement("span", { className: be.icon, "aria-hidden": "true" }, (l = o.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: be.text }, /* @__PURE__ */ n.createElement("div", { className: be.cap }, o.title, o.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", o.meta) : null), /* @__PURE__ */ n.createElement("div", { className: be.body }, o.body), o.reason ? /* @__PURE__ */ n.createElement("div", { className: be.reason }, o.reason) : null), /* @__PURE__ */ n.createElement(Wt, { variant: "primary", disabled: r, onClick: () => t(o) }, (c = o.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(Wt, { disabled: r, onClick: () => a(o) }, "무시"));
  }));
}
function Wv({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: s, onSkip: o }) {
  const l = j(!1), [c, i] = M(!1), [m, u] = M(""), f = async (p) => {
    if (!l.current) {
      l.current = !0, i(!0), u("");
      try {
        await p();
      } catch {
        u("처리하지 못했습니다. 잠시 후 다시 시도하세요.");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    da,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: be.kicker }, "✦ ", t),
      error: m,
      footer: /* @__PURE__ */ n.createElement(Wt, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement(jp, { items: a, busy: c, onRun: (p) => f(() => s(p)), onSkip: (p) => f(() => o(p)) })
  );
}
const Rp = "_wrap_1wvdc_2", Ip = "_header_1wvdc_7", Op = "_iconBox_1wvdc_8", Pp = "_headText_1wvdc_12", Xp = "_eyebrow_1wvdc_13", zp = "_headline_1wvdc_14", Fp = "_headerExtra_1wvdc_16", Wp = "_grid_1wvdc_19", Hp = "_card_1wvdc_20", Kp = "_badge_1wvdc_29", Up = "_toneRed_1wvdc_33", Yp = "_toneViolet_1wvdc_34", Gp = "_toneGreen_1wvdc_35", Vp = "_toneBlue_1wvdc_36", Qp = "_title_1wvdc_38", Jp = "_summary_1wvdc_42", Zp = "_action_1wvdc_46", ey = "_notice_1wvdc_53", ty = "_err_1wvdc_56", _e = {
  wrap: Rp,
  header: Ip,
  iconBox: Op,
  headText: Pp,
  eyebrow: Xp,
  headline: zp,
  headerExtra: Fp,
  grid: Wp,
  card: Hp,
  badge: Kp,
  toneRed: Up,
  toneViolet: Yp,
  toneGreen: Gp,
  toneBlue: Vp,
  title: Qp,
  summary: Jp,
  action: Zp,
  notice: ey,
  err: ty
};
function Fa({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const ny = {
  red: _e.toneRed,
  violet: _e.toneViolet,
  green: _e.toneGreen,
  blue: _e.toneBlue
};
function Hv({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: s,
  loading: o,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [_e.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: _e.header }, /* @__PURE__ */ n.createElement("span", { className: _e.iconBox }, /* @__PURE__ */ n.createElement(Fa, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: _e.headText }, /* @__PURE__ */ n.createElement("div", { className: _e.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: _e.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: _e.headerExtra }, c) : null), s ? /* @__PURE__ */ n.createElement("div", { className: _e.notice + " " + _e.err, role: "alert" }, s) : null, e.length === 0 ? s ? null : o ? /* @__PURE__ */ n.createElement("div", { className: _e.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: _e.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: _e.grid }, e.map((m) => {
    var u, f;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: m.id, className: _e.card, onClick: () => t(m) }, /* @__PURE__ */ n.createElement("span", { className: [_e.badge, ny[(u = m.tone) != null ? u : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(Fa, { size: 9 }), m.badge), /* @__PURE__ */ n.createElement("span", { className: _e.title }, m.title), m.summary ? /* @__PURE__ */ n.createElement("span", { className: _e.summary, title: typeof m.summary == "string" ? m.summary : void 0 }, m.summary) : null, /* @__PURE__ */ n.createElement("span", { className: _e.action }, (f = m.actionLabel) != null ? f : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const ay = "_wrapper_wrch3_1", ry = "_searchIcon_wrch3_18", sy = "_input_wrch3_26", oy = "_clearButton_wrch3_40", ly = "_hint_wrch3_60", en = {
  wrapper: ay,
  searchIcon: ry,
  input: sy,
  clearButton: oy,
  hint: ly
}, cy = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function iy({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: s,
  onClear: o
}) {
  const l = (c) => {
    c.key === "Enter" && (s == null || s());
  };
  return /* @__PURE__ */ n.createElement("div", { className: en.wrapper }, /* @__PURE__ */ n.createElement("span", { className: en.searchIcon }, cy), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: en.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), o && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: en.clearButton,
      onClick: o,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: en.hint }, r));
}
const uy = "_screen_1bsma_1", my = "_shell_1bsma_8", dy = "_command_1bsma_10", fy = "_body_1bsma_20", _y = "_overview_1bsma_22", py = "_areaHead_1bsma_25", Xt = {
  screen: uy,
  shell: my,
  command: dy,
  body: fy,
  overview: _y,
  areaHead: py
};
function Kv({ search: e, panel: t, children: a, className: r = "" }) {
  var s;
  return /* @__PURE__ */ n.createElement("main", { className: [Xt.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: Xt.shell }, e && /* @__PURE__ */ n.createElement("div", { className: Xt.command }, /* @__PURE__ */ n.createElement(
    iy,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (s = e.hint) != null ? s : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: Xt.body }, a)));
}
function Uv({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Xt.overview, t].filter(Boolean).join(" ") }, e);
}
function Yv({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: Xt.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, t));
}
const yy = "_group_oodts_1", by = "_grid_oodts_7", hy = "_row_oodts_8", Ey = "_item_oodts_9", gy = "_launch_oodts_14", vy = "_name_oodts_17", ky = "_desc_oodts_18", wy = "_badge_oodts_19", Ny = "_disabled_oodts_23", $y = "_tab_oodts_25", xy = "_star_oodts_25", Dy = "_on_oodts_30", Ay = "_empty_oodts_32", Pe = {
  group: yy,
  grid: by,
  row: hy,
  item: Ey,
  launch: gy,
  name: vy,
  desc: ky,
  badge: wy,
  disabled: Ny,
  tab: $y,
  star: xy,
  on: Dy,
  empty: Ay
};
function Cy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function Sy() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function Gv({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Pe.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Pe.grid }, t.map((s) => /* @__PURE__ */ n.createElement("div", { className: Pe.row, key: s.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Pe.item, s.disabled ? Pe.disabled : ""].filter(Boolean).join(" "),
      disabled: s.disabled,
      onClick: s.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Pe.launch }, /* @__PURE__ */ n.createElement(Cy, null)),
    /* @__PURE__ */ n.createElement("span", { className: Pe.name }, s.label),
    s.desc && /* @__PURE__ */ n.createElement("span", { className: Pe.desc }, s.desc),
    s.badge != null && /* @__PURE__ */ n.createElement("em", { className: Pe.badge }, s.badge)
  ), s.onOpenNewTab && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Pe.tab,
      "aria-label": `${s.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: s.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(Sy, null)
  ), s.onToggleStar && !s.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Pe.star, s.starred ? Pe.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!s.starred,
      "aria-label": `${s.label} ${s.starred ? "마이메뉴에서 삭제" : "마이메뉴에 추가"}`,
      onClick: s.onToggleStar
    },
    s.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Pe.empty }, a)));
}
const My = "_strip_8zhai_2", Ty = "_day_8zhai_9", qy = "_total_8zhai_10", By = "_sel_8zhai_31", Ly = "_today_8zhai_35", jy = "_md_8zhai_35", Ry = "_off_8zhai_36", Iy = "_head_8zhai_45", Oy = "_wd_8zhai_46", Py = "_sun_8zhai_47", Xy = "_sat_8zhai_48", zy = "_lock_8zhai_50", Fy = "_value_8zhai_60", Wy = "_mark_8zhai_66", Hy = "_warn_8zhai_67", Ky = "_danger_8zhai_68", Uy = "_info_8zhai_69", Ne = {
  strip: My,
  day: Ty,
  total: qy,
  sel: By,
  today: Ly,
  md: jy,
  off: Ry,
  head: Iy,
  wd: Oy,
  sun: Py,
  sat: Xy,
  lock: zy,
  value: Fy,
  mark: Wy,
  warn: Hy,
  danger: Ky,
  info: Uy
}, Wa = ["일", "월", "화", "수", "목", "금", "토"];
function Yy(e) {
  const [t, a, r] = e.split("-").map(Number), s = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: s };
}
function Vv({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: s,
  totalLabel: o = "합계",
  "aria-label": l,
  className: c
}) {
  const i = j([]), m = (p) => {
    var y;
    const _ = e.length;
    for (let d = 0; d < _; d++) {
      const b = (p + d + _) % _;
      if (!e[b].disabled) {
        (y = i.current[b]) == null || y.focus();
        return;
      }
    }
  }, u = (p, _) => {
    p.key === "ArrowRight" ? (p.preventDefault(), m(_ + 1)) : p.key === "ArrowLeft" ? (p.preventDefault(), m(_ - 1)) : p.key === "Home" ? (p.preventDefault(), m(0)) : p.key === "End" && (p.preventDefault(), m(e.length - 1));
  }, f = Math.max(0, e.findIndex((p) => p.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${Ne.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((p, _) => {
    var w, k, x, g;
    const { md: y, wd: d } = Yy(p.date), b = [
      Ne.day,
      p.off ? Ne.off : "",
      p.date === t ? Ne.sel : "",
      p.date === a ? Ne.today : "",
      d === 0 ? Ne.sun : d === 6 ? Ne.sat : ""
    ].filter(Boolean).join(" "), N = [`${y}(${Wa[d]})`, p.offLabel, p.locked ? "잠김" : null, (w = p.mark) == null ? void 0 : w.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: p.date,
        ref: (h) => {
          i.current[_] = h;
        },
        type: "button",
        className: b,
        disabled: p.disabled,
        tabIndex: _ === f ? 0 : -1,
        "aria-pressed": p.date === t,
        "aria-label": N,
        title: N,
        onClick: () => r == null ? void 0 : r(p.date),
        onKeyDown: (h) => u(h, _)
      },
      /* @__PURE__ */ n.createElement("span", { className: Ne.head }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, Wa[d]), /* @__PURE__ */ n.createElement("span", { className: Ne.md }, y), p.locked && /* @__PURE__ */ n.createElement("span", { className: Ne.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: Ne.value }, p.value),
      /* @__PURE__ */ n.createElement("span", { className: `${Ne.mark}${p.mark ? ` ${Ne[p.mark.tone]}` : ""}` }, (g = (k = p.mark) == null ? void 0 : k.text) != null ? g : p.off && (x = p.offLabel) != null ? x : "")
    );
  }), s !== void 0 && /* @__PURE__ */ n.createElement("div", { className: Ne.total }, /* @__PURE__ */ n.createElement("span", { className: Ne.wd }, o), /* @__PURE__ */ n.createElement("span", { className: Ne.value }, s)));
}
const Gy = "_stepper_1wbt2_1", Vy = "_nav_1wbt2_2", Qy = "_today_1wbt2_3", Jy = "_range_1wbt2_14", tn = {
  stepper: Gy,
  nav: Vy,
  today: Qy,
  range: Jy
};
function Zy(e) {
  const t = ca(e);
  return t === 0 ? 7 : t;
}
function eb(e, t = 1) {
  const a = (Zy(e) - t + 7) % 7;
  return Cn(e, -a);
}
function Fn(e, t) {
  return Cn(e, t);
}
function Qv({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: s, label: o = "주" }) {
  const l = Fn(e, 6), c = eb(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: tn.stepper, role: "group", "aria-label": o }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: tn.nav,
      onClick: () => t(Fn(e, -7)),
      disabled: s,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: tn.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: tn.nav,
      onClick: () => t(Fn(e, 7)),
      disabled: s,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: tn.today,
      onClick: () => t(c),
      disabled: s || e === c
    },
    "이번 주"
  ));
}
const tb = "_wrap_1dtpy_1", nb = "_svg_1dtpy_2", ab = "_grid_1dtpy_3", rb = "_axis_1dtpy_4", sb = "_accent_1dtpy_5", ob = "_muted_1dtpy_6", lb = "_ok_1dtpy_7", cb = "_warn_1dtpy_8", ib = "_danger_1dtpy_9", ub = "_legend_1dtpy_10", mb = "_dot_accent_1dtpy_13", db = "_dot_muted_1dtpy_14", fb = "_dot_ok_1dtpy_15", _b = "_dot_warn_1dtpy_16", pb = "_dot_danger_1dtpy_17", pt = {
  wrap: tb,
  svg: nb,
  grid: ab,
  axis: rb,
  accent: sb,
  muted: ob,
  ok: lb,
  warn: cb,
  danger: ib,
  legend: ub,
  dot_accent: mb,
  dot_muted: db,
  dot_ok: fb,
  dot_warn: _b,
  dot_danger: pb
}, yb = 600;
function bb(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const Ha = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function Jv({ categories: e, series: t, unit: a = "", height: r = 180, label: s, labelEvery: o }) {
  const l = j(null), [c, i] = M(yb);
  Be(() => {
    const E = l.current;
    if (!E) return;
    const $ = () => {
      const S = E.clientWidth;
      S > 0 && i((T) => T === S ? T : S);
    };
    if ($(), typeof ResizeObserver == "undefined") return;
    const D = new ResizeObserver($);
    return D.observe(E), () => D.disconnect();
  }, []);
  const m = r, u = 40, f = 22, p = 8, _ = c - u - 4, y = m - f - p, d = t.flatMap((E) => E.values.filter(($) => $ != null)), b = bb(Math.max(0, ...d)), N = Math.max(e.length, 1), w = _ / N, k = Math.min(8, w * 0.2), x = Math.max(1, (w - k) / Math.max(t.length, 1)), g = o != null ? o : Math.max(1, Math.ceil(N / 8)), h = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: pt.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: pt.svg,
      viewBox: `0 0 ${c} ${m}`,
      role: "img",
      "aria-label": s,
      style: { height: r }
    },
    h.map((E) => {
      const $ = p + y - E / b * y;
      return /* @__PURE__ */ n.createElement("g", { key: E }, /* @__PURE__ */ n.createElement("line", { className: pt.grid, x1: u, x2: c - 4, y1: $, y2: $ }), /* @__PURE__ */ n.createElement("text", { className: pt.axis, x: u - 4, y: $ + 3, textAnchor: "end" }, Ha(E)));
    }),
    e.map((E, $) => /* @__PURE__ */ n.createElement("g", { key: E }, t.map((D, S) => {
      var q;
      const T = D.values[$];
      if (T == null || T <= 0) return null;
      const I = T / b * y;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: D.key,
          className: pt[(q = D.tone) != null ? q : "accent"],
          x: u + $ * w + k / 2 + S * x,
          y: p + y - I,
          width: x,
          height: I
        },
        /* @__PURE__ */ n.createElement("title", null, `${E} · ${D.label} ${Ha(T)}${a}`)
      );
    }), $ % g === 0 && /* @__PURE__ */ n.createElement("text", { className: pt.axis, x: u + $ * w + w / 2, y: m - 6, textAnchor: "middle" }, E)))
  ), /* @__PURE__ */ n.createElement("ul", { className: pt.legend }, t.map((E) => {
    var $;
    return /* @__PURE__ */ n.createElement("li", { key: E.key }, /* @__PURE__ */ n.createElement("i", { className: pt[`dot_${($ = E.tone) != null ? $ : "accent"}`], "aria-hidden": "true" }), E.label, a ? ` (${a})` : "");
  })));
}
const hb = "_wrap_85lir_1", Eb = "_track_85lir_2", gb = "_accent_85lir_3", vb = "_muted_85lir_3", kb = "_ok_85lir_3", wb = "_warn_85lir_3", Nb = "_danger_85lir_3", $b = "_center_85lir_9", xb = "_legend_85lir_10", Db = "_name_85lir_13", Ab = "_val_85lir_14", Cb = "_pct_85lir_15", Sb = "_dot_accent_85lir_16", Mb = "_dot_muted_85lir_17", Tb = "_dot_ok_85lir_18", qb = "_dot_warn_85lir_19", Bb = "_dot_danger_85lir_20", st = {
  wrap: hb,
  track: Eb,
  accent: gb,
  muted: vb,
  ok: kb,
  warn: wb,
  danger: Nb,
  center: $b,
  legend: xb,
  name: Db,
  val: Ab,
  pct: Cb,
  dot_accent: Sb,
  dot_muted: Mb,
  dot_ok: Tb,
  dot_warn: qb,
  dot_danger: Bb
}, Zn = 40, Ka = 2 * Math.PI * Zn;
function Zv({ items: e, center: t, size: a = 120, label: r, emptyText: s = "자료 없음", unit: o = "" }) {
  const l = e.reduce((i, m) => i + Math.max(0, m.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: st.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: st.track, cx: "50", cy: "50", r: Zn }), l > 0 && e.map((i) => {
    var f;
    const m = Math.max(0, i.value) / l * Ka, u = c;
    return c += m, m <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: st[(f = i.tone) != null ? f : "accent"],
        cx: "50",
        cy: "50",
        r: Zn,
        strokeDasharray: `${m} ${Ka - m}`,
        strokeDashoffset: -u,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${o}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: st.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : s)), /* @__PURE__ */ n.createElement("ul", { className: st.legend }, e.map((i) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: st[`dot_${(m = i.tone) != null ? m : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: st.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: st.val }, i.value.toLocaleString("ko-KR"), o), /* @__PURE__ */ n.createElement("span", { className: st.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const Lb = "_wrap_1b8ll_1", jb = "_track_1b8ll_2", Rb = "_compact_1b8ll_3", Ib = "_fill_1b8ll_4", Ob = "_accent_1b8ll_5", Pb = "_muted_1b8ll_6", Xb = "_ok_1b8ll_7", zb = "_warn_1b8ll_8", Fb = "_danger_1b8ll_9", Wb = "_num_1b8ll_10", Hb = "_none_1b8ll_12", xt = {
  wrap: Lb,
  track: jb,
  compact: Rb,
  fill: Ib,
  accent: Ob,
  muted: Pb,
  ok: Xb,
  warn: zb,
  danger: Fb,
  num: Wb,
  none: Hb
};
function e0({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: xt.none, "aria-label": `${t} 해당 없음` }, "-");
  const s = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [xt.wrap, r ? xt.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": s
    },
    /* @__PURE__ */ n.createElement("span", { className: xt.track }, /* @__PURE__ */ n.createElement("span", { className: `${xt.fill} ${xt[a]}`, style: { width: `${s}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: xt.num }, s, "%")
  );
}
const Kb = { day: 28, week: 10, month: 3 };
function qt(e, t) {
  return Cn(e, t);
}
function ea(e, t) {
  return ht(t) - ht(e) + 1;
}
function Br(e) {
  return ca(e);
}
const Ua = (e) => {
  const t = Br(e);
  return t === 0 || t === 6;
};
function Pt(e, t, a, r) {
  const s = [], o = ea(e, t);
  for (let l = 0; l < o; l++) {
    const c = qt(e, l), i = a(c), m = s[s.length - 1];
    m && m.key === i ? m.days++ : s.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return s;
}
function Ub(e, t, a) {
  const r = (o) => o.slice(0, 7), s = (o) => `${o.slice(0, 4)}.${o.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Pt(e, t, (o) => o.slice(0, 4), (o) => `${o.slice(0, 4)}년`),
      bottom: Pt(e, t, r, (o) => `${Number(o.slice(5, 7))}월`)
    };
  if (a === "week") {
    const o = (l) => qt(l, -((Br(l) + 6) % 7));
    return {
      top: Pt(e, t, r, s),
      bottom: Pt(e, t, o, (l) => {
        const c = o(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Pt(e, t, r, s),
    bottom: Pt(e, t, (o) => o, (o) => String(Number(o.slice(8, 10))))
  };
}
function Wn(e, t, a, r) {
  if (a === "move") return { start: qt(e, r), end: qt(t, r) };
  if (a === "start") {
    const o = qt(e, r);
    return { start: o > t ? t : o, end: t };
  }
  const s = qt(t, r);
  return { start: e, end: s < e ? e : s };
}
const Yb = "_gantt_1smka_3", Gb = "_scroll_1smka_15", Vb = "_canvas_1smka_21", Qb = "_head_1smka_24", Jb = "_headLabel_1smka_32", Zb = "_headTrack_1smka_43", e1 = "_band_1smka_44", t1 = "_seg_1smka_46", n1 = "_tick_1smka_59", a1 = "_tickOff_1smka_60", r1 = "_body_1smka_62", s1 = "_overlay_1smka_65", o1 = "_weekend_1smka_66", l1 = "_holiday_1smka_66", c1 = "_today_1smka_68", i1 = "_row_1smka_70", u1 = "_label_1smka_76", m1 = "_sel_1smka_77", d1 = "_track_1smka_77", f1 = "_dim_1smka_78", _1 = "_labelText_1smka_95", p1 = "_dot_1smka_96", y1 = "_warn_1smka_97", b1 = "_err_1smka_98", h1 = "_bar_1smka_113", E1 = "_can_1smka_21", g1 = "_dragging_1smka_126", v1 = "_fill_1smka_127", k1 = "_late_1smka_128", w1 = "_summary_1smka_130", N1 = "_handle_1smka_133", $1 = "_hL_1smka_134", x1 = "_hR_1smka_135", D1 = "_mark_1smka_137", A1 = "_barText_1smka_138", C1 = "_empty_1smka_147", S1 = "_srOnly_1smka_150", ee = {
  gantt: Yb,
  scroll: Gb,
  canvas: Vb,
  head: Qb,
  headLabel: Jb,
  headTrack: Zb,
  band: e1,
  seg: t1,
  tick: n1,
  tickOff: a1,
  body: r1,
  overlay: s1,
  weekend: o1,
  holiday: l1,
  today: c1,
  row: i1,
  label: u1,
  sel: m1,
  track: d1,
  dim: f1,
  labelText: _1,
  dot: p1,
  warn: y1,
  err: b1,
  bar: h1,
  can: E1,
  dragging: g1,
  fill: v1,
  late: k1,
  summary: w1,
  handle: N1,
  hL: $1,
  hR: x1,
  mark: D1,
  barText: A1,
  empty: C1,
  srOnly: S1
}, Ya = 28, Ga = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let M1 = 0;
function t0({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: s = {},
  today: o,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: m,
  labelWidth: u = 280,
  labelHeader: f,
  lockedReason: p,
  scrollMemory: _,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const N = j("");
  N.current || (N.current = `axe-gantt-keys-${++M1}`);
  const w = Kb[r], k = Math.max(ea(t, a), 1), x = ht(t), g = k * w, h = we(() => Ub(t, a, r), [t, a, r]), E = we(() => {
    const v = [];
    for (let O = 0; O < k; O++) {
      const V = qt(t, O), Q = V in s;
      if (!Q && !Ua(V)) continue;
      const se = v[v.length - 1];
      se && se.offset + se.days === O && se.holiday === Q ? se.days++ : v.push({ offset: O, days: 1, holiday: Q });
    }
    return v;
  }, [t, k, s]), [$, D] = M(null), S = j(null), T = (v) => !!c && !v.locked && !v.summary && !!v.start && !!v.end, I = (v, O, V) => {
    if (!T(O) || v.button !== 0) return;
    v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
    const Q = { id: O.id, mode: V, x: v.clientX, delta: 0, moved: !1 };
    S.current = Q, D(Q);
  }, q = (v) => {
    const O = S.current;
    if (!O) return;
    const V = Math.round((v.clientX - O.x) / w), Q = O.moved || Math.abs(v.clientX - O.x) > 3;
    if (V !== O.delta || Q !== O.moved) {
      const se = { ...O, delta: V, moved: Q };
      S.current = se, D(se);
    }
  }, P = (v) => {
    const O = S.current;
    if (S.current = null, D(null), !!O) {
      if (!O.moved) {
        i == null || i(v);
        return;
      }
      O.delta !== 0 && v.start && v.end && (c == null || c(v, Wn(v.start, v.end, O.mode, O.delta), O.mode));
    }
  }, Y = () => {
    S.current = null, D(null);
  }, K = (v, O) => {
    if (v.key === "Escape" && S.current) {
      Y();
      return;
    }
    if (v.key === "Enter") {
      i == null || i(O);
      return;
    }
    if (!T(O) || v.key !== "ArrowLeft" && v.key !== "ArrowRight") return;
    v.preventDefault();
    const V = v.key === "ArrowLeft" ? -1 : 1, Q = v.shiftKey ? "end" : v.altKey ? "start" : "move";
    c == null || c(O, Wn(O.start, O.end, Q, V), Q);
  }, L = o ? ht(o) - x : -1, te = j(null), ne = j(null);
  return Be(() => {
    const v = te.current;
    if (v && (_ != null && _.current) && ne.current === null) {
      ne.current = r, v.scrollLeft = _.current.left, v.scrollTop = _.current.top;
      return;
    }
    if (!l || !v || L < 0 || L >= k || ne.current === r) return;
    ne.current = r;
    const O = Math.max(v.clientWidth - u, 0);
    v.scrollLeft = Math.max(0, L * w + w / 2 - O / 3);
  }, [l, r, L, k, w, u]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ee.gantt, y].filter(Boolean).join(" "),
      style: d,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (v) => {
        v.key === "Escape" && S.current && Y();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: N.current, className: ee.srOnly }, Ga),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: te,
        className: ee.scroll,
        onScroll: _ ? (v) => {
          _.current = { left: v.currentTarget.scrollLeft, top: v.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ee.canvas, style: { width: u + g } }, /* @__PURE__ */ n.createElement("div", { className: ee.head, style: { gridTemplateColumns: `${u}px ${g}px` } }, /* @__PURE__ */ n.createElement("div", { className: ee.headLabel }, f), /* @__PURE__ */ n.createElement("div", { className: ee.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ee.band }, h.top.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.key, className: ee.seg, style: { left: v.offset * w, width: v.days * w }, title: v.label }, v.label))), /* @__PURE__ */ n.createElement("div", { className: ee.band }, h.bottom.map((v) => {
        var V;
        const O = r === "day" && (v.key in s || Ua(v.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: v.key,
            className: [ee.seg, ee.tick, O ? ee.tickOff : ""].filter(Boolean).join(" "),
            style: { left: v.offset * w, width: v.days * w },
            title: (V = s[v.key]) != null ? V : v.key
          },
          v.days * w >= 16 ? v.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ee.body, style: { minHeight: Ya } }, /* @__PURE__ */ n.createElement("div", { className: ee.overlay, style: { left: u, width: g }, "aria-hidden": "true" }, E.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.offset, className: v.holiday ? ee.holiday : ee.weekend, style: { left: v.offset * w, width: v.days * w } })), L >= 0 && L < k && /* @__PURE__ */ n.createElement("span", { className: ee.today, style: { left: L * w + w / 2 }, title: "오늘" })), e.map((v) => {
        var X, H, ce, Ue;
        const O = !!v.start && !!v.end && v.start <= v.end, V = $ && $.id === v.id ? $ : null, Q = O && V && V.delta !== 0 ? Wn(v.start, v.end, V.mode, V.delta) : O ? { start: v.start, end: v.end } : null, se = Q ? (ht(Q.start) - x) * w : 0, B = Q ? ea(Q.start, Q.end) * w : 0, J = Math.max(0, Math.min(100, (X = v.progress) != null ? X : 0)), R = m != null && m === v.id, z = T(v), G = !z && c && Q ? p == null ? void 0 : p(v) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: v.id,
            className: [ee.row, R ? ee.sel : "", v.dim ? ee.dim : ""].filter(Boolean).join(" "),
            style: { height: Ya }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ee.label,
              style: { width: u },
              title: v.name,
              onClick: () => i == null ? void 0 : i(v)
            },
            /* @__PURE__ */ n.createElement("span", { className: ee.labelText }, v.label),
            v.marked && /* @__PURE__ */ n.createElement("span", { className: ee.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            v.warn && /* @__PURE__ */ n.createElement("span", { className: ee.warn, title: v.warn, "aria-label": v.warn }, "⚠"),
            v.error && /* @__PURE__ */ n.createElement("span", { className: ee.err, title: v.error, "aria-label": v.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ee.track, style: { width: g }, onClick: () => !V && (i == null ? void 0 : i(v)) }, Q ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ee.bar, v.summary ? ee.summary : "", v.late ? ee.late : "", z ? ee.can : "", V ? ee.dragging : ""].filter(Boolean).join(" "),
              style: { left: se, width: Math.max(B, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(H = v.name) != null ? H : ""} ${Q.start} ~ ${Q.end}${v.progress != null ? ` ${J}%` : ""}${v.late ? " 지연" : ""}${G ? ` 잠김: ${G}` : ""}`,
              "aria-describedby": z ? N.current : void 0,
              title: `${Q.start} ~ ${Q.end}${v.progress != null ? ` · ${J}%` : ""}${v.late ? " · 지연" : ""}${z ? `
끌어 옮기기·양 끝 조절
${Ga}` : ""}${G ? `
잠김: ${G}` : ""}`,
              onPointerDown: (Re) => I(Re, v, "move"),
              onPointerMove: q,
              onPointerUp: () => P(v),
              onPointerCancel: Y,
              onClick: (Re) => Re.stopPropagation(),
              onKeyDown: (Re) => K(Re, v)
            },
            v.progress != null && /* @__PURE__ */ n.createElement("span", { className: ee.fill, style: { width: `${J}%` } }),
            z && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hL}`, onPointerDown: (Re) => I(Re, v, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hR}`, onPointerDown: (Re) => I(Re, v, "end") }))
          ), v.markDate && v.markDate >= t && v.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ee.mark, style: { left: (ht(v.markDate) - x + 1) * w - 1 }, title: (ce = v.markLabel) != null ? ce : v.markDate }), v.barText && /* @__PURE__ */ n.createElement("span", { className: ee.barText, style: { left: se + Math.max(B, 2) + 4 } }, v.barText)) : /* @__PURE__ */ n.createElement("span", { className: ee.empty }, (Ue = v.emptyText) != null ? Ue : "기간 없음"))
        );
      })))
    )
  );
}
const T1 = "_board_192fl_3", q1 = "_col_192fl_15", B1 = "_over_192fl_23", L1 = "_head_192fl_25", j1 = "_title_192fl_33", R1 = "_count_192fl_34", I1 = "_hint_192fl_43", O1 = "_list_192fl_45", P1 = "_empty_192fl_54", X1 = "_card_192fl_56", z1 = "_sel_192fl_68", F1 = "_dragging_192fl_69", W1 = "_hasErr_192fl_70", H1 = "_dot_192fl_71", K1 = "_err_192fl_72", Me = {
  board: T1,
  col: q1,
  over: B1,
  head: L1,
  title: j1,
  count: R1,
  hint: I1,
  list: O1,
  empty: P1,
  card: X1,
  sel: z1,
  dragging: F1,
  hasErr: W1,
  dot: H1,
  err: K1
}, Hn = "application/x-axerp-kanban";
function n0({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: s,
  cardLabel: o,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: m,
  error: u,
  lockedReason: f,
  emptyText: p = "카드가 없습니다",
  moveHint: _,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const N = Gt("axe-kb"), [w, k] = M(null), [x, g] = M(null), h = new Map(t.map((T) => [String(a(T)), T])), E = j(null), $ = j(null);
  Z(() => {
    var q, P;
    const T = $.current;
    if (!T) return;
    if (Date.now() > T.until) {
      $.current = null;
      return;
    }
    const I = Array.from((P = (q = E.current) == null ? void 0 : q.querySelectorAll("[data-kanban-key]")) != null ? P : []).find((Y) => Y.dataset.kanbanKey === T.key);
    I && document.activeElement !== I && I.focus(), $.current = null;
  });
  const D = (T, I) => {
    T.preventDefault(), k(null), g(null);
    const q = T.dataTransfer.getData(Hn), P = h.get(q);
    P && r(P) !== I && (l == null || l(P, I));
  }, S = (T, I) => {
    if (T.key === "Enter" || T.key === " ") {
      T.preventDefault(), c == null || c(I);
      return;
    }
    if (!l || !T.altKey || T.key !== "ArrowLeft" && T.key !== "ArrowRight" || f != null && f(I)) return;
    T.preventDefault();
    const q = e.findIndex((Y) => Y.key === r(I)), P = q + (T.key === "ArrowLeft" ? -1 : 1);
    q >= 0 && P >= 0 && P < e.length && ($.current = { key: String(a(I)), until: Date.now() + 1500 }, l(I, e[P].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: E, className: [Me.board, y].filter(Boolean).join(" "), style: d, role: "region", "aria-label": b != null ? b : "보드" }, e.map((T) => {
    const I = t.filter((q) => r(q) === T.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: T.key,
        className: [Me.col, w === T.key ? Me.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof T.title == "string" ? T.title : void 0,
        onDragOver: l ? (q) => {
          q.dataTransfer.types.includes(Hn) && (q.preventDefault(), k(T.key));
        } : void 0,
        onDragLeave: l ? (q) => {
          q.currentTarget.contains(q.relatedTarget) || k((P) => P === T.key ? null : P);
        } : void 0,
        onDrop: l ? (q) => D(q, T.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.title }, T.title), /* @__PURE__ */ n.createElement("span", { className: Me.count }, I.length), T.hint && /* @__PURE__ */ n.createElement("span", { className: Me.hint }, T.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Me.list }, I.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Me.empty }, p), I.map((q) => {
        const P = a(q), Y = f == null ? void 0 : f(q), K = u == null ? void 0 : u(q), L = !!l && !Y, te = Y != null ? Y : L ? _ != null ? _ : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: P,
            className: [Me.card, i === P ? Me.sel : "", x === P ? Me.dragging : "", K ? Me.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(P),
            role: "button",
            "aria-label": o == null ? void 0 : o(q),
            "aria-keyshortcuts": L ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: te,
            "aria-describedby": te ? `${N}-h-${String(P)}` : void 0,
            draggable: L,
            onDragStart: L ? (ne) => {
              ne.dataTransfer.setData(Hn, String(P)), ne.dataTransfer.effectAllowed = "move", g(P);
            } : void 0,
            onDragEnd: () => {
              g(null), k(null);
            },
            onClick: () => c == null ? void 0 : c(q),
            onKeyDown: (ne) => S(ne, q)
          },
          te && /* @__PURE__ */ n.createElement(br, { id: `${N}-h-${String(P)}` }, te),
          (m == null ? void 0 : m(q)) && /* @__PURE__ */ n.createElement("span", { className: Me.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          s(q),
          K && /* @__PURE__ */ n.createElement("p", { className: Me.err, role: "alert" }, K)
        );
      }))
    );
  }));
}
const U1 = "_list_1aqum_2", Y1 = "_empty_1aqum_3", G1 = "_item_1aqum_5", V1 = "_row_block_1aqum_6", Q1 = "_row_warn_1aqum_7", J1 = "_head_1aqum_9", Z1 = "_mark_1aqum_16", eh = "_msg_1aqum_17", th = "_count_1aqum_18", nh = "_aside_1aqum_19", ah = "_caret_1aqum_20", rh = "_block_1aqum_22", sh = "_warn_1aqum_23", oh = "_info_1aqum_24", lh = "_body_1aqum_29", ch = "_actions_1aqum_30", Te = {
  list: U1,
  empty: Y1,
  item: G1,
  row_block: V1,
  row_warn: Q1,
  head: J1,
  mark: Z1,
  msg: eh,
  count: th,
  aside: nh,
  caret: ah,
  block: rh,
  warn: sh,
  info: oh,
  body: lh,
  actions: ch
}, ih = { block: "■", warn: "▲", info: "●" }, uh = { block: "차단", warn: "경고", info: "정보" };
function a0({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [s, o] = M({}), [l, c] = M(e);
  return l !== e && (c(e), o({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${Te.list} ${r}` }, e.map((i) => {
    var p;
    const m = !!i.detail || !!i.actions, u = m && ((p = s[i.key]) != null ? p : a.includes(i.tone)), f = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${Te.mark} ${Te[i.tone]}`, "aria-label": uh[i.tone], role: "img" }, ih[i.tone]), /* @__PURE__ */ n.createElement("span", { className: Te.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${Te.count} ${Te[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: Te.aside }, i.aside), m && /* @__PURE__ */ n.createElement("span", { className: Te.caret, "aria-hidden": "true" }, u ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${Te.item} ${Te[`row_${i.tone}`]}` }, m ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Te.head,
        "aria-expanded": u,
        onClick: () => o((_) => ({ ..._, [i.key]: !u }))
      },
      f
    ) : /* @__PURE__ */ n.createElement("div", { className: Te.head }, f), u && /* @__PURE__ */ n.createElement("div", { className: Te.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: Te.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${Te.empty} ${r}` }, t);
}
function mh(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), s = (o, l) => Array.from({ length: l - o + 1 }, (c, i) => o + i);
  return a <= 10 ? s(1, a) : r <= 5 ? [...s(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...s(a - 6, a)] : [1, "…", ...s(r - 2, r + 2), "…", a];
}
function dh(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function r0(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function s0(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const fh = "_nav_1r2z8_1", _h = "_list_1r2z8_3", ph = "_btn_1r2z8_4", yh = "_cur_1r2z8_13", bh = "_gap_1r2z8_15", hh = "_total_1r2z8_16", Eh = "_jump_1r2z8_17", gh = "_go_1r2z8_20", vh = "_size_1r2z8_22", kh = "_more_1r2z8_24", wh = "_moreBtn_1r2z8_25", Nh = "_moreN_1r2z8_29", ge = {
  nav: fh,
  list: _h,
  btn: ph,
  cur: yh,
  gap: bh,
  total: hh,
  jump: Eh,
  in: "_in_1r2z8_18",
  go: gh,
  size: vh,
  more: kh,
  moreBtn: wh,
  moreN: Nh
};
function o0({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: s, pageSize: o, onPageSizeChange: l, total: c, className: i = "" }) {
  const m = Math.max(1, t), u = Math.min(m, Math.max(1, e)), [f, p] = M(String(u));
  Z(() => p(String(u)), [u]);
  const _ = (d) => {
    d !== u && d >= 1 && d <= m && a(d);
  }, y = () => {
    const d = dh(f, m);
    if (d === null) {
      p(String(u));
      return;
    }
    p(String(d)), _(d);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [ge.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: ge.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: ge.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(1), disabled: u === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(u - 1), disabled: u === 1, "aria-label": "이전 쪽" }, "‹")), mh(u, m).map((d, b) => d === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: ge.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [ge.btn, d === u ? ge.cur : ""].filter(Boolean).join(" "),
      onClick: () => _(d),
      "aria-current": d === u ? "page" : void 0,
      "aria-label": `${d}쪽`
    },
    d
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(u + 1), disabled: u === m, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.btn, onClick: () => _(m), disabled: u === m, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: ge.total }, "전체 ", m, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: ge.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: ge.in,
      inputMode: "numeric",
      value: f,
      "aria-label": "이동할 쪽 번호",
      onChange: (d) => p(d.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (d) => {
        d.key === "Enter" && (d.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.go, onClick: y }, "이동")), s && o !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: ge.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: o, onChange: (d) => l(Number(d.target.value)) }, s.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d, "건")))));
}
function l0({ shown: e, total: t, onMore: a, busy: r = !1, className: s = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [ge.more, s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: ge.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const $h = "_ol_fbatg_1", xh = "_li_fbatg_2", Dh = "_done_fbatg_5", Ah = "_now_fbatg_5", Ch = "_item_fbatg_6", Sh = "_dot_fbatg_12", Mh = "_label_fbatg_19", Th = "_opt_fbatg_21", qh = "_sr_fbatg_22", ot = {
  ol: $h,
  li: xh,
  done: Dh,
  now: Ah,
  item: Ch,
  dot: Sh,
  label: Mh,
  opt: Th,
  sr: qh
};
function c0({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [ot.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((s, o) => {
    const l = o < t ? "done" : o === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: ot.dot, "aria-hidden": "true" }, l === "done" ? "✓" : o + 1), /* @__PURE__ */ n.createElement("span", { className: ot.label }, s.label, s.optional && /* @__PURE__ */ n.createElement("span", { className: ot.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: ot.sr }, " 완료"))), i = !!a && o <= t;
    return /* @__PURE__ */ n.createElement("li", { key: s.key, className: [ot.li, ot[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: ot.item, onClick: () => a(o, s) }, c) : /* @__PURE__ */ n.createElement("span", { className: ot.item }, c));
  }));
}
const Bh = "_root_7y5bc_5", Lh = "_block_7y5bc_6", jh = "_svg_7y5bc_7", Rh = "_sm_7y5bc_8", Ih = "_md_7y5bc_9", Oh = "_lg_7y5bc_10", Ph = "_track_7y5bc_11", Xh = "_bar_7y5bc_12", zh = "_spin_7y5bc_13", Fh = "_txt_7y5bc_15", yt = {
  root: Bh,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: Lh,
  svg: jh,
  sm: Rh,
  md: Ih,
  lg: Oh,
  track: Ph,
  bar: Xh,
  spin: zh,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: Fh,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function i0({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: s = !1, className: o = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [yt.root, s ? yt.block : "", o].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [yt.svg, yt[e], l ? "" : yt.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: yt.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: yt.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: yt.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const Wh = "_group_xpsei_1", Hh = "_legend_xpsei_2", Kh = "_req_xpsei_3", Uh = "_opts_xpsei_4", Yh = "_inline_xpsei_5", Gh = "_all_xpsei_6", Vh = "_opt_xpsei_4", Qh = "_dis_xpsei_11", Jh = "_radio_xpsei_12", Zh = "_check_xpsei_12", eE = "_text_xpsei_14", tE = "_hint_xpsei_15", nE = "_err_xpsei_16", pe = {
  group: Wh,
  legend: Hh,
  req: Kh,
  opts: Uh,
  inline: Yh,
  all: Gh,
  opt: Vh,
  dis: Qh,
  radio: Jh,
  check: Zh,
  text: eE,
  hint: tE,
  err: nE
};
function Lr({ legend: e, required: t }) {
  return /* @__PURE__ */ n.createElement("legend", { className: pe.legend }, e, t && /* @__PURE__ */ n.createElement("span", { className: pe.req }, " (필수)"));
}
function u0({ name: e, legend: t, options: a, value: r, onChange: s, required: o, disabled: l, error: c, inline: i = !1, className: m = "" }) {
  const u = Gt("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [pe.group, m].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? u : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Lr, { legend: t, required: o }),
    /* @__PURE__ */ n.createElement("div", { className: [pe.opts, i ? pe.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((f) => /* @__PURE__ */ n.createElement("label", { key: f.value, className: [pe.opt, f.disabled ? pe.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: pe.radio,
        name: e,
        value: f.value,
        checked: r === f.value,
        disabled: f.disabled,
        required: o,
        onChange: () => s(f.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: pe.text }, f.label, f.hint && /* @__PURE__ */ n.createElement("span", { className: pe.hint }, f.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: u, className: pe.err }, c)
  );
}
function Va({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: s, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [pe.opt, r ? pe.dis : "", o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: pe.check,
      checked: e,
      disabled: r,
      ref: (l) => {
        l && (l.indeterminate = t && !e);
      },
      onChange: (l) => a(l.target.checked)
    }
  ), s !== void 0 && /* @__PURE__ */ n.createElement("span", { className: pe.text }, s));
}
function m0({ legend: e, options: t, value: a, onChange: r, required: s, disabled: o, error: l, inline: c = !1, selectAll: i, className: m = "" }) {
  const u = Gt("axe-cg-err"), f = t.filter((d) => !d.disabled).map((d) => d.value), p = f.length > 0 && f.every((d) => a.includes(d)), _ = f.some((d) => a.includes(d)), y = (d, b) => r(b ? [...a, d] : a.filter((N) => N !== d));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [pe.group, m].filter(Boolean).join(" "),
      disabled: o,
      "aria-describedby": l ? u : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Lr, { legend: e, required: s }),
    i && /* @__PURE__ */ n.createElement("div", { className: pe.all }, /* @__PURE__ */ n.createElement(
      Va,
      {
        checked: p,
        indeterminate: _ && !p,
        onChange: (d) => r(d ? Array.from(/* @__PURE__ */ new Set([...a, ...f])) : a.filter((b) => !f.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [pe.opts, c ? pe.inline : ""].filter(Boolean).join(" ") }, t.map((d) => /* @__PURE__ */ n.createElement(Va, { key: d.value, checked: a.includes(d.value), disabled: d.disabled, onChange: (b) => y(d.value, b) }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: pe.hint }, d.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: u, className: pe.err }, l)
  );
}
const aE = "_list_13vw7_1", rE = "_tag_13vw7_2", sE = "_main_13vw7_3", oE = "_x_13vw7_6", lE = "_t_muted_13vw7_10", cE = "_t_accent_13vw7_11", iE = "_t_ok_13vw7_12", uE = "_t_warn_13vw7_13", mE = "_t_danger_13vw7_14", dE = "_sel_13vw7_16", At = {
  list: aE,
  tag: rE,
  main: sE,
  x: oE,
  t_muted: lE,
  t_accent: cE,
  t_ok: iE,
  t_warn: uE,
  t_danger: mE,
  sel: dE
};
function d0({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: s, removeLabel: o, disabled: l, className: c = "" }) {
  const i = [At.tag, At[`t_${t}`], a ? At.sel : "", c].filter(Boolean).join(" "), m = o != null ? o : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: At.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: At.main }, e), s && /* @__PURE__ */ n.createElement("button", { type: "button", className: At.x, onClick: s, disabled: l, "aria-label": m }, "✕"));
}
function f0({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [At.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, s) => /* @__PURE__ */ n.createElement("li", { key: s }, r)));
}
const fE = "_acc_1lmty_1", _E = "_item_1lmty_2", pE = "_h_1lmty_3", yE = "_btn_1lmty_4", bE = "_title_1lmty_8", hE = "_meta_1lmty_9", EE = "_chev_1lmty_10", gE = "_open_1lmty_11", vE = "_body_1lmty_12", lt = {
  acc: fE,
  item: _E,
  h: pE,
  btn: yE,
  title: bE,
  meta: hE,
  chev: EE,
  open: gE,
  body: vE
};
function _0({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: s, headingLevel: o = 3, className: l = "" }) {
  const [c, i] = M(a), m = r != null ? r : c, u = Gt("axe-acc"), f = `h${o}`, p = (_) => {
    const y = m.includes(_) ? m.filter((d) => d !== _) : t ? [_] : [...m, _];
    r === void 0 && i(y), s == null || s(y);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [lt.acc, l].filter(Boolean).join(" ") }, e.map((_) => {
    const y = m.includes(_.key), d = `${u}-b-${_.key}`, b = `${u}-p-${_.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: _.key, className: [lt.item, y ? lt.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(f, { className: lt.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: d,
        className: lt.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: _.disabled,
        onClick: () => p(_.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: lt.title }, _.title),
      _.meta && /* @__PURE__ */ n.createElement("span", { className: lt.meta }, _.meta),
      /* @__PURE__ */ n.createElement("span", { className: lt.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": d, hidden: !y, className: lt.body }, _.content));
  }));
}
const kE = "_stack_1u83j_2", wE = "_toast_1u83j_3", NE = "_t_danger_1u83j_9", $E = "_ico_1u83j_10", xE = "_t_ok_1u83j_11", DE = "_msg_1u83j_12", AE = "_act_1u83j_13", CE = "_x_1u83j_15", Ct = {
  stack: kE,
  toast: wE,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: NE,
  ico: $E,
  t_ok: xE,
  msg: DE,
  act: AE,
  x: CE
}, jr = An(null);
let SE = 0;
function p0() {
  const e = Dn(jr);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function ME({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = M(!1), s = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  Z(() => {
    if (a || s === 0) return;
    const i = window.setTimeout(t, s);
    return () => window.clearTimeout(i);
  }, [a, s, t, e.message]);
  const o = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Ct.toast, Ct[`t_${o}`]].join(" "),
      role: o === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: Ct.ico, "aria-hidden": "true" }, o === "ok" ? "✓" : o === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: Ct.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ct.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: Ct.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function y0({ children: e }) {
  const [t, a] = M([]), r = j(t);
  r.current = t;
  const s = le((c) => a((i) => i.filter((m) => m.id !== c)), []), o = le((c) => {
    const i = typeof c == "string" ? { message: c } : c, m = r.current.find((f) => f.message === i.message);
    if (m)
      return a((f) => f.map((p) => p.id === m.id ? { ...p, ...i } : p)), m.id;
    const u = ++SE;
    return a((f) => [...f, { ...i, id: u }].slice(-3)), u;
  }, []), l = we(() => ({ toast: o, dismiss: s }), [o, s]);
  return /* @__PURE__ */ n.createElement(jr.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: Ct.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(ME, { key: c.id, item: c, onClose: () => s(c.id) }))));
}
const TE = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function qE(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const BE = "_grid_yplhe_1", LE = "_group_yplhe_2", jE = "_h_yplhe_3", RE = "_list_yplhe_4", IE = "_row_yplhe_5", OE = "_keys_yplhe_6", PE = "_text_yplhe_7", XE = "_or_yplhe_8", zE = "_kbd_yplhe_9", ct = {
  grid: BE,
  group: LE,
  h: jE,
  list: RE,
  row: IE,
  keys: OE,
  text: PE,
  or: XE,
  kbd: zE
};
function FE({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...TE];
  return /* @__PURE__ */ n.createElement(da, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: ct.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: ct.group }, /* @__PURE__ */ n.createElement("h3", { className: ct.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: ct.list }, r.items.map((s, o) => /* @__PURE__ */ n.createElement("div", { key: o, className: ct.row }, /* @__PURE__ */ n.createElement("dt", { className: ct.keys }, s.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: ct.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: ct.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: ct.text }, s.text))))))));
}
function WE(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function b0(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, s] = M(!1);
  return Z(() => {
    if (!t) return;
    const o = (l) => {
      qE(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, WE(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), s(!0)));
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [t]), { open: () => s(!0), dialog: r ? /* @__PURE__ */ n.createElement(FE, { extra: a, onClose: () => s(!1) }) : null };
}
const Qa = 30, HE = BigInt(10);
function Ut(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * HE;
  return t;
}
function mt(e, t = 0) {
  return { u: e, s: t };
}
const Rr = mt(BigInt(0));
function Ir(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Ut(a - e.s), t.u * Ut(a - t.s), a];
}
function dn(e, t) {
  const [a, r, s] = Ir(e, t);
  return mt(a + r, s);
}
function fa(e, t) {
  const [a, r, s] = Ir(e, t);
  return mt(a - r, s);
}
function et(e, t) {
  return mt(e.u * t.u, e.s + t.s);
}
function Bt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Ut(t.s + Qa), r = t.u * Ut(e.s);
  return mt(a / r, Qa);
}
function Or(e) {
  return mt(-e.u, e.s);
}
function dt(e, t, a) {
  if (t >= e.s)
    return mt(e.u * Ut(t - e.s), t);
  const r = Ut(e.s - t), s = e.u < BigInt(0), o = s ? -e.u : e.u, l = o / r, c = o % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, mt(s ? -i : i, t);
}
function he(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s) + r.slice(s + 1), l = s < 0 ? 0 : r.length - s - 1, c = BigInt(o === "" ? "0" : o);
  return mt(a ? -c : c, l);
}
function _a(e) {
  var a;
  const t = he(String(e));
  return t || ((a = he(e.toFixed(20))) != null ? a : Rr);
}
function Ke(e, t = e.s, a = !1) {
  const r = dt(e, Math.max(t, 0), "half"), s = r.u < BigInt(0), o = (s ? -r.u : r.u).toString().padStart(t + 1, "0"), l = o.length - t;
  let c = o.slice(0, l);
  const i = o.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (s ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function ta(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), s = Number(t[3]);
  return r < 1 || r > 12 || s < 1 || s > Le(a, r) ? null : { y: a, m: r, d: s };
}
function zt({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), s = e + 4800 - r, o = t + 12 * r - 3;
  return a + Math.floor((153 * o + 2) / 5) + 365 * s + Math.floor(s / 4) - Math.floor(s / 100) + Math.floor(s / 400) - 32045;
}
function Pr(e, t) {
  const a = zt(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), s = a - Math.floor(146097 * r / 4), o = Math.floor((4 * s + 3) / 1461), l = s - Math.floor(1461 * o / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + o - 4800 + Math.floor(c / 10)
  };
}
function Xr(e, t, a = "exclude-first") {
  const r = zt(e) > zt(t), s = r ? t : e, o = r ? e : t, l = a === "include-first", c = zt(o) - zt(s) + (l ? 1 : 0), i = l ? Pr(o, 1) : o;
  let m = i.y - s.y, u = i.m - s.m, f = i.d - s.d;
  if (f < 0) {
    u -= 1;
    const p = i.m === 1 ? 12 : i.m - 1, _ = i.m === 1 ? i.y - 1 : i.y;
    f += Le(_, p);
  }
  return u < 0 && (m -= 1, u += 12), { days: c, y: m, m: u, d: f, swapped: r };
}
function xn(e, t) {
  return Pr(e, t);
}
function Ja(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), s = a % 12 + 1;
  return { y: r, m: s, d: Math.min(e.d, Le(r, s)) };
}
const KE = ["월", "화", "수", "목", "금", "토", "일"];
function na(e) {
  return KE[zt(e) % 7];
}
function ze(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const nn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], Kn = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function Za(e) {
  var t;
  return (t = Kn[e]) != null ? t : e in Kn ? Kn[e] : null;
}
function aa(e, t) {
  return e.find((a) => a.code === t);
}
function zr(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function Fr(e, t, a, r) {
  const s = aa(e, a), o = aa(e, r);
  if (!s || !o) return null;
  const l = he(s.krw), c = he(o.krw), i = he(String(s.per)), m = he(String(o.per));
  if (!l || !c || !i || !m) return null;
  const u = Bt(et(t, l), i);
  if (!u) return null;
  const f = Bt(et(u, m), c);
  return f ? {
    value: dt(f, 2, "half"),
    notice: `${zr(s)} · 참고용 환율`
  } : null;
}
function UE(e, t) {
  let a = null;
  for (const s of e)
    if (s.value) {
      if (a === null) {
        a = s.sign === "-" ? Or(s.value) : s.value;
        continue;
      }
      switch (s.sign) {
        case "+":
          a = dn(a, s.value);
          break;
        case "-":
          a = fa(a, s.value);
          break;
        case "*":
          a = et(a, s.value);
          break;
        default: {
          const o = Bt(a, s.value);
          if (!o) return { ok: !1, error: "divide-by-zero" };
          a = o;
          break;
        }
      }
    }
  const r = a != null ? a : Rr;
  return { ok: !0, value: t ? dt(r, t.digits, t.mode) : r };
}
const er = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function sn() {
  return { sign: "+", text: "" };
}
function YE(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), s = r.indexOf("."), o = s < 0 ? r : r.slice(0, s), l = s < 0 ? "" : "." + r.slice(s + 1).replace(/\./g, "");
  return (a ? "-" : "") + o.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function GE(e) {
  return e.map((t) => ({ sign: t.sign, value: he(t.text) }));
}
function VE(e) {
  const { lines: t, onLines: a, active: r, onActive: s, digits: o, onDigits: l, mode: c, onMode: i } = e, m = j([]), u = Math.min(r, t.length - 1);
  Z(() => {
    var k;
    (k = m.current[u]) == null || k.focus();
  }, [u, t.length]);
  const f = UE(GE(t), { digits: o, mode: c }), p = f.ok ? Ke(f.value, o, !0) : "0으로 나눌 수 없음", _ = (k, x) => {
    a(t.map((g, h) => h === k ? { ...g, ...x } : g));
  }, y = (k = t.length, x = "") => {
    const g = [...t];
    g.splice(k, 0, { ...sn(), text: x }), a(g), s(k);
  }, d = (k) => {
    if (t.length === 1) {
      a([sn()]);
      return;
    }
    a(t.filter((x, g) => g !== k)), s(Math.max(0, k - 1));
  }, b = () => {
    f.ok && y(t.length, Ke(f.value, o, !0));
  }, N = (k, x) => {
    const g = k.key, h = QE(g);
    if (h && !(g === "-" && t[x].text === "")) {
      k.preventDefault(), _(x, { sign: h });
      return;
    }
    if (g === "v" || g === "V") {
      k.preventDefault(), b();
      return;
    }
    g === "Enter" ? (k.preventDefault(), x === t.length - 1 ? y() : s(x + 1)) : g === "ArrowDown" ? (k.preventDefault(), s(Math.min(x + 1, t.length - 1))) : g === "ArrowUp" ? (k.preventDefault(), s(Math.max(x - 1, 0))) : g === "Insert" ? (k.preventDefault(), y(x + 1)) : g === "Delete" && t[x].text === "" ? (k.preventDefault(), d(x)) : g === "F4" && (k.preventDefault(), w());
  }, w = () => {
    a([sn()]), s(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => y(u + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => d(u) }, "라인삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: w }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, er.map((k) => {
    var x;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: k.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((x = t[u]) == null ? void 0 : x.sign) === k.key,
        onClick: () => _(u, { sign: k.key })
      },
      k.label,
      " (",
      k.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: o, onChange: (k) => l(Number(k.target.value)) }, [0, 1, 2, 3, 4].map((k) => /* @__PURE__ */ n.createElement("option", { key: k, value: k }, k))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (k) => i(k.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((k, x) => {
    var g;
    return /* @__PURE__ */ n.createElement("div", { key: x, className: `bical-line${x === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, x === u ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (g = er.find((h) => h.key === k.sign)) == null ? void 0 : g.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (h) => {
          m.current[x] = h;
        },
        value: k.text,
        inputMode: "decimal",
        "aria-label": `${x + 1}번째 금액`,
        onFocus: () => s(x),
        onChange: (h) => _(x, { text: YE(h.target.value) }),
        onKeyDown: (h) => N(h, x)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${f.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, p))));
}
function QE(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function JE(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let s = a;
      for (; s < e.length && (e[s] >= "0" && e[s] <= "9" || e[s] === "." || e[s] === ","); ) s += 1;
      const o = he(e.slice(a, s));
      if (!o) return null;
      t.push({ t: "num", v: o }), a = s;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class ZE {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? dn(t.value, r.value) : fa(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: et(t.value, r.value) };
      else {
        const s = Bt(t.value, r.value);
        if (!s) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: s };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? Or(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function eg(e) {
  const t = JE(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new ZE(t).parse();
}
const on = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], tg = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function ng(e, t) {
  return e.replace(/오늘/g, ze(t)).replace(/내일/g, ze(xn(t, 1))).replace(/어제/g, ze(xn(t, -1)));
}
function ag(e) {
  const t = [];
  for (const a of e.matchAll(tg)) {
    const r = ta(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const rg = /부터|까지|에서|일수|며칠|기간|차이|~/;
function sg(e, t) {
  if (t.length < 2 || !rg.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = Xr(t[0], t[1], a ? "include-first" : "exclude-first"), s = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${ze(t[0])} ~ ${ze(t[1])} 기간(${s})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const og = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function lg(e, t) {
  if (t.length !== 1) return null;
  const a = og.exec(e);
  if (!a) return null;
  const r = Number(a[1]), s = a[3] === "전" || a[3] === "이전", o = s ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = xn(l, o) : a[2] === "주" ? c = xn(l, o * 7) : a[2] === "년" ? c = Ja(l, o * 12) : c = Ja(l, o), {
    ok: !0,
    explain: `${ze(l)} 에서 ${r}${a[2]} ${s ? "전" : "후"}`,
    value: `${ze(c)} (${na(c)})`
  };
}
function cg(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? Wr(a[2]) : null, s = he(a[1]);
  if (!s) return null;
  const o = r ? et(s, r) : s, l = Za(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : Za(ig(e));
  if (!i || i === l) return null;
  const m = Fr(t, o, l, i);
  return m ? {
    ok: !0,
    explain: `${Ke(o, o.s, !0)} ${l} → ${i} · ${m.notice}`,
    value: `${Ke(m.value, 2, !0)} ${i}`
  } : null;
}
function ig(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const ug = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function Wr(e) {
  var t;
  return (t = he(ug[e])) != null ? t : _a(1);
}
const mg = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, dg = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function fg(e) {
  return e.replace(mg, (t) => {
    let a = he("0"), r = !1;
    for (const s of t.matchAll(dg)) {
      const o = he(s[1]);
      o && (r = !0, a = dn(a, s[2] ? et(o, Wr(s[2])) : o));
    }
    return r ? Ke(a, a.s) : t;
  });
}
const _g = /원화|원|엔|씩|개월|개|명|건/g;
function pg(e) {
  return fg(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(_g, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const yg = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function bg(e, t, a) {
  const r = he("1"), s = Ke(et(t, _a(100)), 0);
  if (a === "add")
    return {
      value: dt(et(e, dn(r, t)), 0, "half"),
      explain: `消費税 ${s}% 가산(税抜 기준)`
    };
  const o = Bt(et(e, t), dn(r, t));
  return {
    value: o ? dt(o, 0, "down") : e,
    explain: `消費税 ${s}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function hg(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: on };
  const r = ng(a, t.today), s = ag(r), o = sg(r, s);
  if (o) return o;
  const l = lg(r, s);
  if (l) return l;
  const c = cg(r, (i = t.rates) != null ? i : []);
  return c || Eg(r, t);
}
function Eg(e, t) {
  var m, u;
  const a = yg.exec(e), r = a ? e.slice(0, a.index) : e, s = pg(r);
  if (!s) return { ok: !1, supported: on };
  const o = eg(s);
  if (!o.ok)
    return { ok: !1, supported: on };
  if (!a)
    return { ok: !0, explain: s, value: tr(o.value), expr: s };
  const l = (u = (m = gg(a[2])) != null ? m : t.taxRate) != null ? u : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...on]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = bg(o.value, l, c);
  return {
    ok: !0,
    explain: `${s} · ${i.explain}`,
    value: tr(i.value),
    expr: s
  };
}
function gg(e) {
  var a;
  if (!e) return null;
  const t = he(e);
  return t && (a = Bt(t, _a(100))) != null ? a : null;
}
function tr(e) {
  const t = dt(e, 2, "half"), a = dt(t, 0, "down");
  return fa(t, a).u === BigInt(0) ? Ke(t, 0, !0) : Ke(t, 2, !0);
}
const He = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function nr(e, t) {
  const a = He[e].units.find((s) => s.key === t);
  if (!a) return null;
  const r = he(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function vg(e, t, a, r, s = 4, o = "half") {
  const l = nr(e, t), c = nr(e, a);
  if (!l || !c) return null;
  const i = Bt(et(r, l), c);
  return i ? dt(i, s, o) : null;
}
const kg = [0, 1, 2, 3, 4, 6], wg = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Ng(e) {
  const { tab: t, onTab: a, seed: r, onClose: s, history: o, onHistory: l } = e, [c, i] = M(() => r == null ? [sn()] : [{ sign: "+", text: Ke(Mg(r), 0, !0) }]), [m, u] = M(0), [f, p] = M(0), [_, y] = M("half"), d = j(null);
  Z(() => {
    const N = (w) => {
      w.key === "Escape" && (w.preventDefault(), s());
    };
    return document.addEventListener("keydown", N), () => document.removeEventListener("keydown", N);
  }, [s]), Z(() => {
    var N, w;
    (w = (N = d.current) == null ? void 0 : N.querySelector("[data-autofocus]")) == null || w.focus();
  }, [t]);
  const b = (N) => {
    const w = [...c.filter((k) => k.text !== ""), { sign: "+", text: N }, sn()];
    i(w), u(w.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: d }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: s }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, wg.map((N) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: N.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": N.key === t,
      onClick: () => a(N.key)
    },
    N.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(Dg, { history: o, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    VE,
    {
      lines: c,
      onLines: i,
      active: m,
      onActive: u,
      digits: f,
      onDigits: p,
      mode: _,
      onMode: y
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(Ag, null), t === "unit" && /* @__PURE__ */ n.createElement(Cg, null), t === "fx" && /* @__PURE__ */ n.createElement(Sg, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: s }, "닫기"))));
}
const $g = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], xg = 20;
function Dg({ history: e, onHistory: t, onPush: a }) {
  var y;
  const [r, s] = M(""), [o, l] = M(null), [c, i] = M(!1), [m, u] = M(!1), f = j(!1), p = we(pa, []), _ = (d) => {
    s(d), u(!1);
    const b = hg(d, { today: p, rates: nn, taxRate: null });
    l(b), d.trim() && t([d, ...e.filter((N) => N !== d)].slice(0, xg));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (d) => s(d.target.value),
      onCompositionStart: () => {
        f.current = !0;
      },
      onCompositionEnd: () => {
        f.current = !1;
      },
      onKeyDown: (d) => {
        d.key === "Enter" && !d.shiftKey && !f.current && !d.nativeEvent.isComposing && (d.preventDefault(), _(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, $g.map((d) => /* @__PURE__ */ n.createElement("button", { key: d, type: "button", className: "bical-chip", onClick: () => _(d) }, d))), o && (o.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, o.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, o.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var d;
        (d = navigator.clipboard) == null || d.writeText(o.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    m ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(o.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = o.supported) != null ? y : on).map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, d))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((d) => !d) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => _(d) }, d))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function Ag() {
  const e = we(pa, []), [t, a] = M(ze(e)), [r, s] = M(ze(e)), [o, l] = M("exclude-first"), c = ta(t), i = ta(r), m = c && i ? Xr(c, i, o) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: o, onChange: (u) => l(u.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (u) => s(u.target.value) })), m ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, ze(c), "(", na(c), ") ~ ", ze(i), "(", na(i), ")", m.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", m.y, "년 ", m.m, "개월 ", m.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function Cg() {
  const [e, t] = M("area"), [a, r] = M(He.area.units[0].key), [s, o] = M(He.area.units[4].key), [l, c] = M(""), [i, m] = M(4), [u, f] = M("half"), p = (d) => {
    t(d), r(He[d].units[0].key), o(He[d].units[1].key), c("");
  }, _ = he(l), y = _ ? vg(e, a, s, _, i, u) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (d) => p(d.target.value) }, Object.keys(He).map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, He[d].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", He[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (d) => c(d.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (d) => r(d.target.value) }, He[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: s, onChange: (d) => o(d.target.value) }, He[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (d) => m(Number(d.target.value)) }, kg.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: u, onChange: (d) => f(d.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, ar(e, a), " → ", ar(e, s), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y ? Ke(y, i, !0) : "—")));
}
function ar(e, t) {
  var a, r;
  return (r = (a = He[e].units.find((s) => s.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function Sg() {
  const e = we(pa, []), [t, a] = M(ze(e)), [r, s] = M("JPY"), [o, l] = M("KRW"), [c, i] = M(""), m = he(c), u = m ? Fr(nn, m, r, o) : null, f = aa(nn, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (p) => a(p.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (p) => i(p.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (p) => s(p.target.value) }, nn.map((p) => /* @__PURE__ */ n.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: o, onChange: (p) => l(p.target.value) }, nn.map((p) => /* @__PURE__ */ n.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, f ? zr(f) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u ? Ke(u.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function pa() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function Mg(e) {
  var t;
  return dt((t = he(String(e))) != null ? t : he("0"), 0, "half");
}
const Hr = An(null);
function h0({ children: e }) {
  const [t, a] = M(!1), [r, s] = M("text"), [o, l] = M(null), [c, i] = M([]), [m, u] = M(0), f = we(() => ({
    open: (p) => {
      var _, y;
      s((_ = p == null ? void 0 : p.tab) != null ? _ : "text"), l((y = p == null ? void 0 : p.seed) != null ? y : null), u((d) => d + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(Hr.Provider, { value: f }, e, t && /* @__PURE__ */ n.createElement(
    Ng,
    {
      key: m,
      tab: r,
      onTab: s,
      seed: o,
      onClose: f.close,
      history: c,
      onHistory: i
    }
  ));
}
function E0() {
  var e;
  return (e = Dn(Hr)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class g0 extends rr {
  constructor() {
    super(...arguments), this.rootRef = Yr(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new ir(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  Hv as $,
  _0 as A,
  Vg as B,
  Ng as C,
  tv as D,
  Yg as E,
  gn as F,
  Yn as G,
  n0 as H,
  Ov as I,
  Pv as J,
  sa as K,
  l0 as L,
  Kv as M,
  Yv as N,
  Gv as O,
  hv as P,
  da as Q,
  Ev as R,
  cf as S,
  wv as T,
  Uv as U,
  Bg as V,
  Lg as W,
  o0 as X,
  Ug as Y,
  e0 as Z,
  Fv as _,
  Xs as a,
  Ps as a$,
  jp as a0,
  Wv as a1,
  o_ as a2,
  Xv as a3,
  u0 as a4,
  Sv as a5,
  Kg as a6,
  Og as a7,
  Hg as a8,
  e_ as a9,
  Qv as aA,
  Vv as aB,
  $r as aC,
  uf as aD,
  TE as aE,
  gr as aF,
  Yt as aG,
  g0 as aH,
  ir as aI,
  Cr as aJ,
  Wd as aK,
  Fn as aL,
  mr as aM,
  gv as aN,
  Ru as aO,
  c_ as aP,
  Vn as aQ,
  Kc as aR,
  Uc as aS,
  fr as aT,
  jv as aU,
  S_ as aV,
  el as aW,
  Dv as aX,
  qE as aY,
  rl as aZ,
  U_ as a_,
  FE as aa,
  Pg as ab,
  zg as ac,
  Xg as ad,
  iv as ae,
  lv as af,
  ov as ag,
  i0 as ah,
  Fg as ai,
  Iv as aj,
  Nv as ak,
  c0 as al,
  cv as am,
  Wg as an,
  cr as ao,
  d0 as ap,
  f0 as aq,
  Zf as ar,
  jg as as,
  y0 as at,
  Mv as au,
  Lt as av,
  rv as aw,
  kv as ax,
  Qg as ay,
  br as az,
  vv as b,
  Rg as b0,
  al as b1,
  ur as b2,
  s0 as b3,
  mh as b4,
  dh as b5,
  $n as b6,
  Ot as b7,
  a_ as b8,
  Zt as b9,
  ev as bA,
  lc as bB,
  ma as bC,
  Er as bD,
  qv as bE,
  E0 as bF,
  xv as bG,
  mf as bH,
  Tv as bI,
  $v as bJ,
  zv as bK,
  sv as bL,
  b0 as bM,
  Ig as bN,
  p0 as bO,
  av as bP,
  Gt as bQ,
  iy as bR,
  Mr as ba,
  r_ as bb,
  ja as bc,
  _v as bd,
  fc as be,
  nv as bf,
  i_ as bg,
  Tr as bh,
  j_ as bi,
  nl as bj,
  dr as bk,
  tl as bl,
  zs as bm,
  q_ as bn,
  r0 as bo,
  eb as bp,
  Ft as bq,
  qr as br,
  vr as bs,
  yv as bt,
  Au as bu,
  Fd as bv,
  fv as bw,
  Zg as bx,
  Jg as by,
  nc as bz,
  Jv as c,
  Wt as d,
  h0 as e,
  bv as f,
  yr as g,
  m0 as h,
  a0 as i,
  Va as j,
  dv as k,
  mv as l,
  uv as m,
  Rv as n,
  Da as o,
  pv as p,
  Zv as q,
  Sr as r,
  Zo as s,
  Lv as t,
  Bv as u,
  Av as v,
  Cv as w,
  t0 as x,
  Gg as y,
  Js as z
};
